import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Table,
  Badge,
  Button,
  Progress,
  Modal,
  ModalHeader,
  ModalBody,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  TabContent,
  TabPane,
  Pagination,
  PaginationItem,
  PaginationLink,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  CardFooter,
  ModalFooter,
  Spinner,
} from "reactstrap";
import CommonHeader from "components/Headers/CommonHeader.js";
import {
  getChallenges,
  createChallenge,
  updateChallengeStatus,
  getChallengeSubmissions,
  judgeSubmission,
  rewardSubmission,
  getAllJudges,
  getChallengeJoinRequests,
  updateJoinRequestStatus,
  getSubmissionListById,
  submitJudgeScores,
  getCategories,
  getChangeRequests,
  handleRequest,
  getInnovationBoards,
  getReferralEvents,
  getCreatorChannels,
  getdashboardstate,
  IMAGE_BASE_URL,
  getUserMemberships,
  getGiftConfig,
  updateGiftConfig,
  toggleGiftConfigStatus,
  getAllPackagesAPI,
  createPackageAPI,
  updatePackageAPI,
  deletePackageAPI,
} from "api/ApiServices";
import Swal from "sweetalert2";
import Avatar from "../../components/Common/Avatar.js";

/* ═══════════════════════════════════════════════════
   INLINE STYLES – Premium Glassmorphism & Modern UI
   ═══════════════════════════════════════════════════ */
const styles = {
  statCard: {
    background: "linear-gradient(135deg, #ffffff 0%, #f8f9fe 100%)",
    borderRadius: "16px",
    border: "1px solid rgba(0,0,0,0.04)",
    boxShadow: "0 4px 15px rgba(0,0,0,0.03)",
    height: "100%",
    padding: "24px",
    position: "relative",
    overflow: "hidden",
  },
  statIconBox: {
    width: "48px",
    height: "48px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px",
    color: "#fff",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    marginBottom: "16px",
  },
  tableRow: {
    transition: "all 0.15s ease",
    position: "relative",
  },
  avatar: {
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    fontSize: "14px",
    color: "#fff",
    flexShrink: 0,
  },
  filterBar: {
    background: "linear-gradient(135deg, #f8f9fe 0%, #eef1f8 100%)",
    borderRadius: "12px",
    padding: "20px 24px",
    margin: "0 0 24px 0",
    border: "1px solid rgba(0,0,0,0.04)",
    display: "flex",
    gap: "10px",
    overflowX: "auto",
  },
  filterPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    background: "#fff",
    borderRadius: "10px",
    padding: "10px 18px",
    border: "1px solid #e2e8f0",
    fontSize: "14px",
    fontWeight: 600,
    color: "#525f7f",
    cursor: "pointer",
    transition: "all 0.2s ease",
    boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
  },
  filterPillActive: {
    background: "linear-gradient(135deg, #11cdef 0%, #1171ef 100%)",
    color: "#fff",
    border: "1px solid transparent",
    boxShadow: "0 4px 12px rgba(17,205,239,0.3)",
  },
  tag: {
    background: "#eef1f8",
    color: "#32325d",
    padding: "4px 8px",
    borderRadius: "6px",
    fontSize: "11px",
    marginRight: "6px",
    fontWeight: 600,
    display: "inline-block",
  },
  modalDataBlock: {
    background: "#fff",
    borderRadius: "8px",
    padding: "16px",
    border: "1px solid #e9ecef",
    marginBottom: "16px",
  },
  judgeChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
    background: "linear-gradient(135deg, #5e72e4, #825ee4)",
    color: "#fff",
    borderRadius: "20px",
    padding: "4px 12px",
    fontSize: "12px",
    fontWeight: 600,
    margin: "4px",
  },
  criteriaCard: {
    background: "#f8f9fe",
    borderRadius: "8px",
    padding: "12px",
    marginBottom: "8px",
    border: "1px solid #e9ecef",
  },
};

/* ═══════════════════════════════════════
   MOCK DATA
   ═══════════════════════════════════════ */
const DUMMY_IDEAS = [
  {
    id: "ID-101",
    title: "Solar Micro-Grids for Rural Areas",
    author: "Eko_Tech",
    category: "Cleantech",
    upvotes: 450,
    investments: 12500,
    status: "Under Review",
    comments: 34,
    description:
      "A proposal to fund peer-to-peer solar energy trading networks.",
  },
  {
    id: "ID-102",
    title: "AI-Powered Agri-Advisor App",
    author: "FarmAI",
    category: "AgriTech",
    upvotes: 890,
    investments: 45000,
    status: "Approved",
    comments: 120,
    description:
      "Mobile platform using computer vision to diagnose crop diseases.",
  },
  {
    id: "ID-103",
    title: "Blockchain Land Registry",
    author: "CryptoNail",
    category: "GovTech",
    upvotes: 120,
    investments: 500,
    status: "Rejected",
    comments: 12,
    description: "Tokenizing land deeds to prevent fraudulent transactions.",
  },
];

const DUMMY_CREATORS = [
  {
    id: "CR-903",
    channel: "Crypto Signals",
    owner: "MoonBoy99",
    subscribers: "3.1k",
    content: "Finance",
    verified: false,
    activeSessions: 0,
  },
];


const DUMMY_REFERRALS = [
  {
    id: "REF-001",
    referrer: "Alex_Dev",
    referredUser: "Sam_Newbie",
    points: 500,
    credits: "$50",
    bonus: "Yes",
    status: "Active",
  },
  {
    id: "REF-002",
    referrer: "CryptoNail",
    referredUser: "Jane_Doe",
    points: 250,
    credits: "$25",
    bonus: "No",
    status: "Active",
  },
  {
    id: "REF-003",
    referrer: "Eko_Tech",
    referredUser: "Mike_Smith",
    points: 0,
    credits: "$0",
    bonus: "Revoked",
    status: "Suspended",
  },
];

const DUMMY_CHANGE_REQUESTS = [
  {
    id: "REQ-001",
    ideaTitle: "Solar Micro-Grids for Rural Areas",
    requestedTitle: "Smart Solar Grids for Villages",
    requestedContent:
      "An improved proposal for peer-to-peer solar energy trading with IoT integration.",
    requestedInvestment: 15000,
    user: "Eko_Tech",
    status: "pending",
  },
  {
    id: "REQ-002",
    ideaTitle: "AI-Powered Agri-Advisor App",
    requestedTitle: "AI-Powered Agri-Advisor Pro",
    requestedContent:
      "Mobile platform using advanced deep learning to diagnose crop diseases and suggest treatments.",
    requestedInvestment: 50000,
    user: "FarmAI",
    status: "pending",
  },
];

const cancellationReasons = {
  too_expensive: "Membership is too expensive",
  not_using_enough: "Not using the service enough",
  missing_features: "Missing features I need",
  found_alternative: "Found a better alternative",
  technical_issues: "Technical issues",
  temporary: "Temporary cancellation",
  other: "Other",
  upgraded: "Upgraded",
};

/* ═══════════════════════════════════════
   HELPER COMPONENT
   ═══════════════════════════════════════ */
const ReadMoreDescription = ({ text, maxLength = 80 }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  if (!text || text === "—") return <span>{text || "—"}</span>;
  if (text.length <= maxLength) return <span>{text}</span>;
  return (
    <span>
      {isExpanded ? text : `${text.substring(0, maxLength)}...`}
      <span
        style={{
          color: "#5e72e4",
          cursor: "pointer",
          marginLeft: "5px",
          fontWeight: "600",
          fontSize: "11px",
        }}
        onClick={(e) => {
          e.stopPropagation();
          setIsExpanded(!isExpanded);
        }}
      >
        {isExpanded ? "Show Less" : "Read More"}
      </span>
    </span>
  );
};

/* ═══════════════════════════════════════
   MAIN COMPONENT
   ═══════════════════════════════════════ */
const Community = () => {
  console.log(
    "Community Component Rendered - Idea Change Requests Modal Ready",
  );
  const renderPaginationItems = (
    currentPage,
    totalItems,
    limit,
    onPageChange,
  ) => {
    const totalPagesCount = Math.ceil(totalItems / limit);
    if (totalPagesCount <= 1) return null;

    const pages = [];
    const delta = 2;

    pages.push(
      <PaginationItem key={1} active={currentPage === 1}>
        <PaginationLink
          href="#pablo"
          onClick={(e) => {
            e.preventDefault();
            onPageChange(1);
          }}
        >
          1
        </PaginationLink>
      </PaginationItem>,
    );

    if (currentPage > delta + 2) {
      pages.push(
        <PaginationItem key="start-ellipsis" disabled>
          <PaginationLink href="#pablo" onClick={(e) => e.preventDefault()}>
            ...
          </PaginationLink>
        </PaginationItem>,
      );
    }

    const rangeStart = Math.max(2, currentPage - delta);
    const rangeEnd = Math.min(totalPagesCount - 1, currentPage + delta);

    for (let i = rangeStart; i <= rangeEnd; i++) {
      pages.push(
        <PaginationItem key={i} active={currentPage === i}>
          <PaginationLink
            href="#pablo"
            onClick={(e) => {
              e.preventDefault();
              onPageChange(i);
            }}
          >
            {i}
          </PaginationLink>
        </PaginationItem>,
      );
    }

    if (currentPage < totalPagesCount - delta - 1) {
      pages.push(
        <PaginationItem key="end-ellipsis" disabled>
          <PaginationLink href="#pablo" onClick={(e) => e.preventDefault()}>
            ...
          </PaginationLink>
        </PaginationItem>,
      );
    }

    if (totalPagesCount > 1) {
      pages.push(
        <PaginationItem
          key={totalPagesCount}
          active={currentPage === totalPagesCount}
        >
          <PaginationLink
            href="#pablo"
            onClick={(e) => {
              e.preventDefault();
              onPageChange(totalPagesCount);
            }}
          >
            {totalPagesCount}
          </PaginationLink>
        </PaginationItem>,
      );
    }

    return pages;
  };

  const getUserImage = (user) => {
    if (!user) return null;

    const img = user?.image;

    // fallback avatar if no image
    if (!img) return null;

    // full URL case
    if (img.startsWith("http")) return img;

    // filename case (S3)
    return `https://cradleaibucket.s3.us-east-1.amazonaws.com/users-profile-images/${img}`;
  };

  const [changeRequests, setChangeRequests] = useState([]);
  const [changeRequestsLoading, setChangeRequestsLoading] = useState(false);
  const [changeRequestsPage, setChangeRequestsPage] = useState(1);
  const [changeRequestsTotal, setChangeRequestsTotal] = useState(0);
  const [changeRequestsLimit] = useState(10);
  const [userDetailsCache, setUserDetailsCache] = useState({});
  const [fetchingUsers, setFetchingUsers] = useState({});
  const [compareModalOpen, setCompareModalOpen] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);

  const [viewChangeRequestModal, setViewChangeRequestModal] = useState(false);
  const [selectedChangeRequest, setSelectedChangeRequest] = useState(null);

  const [activeTab, setActiveTab] = useState("Innovation Boards");

  // Challenges State
  const [challenges, setChallenges] = useState([]);
  const [challengesPage, setChallengesPage] = useState(1);
  const [challengesTotal, setChallengesTotal] = useState(0);
  const [challengesLimit] = useState(10);
  const [challengesSearch, setChallengesSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [judgesList, setJudgesList] = useState([]);
  const [selectedJudges, setSelectedJudges] = useState([]);
  const [judgesDropdownOpen, setJudgesDropdownOpen] = useState(false);
  const [showJudgesDetail, setShowJudgesDetail] = useState(false);

  // Join Requests State
  const [joinRequestsModalOpen, setJoinRequestsModalOpen] = useState(false);
  const [joinRequests, setJoinRequests] = useState([]);
  const [joinRequestsPage, setJoinRequestsPage] = useState(1);
  const [joinRequestsTotal, setJoinRequestsTotal] = useState(0);
  const [joinRequestsLimit] = useState(10);
  const [joinRequestsSearch, setJoinRequestsSearch] = useState("");
  const [joinRequestsStatus, setJoinRequestsStatus] = useState("");
  const [joinRequestsLoading, setJoinRequestsLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(null);

  // Other Community States (Mocks)
  const [ideas, setIdeas] = useState(DUMMY_IDEAS);
  const [creators, setCreators] = useState(DUMMY_CREATORS);
  const [referrals, setReferrals] = useState(DUMMY_REFERRALS);
  const [packages, setPackages] = useState([]);
  const [packagesLoading, setPackagesLoading] = useState(false);
  const [packagesSearch, setPackagesSearch] = useState("");

  // Modal States
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState(""); // "idea", "challenge", "creator", "createChallenge", "submissions"
  const [selectedItem, setSelectedItem] = useState(null);
  const [submissions, setSubmissions] = useState([]);
  const [referralAction, setReferralAction] = useState(null); // A

  const [allSubmissions, setAllSubmissions] = useState([]);
  const [submissionsPage, setSubmissionsPage] = useState(1);
  const [submissionsTotal, setSubmissionsTotal] = useState(0);
  const [submissionsLimit] = useState(10);
  const [submissionsSearch, setSubmissionsSearch] = useState("");
  const [submissionsStatus, setSubmissionsStatus] = useState("");
  const [submissionsLoading, setSubmissionsLoading] = useState(false);

  // modal states
  const [submissionsModalOpen, setSubmissionsModalOpen] = useState(false);
  const [selectedSubmission, setSelectedSubmission] = useState(null);

  const [changesModalOpen, setChangesModalOpen] = useState(false);

  // categories states
  const [categories, setCategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(false);
  const [categoriesError, setCategoriesError] = useState(null);
  const [selectedChallengeId, setSelectedChallengeId] = useState("");

  const [innovationBoards, setInnovationBoards] = useState([]);
  const [innovationBoardsLoading, setInnovationBoardsLoading] = useState(false);
  const [innovationBoardsPage, setInnovationBoardsPage] = useState(1);
  const [innovationBoardsTotal, setInnovationBoardsTotal] = useState(0);
  const [innovationBoardsLimit] = useState(10);
  const [innovationBoardsSearch, setInnovationBoardsSearch] = useState("");
  const [innovationBoardsStatus, setInnovationBoardsStatus] = useState("");

  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);

  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [fraud, setFraud] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedReferral, setSelectedReferral] = useState(null);

  const [pagination, setPagination] = useState({
    total: 0,
    page: 1,
    pages: 1,
  });

  const [scoreValues, setScoreValues] = useState({
    innovation: 5,
    feasibility: 5,
    impact: 5,
    presentation: 5,
  });

  const [channels, setChannels] = useState([]);
  const [channelsLoading, setChannelsLoading] = useState(false);
  const [channelsPage, setChannelsPage] = useState(1);
  const [channelsTotal, setChannelsTotal] = useState(0);
  const [channelsLimit] = useState(10);
  const [channelsSearch, setChannelsSearch] = useState("");
  const [channelsStatus, setChannelsStatus] = useState("");
  const [channelsPagination, setChannelsPagination] = useState({
    total: 0,
    page: 1,
    totalPages: 1,
  });
  const [memberships, setMemberships] = useState([]);
  const [membershipsLoading, setMembershipsLoading] = useState(false);
  const [membershipsPage, setMembershipsPage] = useState(1);
  const [membershipsTotal, setMembershipsTotal] = useState(0);
  const [membershipsLimit] = useState(10);
  const [membershipsByType, setMembershipsByType] = useState({});
  const [membershipsSearch, setMembershipsSearch] = useState("");
  const [membershipsStatus, setMembershipsStatus] = useState("");
  const [membershipsTier, setMembershipsTier] = useState("");
  const [giftConfig, setGiftConfig] = useState(null);
  const [giftConfigLoading, setGiftConfigLoading] = useState(false);
  const [giftConfigSaving, setGiftConfigSaving] = useState(false);

  const [channelDetailModalOpen, setChannelDetailModalOpen] = useState(false);
  const [selectedChannel, setSelectedChannel] = useState(null);

  const openChannelDetailModal = (channel) => {
    setSelectedChannel(channel);
    setChannelDetailModalOpen(true);
  };

  const handleViewChangeRequest = (changeRequest) => {
    setSelectedChangeRequest(changeRequest);
    setViewChangeRequestModal(true);
  };

  const [dashboardStats, setDashboardStats] = useState({
    totalFundedIdeas: 0,
    activeChallenges: 0,
    totalParticipants: 0,
    crossCountryBonuses: 0,
    totalReferralPoints: 0,
    totalFundingAmount: 0,
    totalIdeas: 0,
    fundedIdeasCount: 0,
    totalChallenges: 0,
    totalSubmissions: 0,
    completedChallenges: 0,
    totalCreators: 0,
    activeCreators: 0,
    totalReferrals: 0,
    totalBonusesPaid: 0,
  });
  const [statsLoading, setStatsLoading] = useState(false);

  const fetchChangeRequests = async () => {
    setChangeRequestsLoading(true);
    try {
      const response = await getChangeRequests(
        changeRequestsPage,
        changeRequestsLimit,
        "", // search - add if needed
        "", // status filter - add if needed
      );
      console.log("Change Requests API Response:", response);

      if (response.status) {
        setChangeRequests(response.payload?.requests || []);
        setChangeRequestsTotal(response.payload?.pagination?.total || 0);
      }
    } catch (error) {
      console.error("Error fetching change requests:", error);
      Swal.fire("Error", "Failed to load change requests", "error");
    } finally {
      setChangeRequestsLoading(false);
    }
  };

  // Add useEffect to fetch change requests when modal opens
  useEffect(() => {
    if (changesModalOpen) {
      fetchChangeRequests();
    }
  }, [changesModalOpen, changeRequestsPage]);

  // Update the handleChangeRequestAction function to work with real data (around line 500-520)
  const handleChangeRequestAction = async (requestId, status) => {
    // Prevent double submission
    if (changeRequestsLoading) return;

    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: `You are about to ${status} this idea change request. This action can't be undone!`,
        icon: status === "approved" ? "question" : "warning",
        showCancelButton: true,
        confirmButtonColor: status === "approved" ? "#2dce89" : "#f5365c",
        cancelButtonColor: "#8898aa",
        confirmButtonText: `Yes, ${status} it!`,
        cancelButtonText: "No, cancel",
        reverseButtons: true,
      });

      if (result.isConfirmed) {
        setChangeRequestsLoading(true);

        // Show loading toast
        Swal.fire({
          title: "Processing...",
          text: `Please wait while we ${status} the request`,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        // Call the API
        const response = await handleRequest(requestId, status);

        console.log("Full API Response:", response);

        // Check response status - handle different response structures
        const isSuccess =
          response?.status === true ||
          response?.success === true ||
          response?.data?.status === true ||
          (response && !response.error);

        if (isSuccess) {
          // Close loading Swal
          Swal.close();

          // Show success message
          await Swal.fire({
            title: "Success!",
            text: `The request has been ${status}ed successfully.`,
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          });

          // Refresh the change requests list
          await fetchChangeRequests();

          // Also refresh the modal data if selected request is open
          if (
            viewChangeRequestModal &&
            selectedChangeRequest?._id === requestId
          ) {
            setSelectedChangeRequest((prev) => ({
              ...prev,
              status: status,
              reviewed_at: new Date().toISOString(),
            }));
          }
        } else {
          // Handle error response
          const errorMessage =
            response?.message ||
            response?.error ||
            response?.data?.message ||
            "Failed to update request status";
          throw new Error(errorMessage);
        }
      }
    } catch (error) {
      console.error("Error updating request:", error);
      Swal.fire({
        title: "Error!",
        text:
          error.response?.data?.message ||
          error.message ||
          "Failed to update request status",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setChangeRequestsLoading(false);
    }
  };

  const refreshChangeRequests = async () => {
    await fetchChangeRequests();
  };

  // fetch categories
  const fetchCategories = async () => {
    try {
      setCategoriesLoading(true);
      const response = await getCategories();
      setCategories(response.data);
    } catch (error) {
      setCategoriesError(error);
    } finally {
      setCategoriesLoading(false);
    }
  };

  // fetch categories on mount
  useEffect(() => {
    fetchCategories();
  }, []);

  // Add this state in your component (around line 130-150)
  const [showScoreModal, setShowScoreModal] = useState(false);
  const [scoreData, setScoreData] = useState({
    score: 0,
    feedback: "",
    status: "approved",
  });
  const [scoreLoading, setScoreLoading] = useState(false);
  const [currentScoringSubmission, setCurrentScoringSubmission] =
    useState(null);

  // Function to submit score for individual submission
  // Function to submit score for individual submission
  const submitScore = async () => {
    console.log("submitScore called");

    if (!currentScoringSubmission) {
      Swal.fire("Error", "No submission selected", "error");
      return;
    }

    setScoreLoading(true);

    try {
      const totalScore =
        ((scoreValues.innovation || 0) +
          (scoreValues.feasibility || 0) +
          (scoreValues.impact || 0) +
          (scoreValues.presentation || 0)) /
        4;

      const finalScore = parseFloat(totalScore.toFixed(1));

      const payload = {
        submissionId: currentScoringSubmission._id,
        scores: {
          innovation: Number(scoreValues.innovation),
          feasibility: Number(scoreValues.feasibility),
          impact: Number(scoreValues.impact),
          presentation: Number(scoreValues.presentation),
          final: finalScore,
        },
        finalScore: finalScore,
        comments: scoreData.feedback || "",
        status: "reviewed",
      };

      console.log(
        "Final payload being sent:",
        JSON.stringify(payload, null, 2),
      );

      const response = await submitJudgeScores(payload);

      if (response && response.status) {
        Swal.fire({
          title: "Success!",
          text: `Score ${finalScore}/10 submitted successfully!`,
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });

        setShowScoreModal(false);
        // Reset score values
        setScoreValues({
          innovation: 5,
          feasibility: 5,
          impact: 5,
          presentation: 5,
        });
        setScoreData({ score: 0, feedback: "", status: "approved" });
        setCurrentScoringSubmission(null);

        // Refresh data
        await fetchAllSubmissions();
        if (selectedItem?.c_uuid) {
          await fetchSubmissionsData(selectedItem.c_uuid);
        }
        await fetchChallengesData();
      } else {
        throw new Error(response?.message || "Failed to submit score");
      }
    } catch (error) {
      console.error("Error submitting score:", error);
      Swal.fire(
        "Error",
        error.response?.data?.message ||
          error.message ||
          "Failed to submit score. Please try again.",
        "error",
      );
    } finally {
      setScoreLoading(false);
    }
  };

  const handleOpenJudgesModal = async (item) => {
    console.log("Opening judges modal for item:", item);

    const challengeId = item.c_uuid || item._id;

    if (!challengeId) {
      console.error("No challenge ID found in item:", item);
      Swal.fire("Error", "Invalid challenge ID", "error");
      return;
    }

    setSelectedSubmission(item);
    setSelectedChallengeId(challengeId);
    setSubmissionsModalOpen(true);

    // Reset pagination to page 1 when opening modal
    setSubmissionsPage(1);

    // Fetch submissions directly
    await fetchAllSubmissions(challengeId);
  };

  const handleCloseModal = () => {
    setSubmissionsModalOpen(false);
    setSelectedSubmission(null);
  };

  const fetchAllSubmissions = async (id) => {
    if (!id) return;

    setSubmissionsLoading(true);

    try {
      const response = await getSubmissionListById(
        id,
        submissionsPage,
        submissionsLimit,
      );

      console.log("API RESPONSE:", response);

      const submissions = response?.payload?.submissions || [];

      setAllSubmissions(submissions);
      setSubmissionsTotal(response?.payload?.pagination?.total || 0);
    } catch (error) {
      console.error(error);
    } finally {
      setSubmissionsLoading(false);
    }
  };

  useEffect(() => {
    if (selectedChallengeId && submissionsModalOpen) {
      console.log(
        "useEffect triggered - fetching submissions for:",
        selectedChallengeId,
      );
      fetchAllSubmissions(selectedChallengeId);
    }
  }, [selectedChallengeId, submissionsPage, submissionsModalOpen]);

  const fetchChallengesData = async () => {
    setLoading(true);
    try {
      const response = await getChallenges(
        challengesPage,
        challengesLimit,
        challengesSearch,
      );
      if (response.status) {
        setChallenges(response.payload.challenges || []);
        setChallengesTotal(response.payload.total || 0);
      }
    } catch (error) {
      console.error("Error fetching challenges:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChallengesData();
  }, [challengesPage, challengesSearch]);

  // Join Requests Fetch
  const fetchJoinRequests = async () => {
    setJoinRequestsLoading(true);
    try {
      const response = await getChallengeJoinRequests(
        joinRequestsPage,
        joinRequestsLimit,
        joinRequestsStatus,
        joinRequestsSearch,
      );
      if (response.status) {
        setJoinRequests(response.payload.requests || []);
        setJoinRequestsTotal(response.payload.total || 0);
      }
    } catch (error) {
      console.error("Error fetching join requests:", error);
    } finally {
      setJoinRequestsLoading(false);
    }
  };

  useEffect(() => {
    if (joinRequestsModalOpen) {
      fetchJoinRequests();
    }
  }, [
    joinRequestsModalOpen,
    joinRequestsPage,
    joinRequestsSearch,
    joinRequestsStatus,
  ]);

  const handleJoinRequestAction = async (requestId, status) => {
    setActionLoading(`${requestId}-${status}`);
    try {
      const response = await updateJoinRequestStatus(requestId, status);
      if (response.status) {
        // Update local state instead of refetching to avoid table reload
        setJoinRequests((prev) =>
          prev.map((req) => (req._id === requestId ? { ...req, status } : req)),
        );
      }
    } catch (error) {
      console.error("Error updating join request:", error);
      Swal.fire("Error", "Failed to update request status", "error");
    } finally {
      setActionLoading(null);
    }
  };

  const openJoinRequestsModal = () => {
    setJoinRequestsPage(1);
    setJoinRequestsSearch("");
    setJoinRequestsStatus("");
    setJoinRequestsModalOpen(true);
  };

  // Helper Functions
  const openModal = async (type, item, e) => {
    if (e) e.preventDefault();

    setModalType(type);
    setSelectedItem(item);
    setShowJudgesDetail(false);

    try {
      let judgesRes = null;

      if (type === "challenge" && item?.c_uuid) {
        const challengeId = item._id || item.c_uuid;

        // ✅ FETCH ALL JUDGES FIRST
        const [response, jr, resultRes] = await Promise.all([
          getChallengeSubmissions(challengeId).catch((e) => ({
            status: false,
            payload: { submissions: [] },
          })),
          getAllJudges().catch((e) => ({
            status: false,
            payload: { judges: [] },
          })),
          getSubmissionListById(challengeId, 1, 100).catch((e) => ({
            status: false,
            payload: { submissions: [] },
          })),
        ]);

        console.log("🔍 resultRes:", resultRes);
        console.log("🔍 Judges Response:", jr);

        if (response?.status) {
          setSubmissions(response?.payload?.submissions || []);
        } else {
          setSubmissions([]);
        }

        // ✅ SET JUDGES LIST FROM jr
        const judges = jr?.payload?.judges || jr?.judges || [];
        setJudgesList(Array.isArray(judges) ? judges : []);

        // ✅ EXTRACT WINNERS FROM SUBMISSIONS
        if (resultRes?.status && resultRes?.payload?.submissions) {
          const winners = resultRes.payload.submissions
            .filter(
              (sub) => sub.status === "winner" || sub.status === "declared",
            )
            .map((sub) => ({
              rank: sub.rank,
              prize: sub.prize,
              user_id: sub.user_id,
              submission_id: sub._id,
            }))
            .filter((w) => w.rank !== null && w.rank !== undefined);

          console.log("🏆 Winners extracted:", winners);

          // Sort by rank
          winners.sort((a, b) => a.rank - b.rank);

          // ✅ Update selectedItem with winners
          setSelectedItem((prev) => ({
            ...prev,
            c_winners: winners,
          }));
        } else {
          console.log("⚠️ No submissions found in resultRes");
          setSelectedItem((prev) => ({
            ...prev,
            c_winners: [],
          }));
        }

        judgesRes = jr;
      }

      if (type === "createChallenge") {
        judgesRes = await getAllJudges();
        const list = judgesRes?.payload?.judges ?? judgesRes?.judges ?? [];
        setJudgesList(Array.isArray(list) ? list : []);
      }

      const list = judgesRes?.payload?.judges ?? judgesRes?.judges ?? [];
      setJudgesList(Array.isArray(list) ? list : []);
    } catch (err) {
      console.error("Modal data load error:", err);
      setSubmissions([]);
      setJudgesList([]);
    } finally {
      setModalOpen(true);
    }
  };

  useEffect(() => {
    const fetchJudgesForChallenge = async () => {
      if (
        modalType === "challenge" &&
        selectedItem &&
        judgesList.length === 0
      ) {
        console.log("Fetching judges for challenge...");
        try {
          const response = await getAllJudges();
          console.log("Judges API response:", response);
          if (response?.status) {
            const judges = response?.payload?.judges || response?.judges || [];
            setJudgesList(judges);
            console.log("Judges set:", judges);
          }
        } catch (error) {
          console.error("Error fetching judges:", error);
        }
      }
    };

    fetchJudgesForChallenge();
  }, [modalType, selectedItem]);

  const fetchPackages = async () => {
    try {
      setPackagesLoading(true);
      const res = await getAllPackagesAPI();
      setPackages(res.data || []);
    } catch (error) {
      console.error("Error fetching packages:", error);
    } finally {
      setPackagesLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === "Packages") {
      fetchPackages();
    }
  }, [activeTab]);

  const handleDeletePackage = (id) => {
    Swal.fire({
      title: "Delete Package",
      text: "Are you sure you want to delete this package?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#f5365c",
      confirmButtonText: "Yes, delete it",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deletePackageAPI(id);
          setPackages(packages.filter((p) => (p._id || p.id) !== id));
          Swal.fire("Deleted!", "The package has been deleted.", "success");
        } catch (error) {
          Swal.fire("Error!", "Failed to delete the package.", "error");
        }
      }
    });
  };

  const handleAction = (type, actionType, item) => {
    Swal.fire({
      title: `${actionType} ${type}`,
      text: `Are you sure you want to perform this action on ${item.title || item.name || item.channel}?`,
      icon:
        actionType === "Reject" || actionType === "Suspend"
          ? "warning"
          : "question",
      showCancelButton: true,
      confirmButtonColor:
        actionType === "Reject" || actionType === "Suspend"
          ? "#f5365c"
          : "#5e72e4",
      confirmButtonText: `Yes, ${actionType}`,
    }).then((result) => {
      if (result.isConfirmed) {
        // Update local mock state based on type
        if (type === "Idea") {
          const statusMap = {
            Approve: "Approved",
            Reject: "Rejected",
            Feature: "Featured",
          };
          setIdeas(
            ideas.map((i) =>
              i.id === item.id ? { ...i, status: statusMap[actionType] } : i,
            ),
          );
        } else if (type === "Creator" && actionType === "Verify") {
          setCreators(
            creators.map((c) =>
              c.id === item.id ? { ...c, verified: true } : c,
            ),
          );
        } else if (type === "Referral") {
          if (actionType === "Adjust Points") {
            Swal.fire(
              "Adjust Points",
              "Opening point adjustment flow...",
              "info",
            );
            return;
          }
          if (actionType === "Revoke Bonus" || actionType === "Revoke")
            setReferrals(
              referrals.map((r) =>
                r.id === item.id
                  ? { ...r, bonus: "Revoked", status: "Suspended" }
                  : r,
              ),
            );
        }

        setModalOpen(false);
        Swal.fire(
          "Success!",
          `The item has been ${actionType.toLowerCase()}ed.`,
          "success",
        );
      }
    });
  };

  const handleJudge = async (submissionId, status) => {
    try {
      const { value: feedback } = await Swal.fire({
        title: `${status} Submission`,
        input: "textarea",
        inputPlaceholder: "Add feedback for the participant...",
        showCancelButton: true,
      });

      const response = await judgeSubmission(submissionId, status, feedback);
      if (response.status) {
        Swal.fire("Success", `Submission ${status.toLowerCase()}ed`, "success");
        if (selectedItem) fetchSubmissionsData(selectedItem.c_uuid);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleReward = async (submissionId, rewardStatus) => {
    try {
      const response = await rewardSubmission(submissionId, rewardStatus);
      if (response.status) {
        Swal.fire("Success", "Reward status updated", "success");
        if (selectedItem) fetchSubmissionsData(selectedItem.c_uuid);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // const handleChangeRequestAction = (id, status) => {
  //     Swal.fire({
  //         title: "Are you sure?",
  //         text: `You are about to ${status} this idea change request. This action can't be undone!`,
  //         icon: status === "approved" ? "question" : "warning",
  //         showCancelButton: true,
  //         confirmButtonColor: status === "approved" ? "#2dce89" : "#f5365c",
  //         cancelButtonColor: "#8898aa",
  //         confirmButtonText: `Yes, ${status} it!`,
  //         cancelButtonText: "No, cancel",
  //         reverseButtons: true
  //     }).then((result) => {
  //         if (result.isConfirmed) {
  //             setChangeRequests(prev => prev.map(req => req.id === id ? { ...req, status } : req));
  //             Swal.fire({
  //                 title: "Success!",
  //                 text: `The request has been ${status}ed successfully.`,
  //                 icon: "success",
  //                 timer: 2000,
  //                 showConfirmButton: false
  //             });
  //         }
  //     });
  // };

  const handleCreateChallengeSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    // Append selected judges (multi-select is not auto-captured by FormData)
    formData.delete("judges");
    selectedJudges.forEach((judgeId) => formData.append("judges", judgeId));

    try {
      const response = await createChallenge(formData);
      if (response.status) {
        Swal.fire("Success", "Challenge created successfully!", "success");
        setModalOpen(false);
        setSelectedJudges([]);
        fetchChallengesData();
      }
    } catch (err) {
      console.error(err);
      Swal.fire(
        "Error",
        "Failed to create challenge. Please try again.",
        "error",
      );
    }
  };
  const handleStatusUpdate = async (item) => {
    try {
      console.log(" Status update for:", item?.c_uuid);

      const nextStatus = "Active";

      const response = await updateChallengeStatus(item.c_uuid, nextStatus);

      if (response?.status) {
        console.log(" API Success:", response);

        setChallenges((prev) =>
          prev.map((ch) =>
            ch.c_uuid === item.c_uuid ? { ...ch, c_status: nextStatus } : ch,
          ),
        );
      } else {
        console.log(" API Failed:", response);
      }
    } catch (err) {
      console.error(" Error updating status:", err);
    }
  };

  const fetchSubmissionsData = async (challengeId) => {
    try {
      const response = await getChallengeSubmissions(challengeId);
      if (response.status) setSubmissions(response.payload.submissions || []);
    } catch (err) {
      console.error(err);
    }
  };

  // Helper to parse JSON fields safely
  const parseIfJson = (data) => {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    try {
      const parsed = JSON.parse(data);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };
  const categoryMap = {};

  categories.forEach((cat) => {
    categoryMap[cat.c_uuid] = cat.c_name;
  });

  const fetchInnovationBoards = async () => {
    setInnovationBoardsLoading(true);

    try {
      const response = await getInnovationBoards({
        page: innovationBoardsPage,
        limit: innovationBoardsLimit,
        search: innovationBoardsSearch,
        status: innovationBoardsStatus,
      });

      console.log("Innovation Boards API Response:", response);

      if (response.success) {
        setInnovationBoards(response.payload || []);
        setInnovationBoardsTotal(response.pagination?.total || 0);
      } else {
        console.error("Failed to fetch innovation boards:", response.message);
        setInnovationBoards([]);
      }
    } catch (error) {
      console.error("Error fetching innovation boards:", error);

      Swal.fire("Error", "Failed to load innovation boards", "error");

      setInnovationBoards([]);
    } finally {
      setInnovationBoardsLoading(false);
    }
  };

  // Add useEffect to fetch innovation boards when tab becomes active
  useEffect(() => {
    if (activeTab === "Innovation Boards") {
      fetchInnovationBoards();
    }
  }, [
    activeTab,
    innovationBoardsPage,
    innovationBoardsSearch,
    innovationBoardsStatus,
  ]);

  const fetchData = async () => {
    setLoading(true);

    try {
      console.log(" API CALL =>", { page, limit, search, status, fraud });

      const res = await getReferralEvents({
        page,
        limit,
        search,
        status,
        fraud,
      });

      console.log(" API RES =>", res);

      if (res?.status) {
        setData(res.payload?.referrals || []);
        setPagination(res.payload?.pagination || {});
      }
    } catch (err) {
      console.error(" ERROR =>", err?.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const delay = setTimeout(() => {
      fetchData();
    }, 400);

    return () => clearTimeout(delay);
  }, [page, search, status, fraud]);

  const openReferralModal = (item, action) => {
    console.log("item", item, "action", action);
    setSelectedItem(item);
    setModalType("referral");
    setReferralAction(action);
    setModalOpen(true);
  };

  const fetchChannels = async () => {
    setChannelsLoading(true);
    try {
      const res = await getCreatorChannels({
        page: channelsPage,
        limit: channelsLimit,
        search: channelsSearch,
        status: channelsStatus,
        contentType: "", // Add if needed
      });

      console.log("Channels API Response:", res);

      if (res?.success) {
        setChannels(res.payload?.data || []);
        setChannelsTotal(res.payload?.pagination?.total || 0);
        setChannelsPagination(
          res.payload?.pagination || {
            total: 0,
            page: 1,
            totalPages: 1,
          },
        );
      } else {
        console.error("Failed to fetch channels:", res?.message);
        setChannels([]);
      }
    } catch (error) {
      console.error("Error fetching channels:", error);
      Swal.fire("Error", "Failed to load creator channels", "error");
      setChannels([]);
    } finally {
      setChannelsLoading(false);
    }
  };

  // Add useEffect for channels tab
  useEffect(() => {
    if (activeTab === "Creator Channels") {
      fetchChannels();
    }
  }, [activeTab, channelsPage, channelsSearch, channelsStatus]);

  // Add debounced search for channels
  useEffect(() => {
    if (activeTab === "Creator Channels") {
      const delay = setTimeout(() => {
        setChannelsPage(1);
        fetchChannels();
      }, 500);
      return () => clearTimeout(delay);
    }
  }, [channelsSearch, channelsStatus]);

  const fetchMemberships = async () => {
    setMembershipsLoading(true);
    try {
      const res = await getUserMemberships({
        page: membershipsPage,
        limit: membershipsLimit,
        search: membershipsSearch,
        status: membershipsStatus,
        tier: membershipsTier,
      });
      console.log("Memberships API Response:", res);
      if (res?.success || res?.status) {
        setMemberships(res.payload?.membershipsByUser || []);
        setMembershipsTotal(
          res.payload?.totalRecords || res.payload?.totalMemberships || 0,
        );
        setMembershipsByType(res.payload?.membershipsByType || {});
      } else {
        console.error("Failed to fetch memberships:", res?.message);
        setMemberships([]);
      }
    } catch (error) {
      console.error("Error fetching memberships:", error);
      Swal.fire("Error", "Failed to load user memberships", "error");
      setMemberships([]);
    } finally {
      setMembershipsLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === "User Memberships") {
      fetchMemberships();
    }
  }, [activeTab, membershipsPage]);

  // Add debounced search and filter hook for memberships tab
  useEffect(() => {
    if (activeTab === "User Memberships") {
      const delay = setTimeout(() => {
        if (membershipsPage === 1) {
          fetchMemberships();
        } else {
          setMembershipsPage(1);
        }
      }, 500);
      return () => clearTimeout(delay);
    }
  }, [membershipsSearch, membershipsStatus, membershipsTier]);

  // ========== 🎁 GIFT CONFIG FUNCTIONS ==========
  const fetchGiftConfig = async () => {
    setGiftConfigLoading(true);
    try {
      const response = await getGiftConfig();
      console.log("Gift Config API Response:", response); // ✅ Debug ke liye

      // ✅ FIX: response.status check karo (success nahi)
      if (response.status === true || response.status === "true") {
        setGiftConfig(response.payload); // ✅ Data "payload" mein hai
      } else {
        console.error("API returned status false:", response);
        Swal.fire(
          "Error",
          response.message || "Failed to load gift config",
          "error",
        );
      }
    } catch (error) {
      console.error("Error fetching gift config:", error);
      Swal.fire("Error", "Failed to load gift config", "error");
    } finally {
      setGiftConfigLoading(false);
    }
  };

  const handleGiftConfigUpdate = async () => {
    if (!giftConfig) {
      Swal.fire("Error", "No config loaded", "error");
      return;
    }

    setGiftConfigSaving(true);
    try {
      const response = await updateGiftConfig({
        gift_amount: giftConfig.gift_amount,
        currency: giftConfig.currency,
        expiry_days: giftConfig.expiry_days,
        is_active: giftConfig.is_active,
      });

      console.log("Update Gift Config Response:", response); // ✅ Debug ke liye

      // ✅ FIX: response.status check karo
      if (response.status === true || response.status === "true") {
        setGiftConfig(response.payload);
        Swal.fire("Success", "Gift config updated successfully!", "success");
      } else {
        Swal.fire(
          "Error",
          response.message || "Failed to update gift config",
          "error",
        );
      }
    } catch (error) {
      console.error("Error updating gift config:", error);
      Swal.fire("Error", "Failed to update gift config", "error");
    } finally {
      setGiftConfigSaving(false);
    }
  };

  const handleToggleGiftStatus = async () => {
    if (!giftConfig) {
      Swal.fire("Error", "No config loaded", "error");
      return;
    }

    try {
      const response = await toggleGiftConfigStatus();
      console.log("Toggle Gift Config Response:", response); // ✅ Debug ke liye

      // ✅ FIX: response.status check karo
      if (response.status === true || response.status === "true") {
        setGiftConfig(response.payload);
        Swal.fire(
          "Success",
          `Gift config ${response.payload.is_active ? "activated" : "deactivated"}!`,
          "success",
        );
      } else {
        Swal.fire(
          "Error",
          response.message || "Failed to toggle gift status",
          "error",
        );
      }
    } catch (error) {
      console.error("Error toggling gift status:", error);
      Swal.fire("Error", "Failed to toggle gift status", "error");
    }
  };

  const fetchDashboardStats = async () => {
    setStatsLoading(true);
    try {
      const response = await getdashboardstate();
      console.log("Dashboard stats response:", response);

      if (response?.success && response?.data) {
        setDashboardStats({
          totalFundedIdeas: response.data.totalFundedIdeas || 0,
          activeChallenges: response.data.activeChallenges || 0,
          totalParticipants: response.data.totalParticipants || 0,
          crossCountryBonuses: response.data.crossCountryBonuses || 0,
          totalReferralPoints: response.data.totalReferralPoints || 0,
          totalFundingAmount: response.data.totalFundingAmount || 0,
          totalIdeas: response.data.totalIdeas || 0,
          fundedIdeasCount: response.data.fundedIdeasCount || 0,
          totalChallenges: response.data.totalChallenges || 0,
          totalSubmissions: response.data.totalSubmissions || 0,
          completedChallenges: response.data.completedChallenges || 0,
          totalCreators: response.data.totalCreators || 0,
          activeCreators: response.data.activeCreators || 0,
          totalReferrals: response.data.totalReferrals || 0,
          totalBonusesPaid: response.data.totalBonusesPaid || 0,
        });
      }
    } catch (error) {
      console.error("Error fetching dashboard stats:", error);
      Swal.fire("Error", "Failed to load dashboard statistics", "error");
    } finally {
      setStatsLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardStats();
  }, []);

  const renderModalBody = () => {
    if (modalType === "createChallenge") {
      return (
        <form
          className="px-4 pb-4"
          onSubmit={handleCreateChallengeSubmit}
          encType="multipart/form-data"
        >
          <Row>
            <Col md="6">
              <div className="form-group mb-3">
                <label className="form-control-label">Tite</label>
                <input
                  name="name"
                  type="text"
                  className="form-control"
                  required
                />
              </div>
            </Col>

            <Col md="6">
              <div className="form-group mb-3">
                <label className="form-control-label">Description</label>
                <input
                  name="description"
                  type="text"
                  className="form-control"
                  required
                />
              </div>
            </Col>
            <Col md="6">
              <div className="form-group mb-3">
                <label className="form-control-label">Category</label>

                <select name="category" className="form-control" required>
                  <option value="">Select Category</option>

                  {categories.map((item) => (
                    <option key={item._id} value={item._id}>
                      {item.c_name}
                    </option>
                  ))}
                </select>
              </div>
            </Col>
            <Col md="4">
              <div className="form-group mb-3">
                <label className="form-control-label">Start Date</label>
                <input
                  name="start_date"
                  type="date"
                  className="form-control"
                  required
                />
              </div>
            </Col>
            <Col md="4">
              <div className="form-group mb-3">
                <label className="form-control-label">End Date</label>
                <input
                  name="end_date"
                  type="date"
                  className="form-control"
                  required
                />
              </div>
            </Col>
            <Col md="4">
              <div className="form-group mb-3">
                <label className="form-control-label">Deadline</label>
                <input
                  name="deadline"
                  type="date"
                  className="form-control"
                  required
                />
              </div>
            </Col>

            {/* <Col md="6">
                            <div className="form-group mb-3">
                                <label className="form-control-label">Visibility</label>
                                <select name="visibility" className="form-control" required>
                                    <option value="Public">Public</option>
                                    <option value="Private">Private</option>
                                </select>
                            </div>
                        </Col> */}
            <Col md="6">
              <div className="form-group mb-3">
                <label className="form-control-label">Reward Type</label>
                <select name="reward_type" className="form-control" required>
                  <option value="wallet">Wallet</option>
                  <option value="points">Points</option>
                  <option value="badge">Badge</option>
                </select>
              </div>
            </Col>
            <Col md="12">
              {" "}
              <div className="form-group mb-3">
                <label className="form-control-label">
                  Prize Pool (JSON format)
                </label>{" "}
                <input
                  name="prize"
                  type="text"
                  className="form-control"
                  placeholder='[{"position": 1, "reward": "$100"}]'
                />{" "}
              </div>{" "}
            </Col>
            <Col md="12">
              <div className="form-group mb-3">
                <label className="form-control-label">Eligibility Rules</label>
                <input
                  name="eligibility"
                  type="text"
                  className="form-control"
                  placeholder="min_tier:Expert, age:18+"
                />
              </div>
            </Col>

            <Col md="12">
              <div className="form-group mb-3" style={{ position: "relative" }}>
                <label className="form-control-label">Assign Judges</label>

                {/* Dropdown trigger button */}
                <div
                  onClick={() => setJudgesDropdownOpen((o) => !o)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    border: "1px solid #e2e8f0",
                    borderRadius: "8px",
                    padding: "8px 14px",
                    cursor: "pointer",
                    background: "#fff",
                    minHeight: "42px",
                    userSelect: "none",
                    boxShadow: judgesDropdownOpen
                      ? "0 0 0 3px rgba(94,114,228,0.15)"
                      : "none",
                    borderColor: judgesDropdownOpen ? "#5e72e4" : "#e2e8f0",
                    transition: "all 0.15s",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "5px",
                      flex: 1,
                    }}
                  >
                    {selectedJudges.length === 0 ? (
                      <span style={{ color: "#adb5bd", fontSize: "13px" }}>
                        Select judges...
                      </span>
                    ) : (
                      selectedJudges.map((id) => {
                        const j = judgesList.find((jj) => jj._id === id);
                        return j ? (
                          <span
                            key={id}
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "5px",
                              background:
                                "linear-gradient(135deg,#5e72e4,#825ee4)",
                              color: "#fff",
                              borderRadius: "20px",
                              padding: "3px 10px",
                              fontSize: "12px",
                              fontWeight: 600,
                            }}
                          >
                            {j.au_name} {j.au_surname}
                            <span
                              style={{ cursor: "pointer", fontWeight: 700 }}
                              onClick={(ev) => {
                                ev.stopPropagation();
                                setSelectedJudges((prev) =>
                                  prev.filter((s) => s !== id),
                                );
                              }}
                            >
                              &times;
                            </span>
                          </span>
                        ) : null;
                      })
                    )}
                  </div>
                  <i
                    className={`fas fa-chevron-${judgesDropdownOpen ? "up" : "down"}`}
                    style={{
                      color: "#8898aa",
                      fontSize: "12px",
                      marginLeft: "8px",
                      flexShrink: 0,
                    }}
                  />
                </div>

                {/* Dropdown panel */}
                {judgesDropdownOpen && (
                  <div
                    style={{
                      position: "absolute",
                      zIndex: 9999,
                      left: 0,
                      right: 0,
                      top: "calc(100% + 2px)",
                      background: "#fff",
                      border: "1px solid #e2e8f0",
                      borderRadius: "8px",
                      boxShadow: "0 8px 24px rgba(0,0,0,0.10)",
                      maxHeight: "200px",
                      overflowY: "auto",
                      padding: "6px 4px",
                    }}
                  >
                    {judgesList.length === 0 ? (
                      <p
                        className="text-muted text-sm mb-0 px-3 py-2"
                        style={{ fontStyle: "italic" }}
                      >
                        No judges with the "Judge" role found.
                      </p>
                    ) : (
                      judgesList.map((judge) => {
                        const checked = selectedJudges.includes(judge._id);
                        return (
                          <div
                            key={judge._id}
                            onClick={() => {
                              setSelectedJudges((prev) =>
                                prev.includes(judge._id)
                                  ? prev.filter((id) => id !== judge._id)
                                  : [...prev, judge._id],
                              );
                            }}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              padding: "8px 12px",
                              cursor: "pointer",
                              borderRadius: "6px",
                              background: checked ? "#eef2ff" : "transparent",
                              transition: "background 0.12s",
                              marginBottom: "2px",
                            }}
                          >
                            <input
                              type="checkbox"
                              readOnly
                              checked={checked}
                              style={{
                                accentColor: "#5e72e4",
                                width: "15px",
                                height: "15px",
                                flexShrink: 0,
                              }}
                            />
                            <span
                              style={{
                                fontSize: "13px",
                                fontWeight: 500,
                                color: "#32325d",
                              }}
                            >
                              {judge.au_name} {judge.au_surname}
                              <span
                                className="text-muted"
                                style={{ fontSize: "11px", marginLeft: "6px" }}
                              >
                                {judge.au_email}
                              </span>
                            </span>
                          </div>
                        );
                      })
                    )}
                  </div>
                )}
              </div>
            </Col>

            <Col md="12">
              <div className="form-group mb-3">
                <label className="form-control-label">
                  Challenge Image (optional)
                </label>
                <input
                  name="image"
                  type="file"
                  className="form-control"
                  accept="image/jpeg,image/png,image/jpg"
                />
              </div>
            </Col>
          </Row>
          <Button block color="primary" type="submit">
            Create Challenge
          </Button>
        </form>
      );
    }

    if (modalType === "createPackage" || modalType === "package") {
      const pkg = modalType === "package" ? selectedItem : null;
      return (
        <form
          className="px-4 pb-4 mt-3"
          onSubmit={async (e) => {
            e.preventDefault();
            const formData = new FormData(e.target);
            const data = {
              name: formData.get("name"),
              price: formData.get("price"),
              period: formData.get("period"),
              subtitle: formData.get("subtitle"),
              features: formData.get("features").split(/[\n,]+/).map(f => f.trim()).filter(f => f !== ""),
              popular: formData.get("popular") === "on",
            };
            
            try {
              if (pkg) {
                await updatePackageAPI(pkg._id || pkg.id, data);
                Swal.fire("Updated!", "The package has been updated.", "success");
              } else {
                await createPackageAPI(data);
                Swal.fire("Created!", "The package has been created.", "success");
              }
              setModalOpen(false);
              fetchPackages();
            } catch (error) {
              console.error("API Error:", error);
              const errorMsg = error.response?.data?.message || "Failed to save the package.";
              Swal.fire("Error!", errorMsg, "error");
            }
          }}
        >
          <Row>
            <Col md="6">
              <div className="form-group mb-3">
                <label className="form-control-label">Package Name</label>
                <input
                  name="name"
                  type="text"
                  className="form-control"
                  defaultValue={pkg?.name || ""}
                  required
                />
              </div>
            </Col>
            <Col md="6">
              <div className="form-group mb-3">
                <label className="form-control-label">Price</label>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="fas fa-dollar-sign" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    name="price"
                    type="number"
                    min="0"
                    step="0.01"
                    defaultValue={pkg?.price || ""}
                    required
                  />
                </InputGroup>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <div className="form-group mb-3">
                <label className="form-control-label">Period (e.g. /month)</label>
                <input
                  name="period"
                  type="text"
                  className="form-control"
                  defaultValue={pkg?.period || ""}
                />
              </div>
            </Col>
            <Col md="6">
              <div className="form-group mb-3">
                <label className="form-control-label">Subtitle</label>
                <input
                  name="subtitle"
                  type="text"
                  className="form-control"
                  defaultValue={pkg?.subtitle || ""}
                />
              </div>
            </Col>
          </Row>
          <div className="form-group mb-3">
            <label className="form-control-label">Features (one per line)</label>
            <textarea
              name="features"
              className="form-control"
              rows="4"
              defaultValue={pkg?.features?.join("\n") || ""}
              required
            />
          </div>
          <div className="form-group mb-4">
            <div className="custom-control custom-checkbox">
              <input
                name="popular"
                className="custom-control-input"
                id="popularCheck"
                type="checkbox"
                defaultChecked={pkg?.popular || false}
              />
              <label className="custom-control-label" htmlFor="popularCheck">
                Mark as Most Popular
              </label>
            </div>
          </div>
          <div className="text-right mt-4">
            <Button
              color="secondary"
              onClick={() => setModalOpen(false)}
              type="button"
            >
              Cancel
            </Button>
            <Button color="primary" type="submit">
              {pkg ? "Save Changes" : "Create Package"}
            </Button>
          </div>
        </form>
      );
    }

    if (!selectedItem) return null;

    if (modalType === "idea") {
      return (
        <div className="px-4 pb-4">
          <h2 className="mb-1 text-dark">{selectedItem.title}</h2>
          <p className="text-muted text-sm mb-4">
            Pitched by <b>{selectedItem.author?.substring(0, 12)}...</b> •{" "}
            {selectedItem.category}
          </p>

          <div style={styles.modalDataBlock}>
            <h6 className="text-uppercase text-muted ls-1 mb-2">
              Pitch Description
            </h6>
            <p
              className="text-sm text-dark"
              style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
            >
              <ReadMoreDescription
                text={selectedItem.description}
                maxLength={250}
              />
            </p>
          </div>

          {/* Skills Section - Added to show full skills details */}
          {selectedItem.skills_needed &&
            selectedItem.skills_needed.length > 0 && (
              <div style={styles.modalDataBlock}>
                <h6 className="text-uppercase text-muted ls-1 mb-2">
                  Skills Required
                </h6>
                <div className="d-flex flex-wrap gap-2">
                  {selectedItem.skills_needed.map((skill, idx) => (
                    <span
                      key={idx}
                      className="badge badge-primary p-2"
                      style={{
                        background: "#f8f9fa",
                        padding: "12px",
                        borderRadius: "8px",
                        fontFamily: "monospace",
                        fontSize: "13px",
                        wordBreak: "break-word",
                        whiteSpace: "pre-wrap",
                        maxHeight: "200px",
                        overflowY: "auto",
                      }}
                    >
                      <i
                        className="fas fa-code mr-1"
                        style={{ fontSize: "11px" }}
                      />
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            )}

          {/* Funding Details Section */}
          <div style={styles.modalDataBlock}>
            <h6 className="text-uppercase text-muted ls-1 mb-2">
              Funding Details
            </h6>
            <Row className="mb-2">
              <Col xs="6">
                <div className="text-muted text-sm">Funding Needed</div>
                <div
                  className="font-weight-bold text-dark"
                  style={{ fontSize: "18px" }}
                >
                  $
                  {selectedItem.funding_needed || selectedItem.investments || 0}
                </div>
              </Col>
              <Col xs="6">
                <div className="text-muted text-sm">Funding Received</div>
                <div
                  className="font-weight-bold text-success"
                  style={{ fontSize: "18px" }}
                >
                  $
                  {selectedItem.funding_received ||
                    selectedItem.investments ||
                    0}
                </div>
              </Col>
            </Row>
            {selectedItem.funding_needed && selectedItem.funding_received && (
              <Progress
                value={
                  (selectedItem.funding_received /
                    selectedItem.funding_needed) *
                  100
                }
                color="success"
                style={{ height: "8px", borderRadius: "4px" }}
              />
            )}
          </div>

          {/* Statistics Section */}
          <Row className="mb-4 text-center">
            <Col xs="4">
              <div
                className="font-weight-bold text-dark"
                style={{ fontSize: "20px" }}
              >
                {selectedItem.upvotes || 0}
              </div>
              <div className="text-xs text-uppercase text-muted">Upvotes</div>
            </Col>
            <Col xs="4">
              <div
                className="font-weight-bold text-primary"
                style={{ fontSize: "20px" }}
              >
                {selectedItem.views || 0}
              </div>
              <div className="text-xs text-uppercase text-muted">Views</div>
            </Col>
            <Col xs="4">
              <div
                className="font-weight-bold text-warning"
                style={{ fontSize: "20px" }}
              >
                {selectedItem.comments || 0}
              </div>
              <div className="text-xs text-uppercase text-muted">Comments</div>
            </Col>
          </Row>

          {/* Status Badge */}
          <div className="mt-3 text-center">
            <Badge
              color={
                selectedItem.status === "funded"
                  ? "success"
                  : selectedItem.status === "open"
                    ? "primary"
                    : "secondary"
              }
              pill
              style={{ fontSize: "13px", padding: "6px 16px" }}
            >
              <i
                className={`fas ${selectedItem.status === "funded" ? "fa-check-circle" : selectedItem.status === "open" ? "fa-clock" : "fa-lock"} mr-1`}
              />
              {selectedItem.status?.toUpperCase() || "OPEN"}
            </Badge>
          </div>
        </div>
      );
    }

    if (modalType === "challenge") {
      // Parse all JSON fields
      const attachments = parseIfJson(selectedItem.c_attachments);
      const judges = parseIfJson(selectedItem.c_judges);
      const criteria = parseIfJson(selectedItem.c_criteria);
      const prize = parseIfJson(selectedItem.c_prize);
      const eligibility = (() => {
        if (!selectedItem.c_eligibility) return null;
        if (typeof selectedItem.c_eligibility === "object")
          return selectedItem.c_eligibility;
        try {
          return JSON.parse(selectedItem.c_eligibility);
        } catch {
          return null;
        }
      })();

      return (
        <div className="px-4 pb-4">
          {/* Header Section */}
          <div className="d-flex justify-content-between align-items-start mb-3 flex-wrap">
            <div className="flex-grow-1">
              <h2 className="mb-1 text-muted">{selectedItem.c_name}</h2>
              {/* Creator Details */}
              <div className="d-flex align-items-center mt-3">
                {/* Profile Image */}
                <img
                  src={
                    getUserImage(selectedItem?.c_creator) ||
                    `https://ui-avatars.com/api/?name=${encodeURIComponent(
                      selectedItem?.c_creator?.name || "User",
                    )}&background=5e72e4&color=fff&size=60`
                  }
                  alt={selectedItem?.c_creator?.name || "User"}
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    marginRight: "15px",
                    border: "2px solid #eee",
                  }}
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                      selectedItem?.c_creator?.name || "User",
                    )}&background=5e72e4&color=fff&size=60`;
                  }}
                />

                {/* User Info */}
                <div>
                  <p
                    className="text-muted text-sm mb-0"
                    style={{ fontSize: "11px" }}
                  >
                    Sponsored by
                  </p>
                  <h5
                    className="mb-0 font-weight-bold"
                    style={{ fontSize: "14px" }}
                  >
                    {selectedItem?.c_creator?.name || "N/A"}
                  </h5>
                  <p className="text-muted mb-0" style={{ fontSize: "12px" }}>
                    {selectedItem?.c_creator?.email || "No Email"}
                  </p>
                </div>
              </div>
              <div className="mt-2 text-sm mb-2">
                <Badge
                  color={
                    selectedItem.c_status === "Draft"
                      ? "warning"
                      : selectedItem.c_status === "Active"
                        ? "success"
                        : "secondary"
                  }
                  pill
                  className="mr-2 text-muted font-weight-bold"
                >
                  {selectedItem.c_status || "N/A"}
                </Badge>

                <Badge
                  color={
                    selectedItem.c_visibility === "Public"
                      ? "info"
                      : "secondary"
                  }
                  pill
                  className="text-muted font-weight-bold"
                >
                  {selectedItem.c_visibility || "N/A"}
                </Badge>

                {selectedItem.c_result_declared && (
                  <Badge
                    color="success"
                    pill
                    className="ml-2 text-muted font-weight-bold"
                  >
                    Results Declared
                  </Badge>
                )}
              </div>
            </div>
            {/* {selectedItem.c_uuid && (
                            <div className="text-right">
                                <small className="text-muted d-block">Challenge ID</small>
                                <code className="text-xs">{selectedItem.c_uuid.substring(0, 13)}...</code>
                            </div>
                        )} */}
          </div>

          {/* Basic Information Card */}
          <div style={styles.modalDataBlock}>
            <h6 className="text-uppercase text-muted ls-1 mb-3">
              <i className="fas fa-info-circle mr-2" /> Basic Information
            </h6>
            <Row>
              <Col md="4" className="mb-2">
                <p className="text-sm mb-0 text-muted">Category</p>
                <p className="font-weight-bold mb-0">
                  {selectedItem.c_category || "N/A"}
                </p>
              </Col>
              <Col md="4" className="mb-2">
                <p className="text-sm mb-0 text-muted">Reward Type</p>
                <p className="font-weight-bold mb-0">
                  {selectedItem.c_reward_type || "N/A"}
                </p>
              </Col>
              <Col md="6" className="mb-2">
                <p className="text-sm mb-0 text-muted">Created At</p>
                <p className="text-sm mb-0">
                  {selectedItem.c_created_at
                    ? new Date(selectedItem.c_created_at).toLocaleString()
                    : "N/A"}
                </p>
              </Col>
            </Row>
          </div>

          {/* Dates Card */}
          <div style={styles.modalDataBlock}>
            <h6 className="text-uppercase text-muted ls-1 mb-3">
              <i className="fas fa-calendar-alt mr-2" /> Important Dates
            </h6>
            <Row>
              <Col md="4" className="mb-2">
                <p className="text-sm mb-0 text-muted">Start Date</p>
                <p className="font-weight-bold mb-0 text-success">
                  <i className="fas fa-play-circle mr-1" />
                  {selectedItem.c_start_date
                    ? new Date(selectedItem.c_start_date).toLocaleDateString()
                    : "N/A"}
                </p>
              </Col>
              <Col md="4" className="mb-2">
                <p className="text-sm mb-0 text-muted">End Date</p>
                <p className="font-weight-bold mb-0 text-danger">
                  <i className="fas fa-flag-checkered mr-1" />
                  {selectedItem.c_end_date
                    ? new Date(selectedItem.c_end_date).toLocaleDateString()
                    : "N/A"}
                </p>
              </Col>
              <Col md="4" className="mb-2">
                <p className="text-sm mb-0 text-muted">Submission Deadline</p>
                <p className="font-weight-bold mb-0 text-warning">
                  <i className="fas fa-hourglass-half mr-1" />
                  {selectedItem.c_deadline
                    ? new Date(selectedItem.c_deadline).toLocaleDateString()
                    : "N/A"}
                </p>
              </Col>
            </Row>
          </div>

          {/* Evaluation Card */}
          {selectedItem.c_evaluation &&
            Object.keys(selectedItem.c_evaluation).length > 0 && (
              <div style={styles.modalDataBlock}>
                <h6 className="text-uppercase text-muted ls-1 mb-3">
                  <i className="fas fa-tasks mr-2" /> Evaluation Criteria
                </h6>
                <Row>
                  {Object.entries(selectedItem.c_evaluation).map(
                    ([key, value]) => (
                      <Col md="4" className="mb-2" key={key}>
                        <p className="text-sm mb-0 text-muted text-capitalize">
                          {key}
                        </p>
                        <p className="font-weight-bold mb-0 text-info">
                          {value}%
                        </p>
                      </Col>
                    ),
                  )}
                </Row>
              </div>
            )}

          {/* Statistics Card */}
          <div style={styles.modalDataBlock}>
            <h6 className="text-uppercase text-muted ls-1 mb-3">
              <i className="fas fa-chart-line mr-2" /> Statistics
            </h6>
            <Row className="text-center">
              <Col xs="6" md="3" className="mb-2">
                <div
                  className="font-weight-bold text-dark"
                  style={{ fontSize: "20px" }}
                >
                  {selectedItem.c_participants_count || 0}
                </div>
                <div className="text-xs text-uppercase text-muted">
                  Participants
                </div>
              </Col>
              <Col xs="6" md="3" className="mb-2">
                <div
                  className="font-weight-bold text-primary"
                  style={{ fontSize: "20px" }}
                >
                  {selectedItem.c_submissions_count || 0}
                </div>
                <div className="text-xs text-uppercase text-muted">
                  Submissions
                </div>
              </Col>
              <Col xs="6" md="3" className="mb-2">
                <div
                  className="font-weight-bold text-success"
                  style={{ fontSize: "20px" }}
                >
                  {selectedItem.c_winners_count || 0}
                </div>
                <div className="text-xs text-uppercase text-muted">Winners</div>
              </Col>
              <Col xs="6" md="3" className="mb-2">
                <div
                  className="font-weight-bold text-info"
                  style={{ fontSize: "20px" }}
                >
                  {selectedItem?.c_judges_count !== undefined
                    ? selectedItem.c_judges_count
                    : selectedItem?.c_judges
                      ? selectedItem.c_judges.length
                      : 0}
                </div>
                <div className="text-xs text-uppercase text-muted">JUDGES</div>
                {(selectedItem?.c_judges_count > 0 ||
                  (selectedItem?.c_judges &&
                    selectedItem.c_judges.length > 0)) && (
                  <Button
                    size="sm"
                    color="info"
                    outline
                    className="mt-1"
                    style={{
                      fontSize: "11px",
                      padding: "2px 10px",
                      borderRadius: "20px",
                    }}
                    onClick={() => setShowJudgesDetail((prev) => !prev)}
                  >
                    <i
                      className={`fas fa-eye${showJudgesDetail ? "-slash" : ""} mr-1`}
                    />
                    {showJudgesDetail ? "Hide" : "View"}
                  </Button>
                )}
              </Col>
            </Row>
          </div>

          {/* Statistics Card ke andar View button ke baad */}
          {showJudgesDetail &&
            (() => {
              // ✅ GET ASSIGNED JUDGES FROM CHALLENGE
              const assignedJudges = selectedItem?.c_judges || [];

              if (assignedJudges.length === 0) {
                return (
                  <div style={styles.modalDataBlock}>
                    <h6 className="text-uppercase text-muted ls-1 mb-3">
                      <i className="fas fa-gavel mr-2" />
                      Assigned Judges
                    </h6>
                    <div className="text-center py-3">
                      <p className="text-muted">
                        No judges assigned to this challenge
                      </p>
                    </div>
                  </div>
                );
              }

              return (
                <div style={styles.modalDataBlock}>
                  <h6 className="text-uppercase text-muted ls-1 mb-3">
                    <i className="fas fa-gavel mr-2" />
                    Assigned Judges List ({assignedJudges.length})
                  </h6>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    {assignedJudges.map((judge, idx) => {
                      // Judge object structure: { r_uuid: "uuid", _id: "..." }
                      // We need to find full judge details from judgesList or use available data
                      const judgeDetails = judgesList.find(
                        (j) =>
                          j.au_uuid === judge.r_uuid || j._id === judge.r_uuid,
                      );

                      // If judge details found in judgesList, show full details
                      if (judgeDetails) {
                        return (
                          <div
                            key={idx}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              background: "#fff",
                              borderRadius: "10px",
                              padding: "12px 16px",
                              border: "1px solid #e9ecef",
                              transition: "all 0.2s",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = "#f8f9fe";
                              e.currentTarget.style.borderColor = "#5e72e4";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = "#fff";
                              e.currentTarget.style.borderColor = "#e9ecef";
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                              }}
                            >
                              {/* Avatar */}
                              <div
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "10px",
                                  background: `linear-gradient(135deg, ${idx % 2 === 0 ? "#5e72e4" : "#11cdef"}, ${idx % 2 === 0 ? "#825ee4" : "#1171ef"})`,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "#fff",
                                  fontWeight: 700,
                                  fontSize: "16px",
                                }}
                              >
                                {(judgeDetails.au_name || "J")
                                  .charAt(0)
                                  .toUpperCase()}
                              </div>

                              {/* Details */}
                              <div>
                                <div
                                  style={{
                                    fontWeight: 600,
                                    fontSize: "14px",
                                    color: "#32325d",
                                  }}
                                >
                                  {judgeDetails.au_name}{" "}
                                  {judgeDetails.au_surname || ""}
                                </div>
                                <div
                                  style={{
                                    fontSize: "11px",
                                    color: "#8898aa",
                                    marginTop: "2px",
                                  }}
                                >
                                  <i
                                    className="fas fa-envelope mr-1"
                                    style={{ fontSize: "9px" }}
                                  />
                                  {judgeDetails.au_email}
                                </div>
                              </div>
                            </div>

                            {/* Badge */}
                            <div>
                              <Badge
                                color="info"
                                pill
                                style={{
                                  fontSize: "10px",
                                  padding: "4px 10px",
                                }}
                              >
                                <i className="fas fa-gavel mr-1" />
                                Judge
                              </Badge>
                            </div>
                          </div>
                        );
                      } else {
                        // If judge details not found, show placeholder
                        return (
                          <div
                            key={idx}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              background: "#fff",
                              borderRadius: "10px",
                              padding: "12px 16px",
                              border: "1px solid #e9ecef",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                              }}
                            >
                              <div
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "10px",
                                  background: "#e9ecef",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "#8898aa",
                                  fontWeight: 700,
                                  fontSize: "16px",
                                }}
                              >
                                ?
                              </div>
                              <div>
                                <div
                                  style={{
                                    fontWeight: 600,
                                    fontSize: "14px",
                                    color: "#32325d",
                                  }}
                                >
                                  Judge {idx + 1}
                                </div>
                                <div
                                  style={{
                                    fontSize: "11px",
                                    color: "#8898aa",
                                    marginTop: "2px",
                                  }}
                                >
                                  <i className="fas fa-user mr-1" />
                                  UUID: {judge.r_uuid?.substring(0, 8)}...
                                </div>
                              </div>
                            </div>
                            <Badge color="secondary" pill>
                              Assigned
                            </Badge>
                          </div>
                        );
                      }
                    })}
                  </div>
                </div>
              );
            })()}

          {/* Prize Pool Card */}
          {prize.length > 0 && (
            <div style={styles.modalDataBlock}>
              <h6 className="text-uppercase text-muted ls-1 mb-3">
                <i className="fas fa-trophy mr-2" /> Prize Pool
              </h6>
              <Row>
                {prize.map((p, idx) => (
                  <Col
                    key={idx}
                    md={Math.min(6, prize.length)}
                    className="mb-2"
                  >
                    <div
                      className="text-center p-2"
                      style={{ background: "#f0fdf4", borderRadius: "8px" }}
                    >
                      <Badge color="success" className="mb-1">
                        Position {p.position || idx + 1}
                      </Badge>
                      <p className="font-weight-bold mb-0 text-dark">
                        {p.reward || p.prize || "N/A"}
                      </p>
                      {p.description && (
                        <small className="text-muted">{p.description}</small>
                      )}
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          )}

          {/* ─── WINNERS / RESULTS SECTION ─── */}
          {selectedItem.c_result_declared && (
            <div style={styles.modalDataBlock}>
              <h6 className="text-uppercase text-muted ls-1 mb-3">
                <i className="fas fa-trophy text-warning mr-2" /> Winners &
                Results
              </h6>

              <div className="table-responsive">
                <table
                  className="table table-hover align-items-center"
                  style={{ fontSize: "14px" }}
                >
                  <thead className="thead-light">
                    <tr>
                      <th style={{ width: "60px" }}>Rank</th>
                      <th>User</th>
                      <th>Prize</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedItem.c_winners &&
                    selectedItem.c_winners.length > 0 ? (
                      selectedItem.c_winners
                        .sort((a, b) => a.rank - b.rank)
                        .map((winner, idx) => (
                          <tr key={idx}>
                            <td>
                              <div
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "32px",
                                  height: "32px",
                                  borderRadius: "50%",
                                  background:
                                    winner.rank === 1
                                      ? "#fbbf24"
                                      : winner.rank === 2
                                        ? "#94a3b8"
                                        : winner.rank === 3
                                          ? "#cd7f32"
                                          : "#e2e8f0",
                                  color:
                                    winner.rank <= 3 ? "#0f172a" : "#64748b",
                                  fontWeight: 700,
                                  fontSize: "0.75rem",
                                }}
                              >
                                {winner.rank === 1
                                  ? "🥇"
                                  : winner.rank === 2
                                    ? "🥈"
                                    : winner.rank === 3
                                      ? "🥉"
                                      : `#${winner.rank}`}
                              </div>
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <img
                                  src={
                                    winner.user_id?.image
                                      ? winner.user_id.image.startsWith("http")
                                        ? winner.user_id.image
                                        : `https://cradleaibucket.s3.us-east-1.amazonaws.com/users-profile-images/${winner.user_id.image}`
                                      : `https://ui-avatars.com/api/?name=${encodeURIComponent(winner.user_id?.name || "User")}&background=5e72e4&color=fff&size=40`
                                  }
                                  alt={winner.user_id?.name || "User"}
                                  style={{
                                    width: "32px",
                                    height: "32px",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                    marginRight: "12px",
                                    border: "2px solid #e9ecef",
                                  }}
                                  onError={(e) => {
                                    e.currentTarget.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(winner.user_id?.name || "User")}&background=5e72e4&color=fff&size=40`;
                                  }}
                                />
                                <div>
                                  <div className="font-weight-bold text-dark">
                                    {winner.user_id?.name || "Unknown User"}
                                  </div>
                                  <small className="text-muted">
                                    {winner.user_id?.email || ""}
                                  </small>
                                </div>
                              </div>
                            </td>
                            <td>
                              <Badge
                                color="success"
                                pill
                                style={{
                                  fontSize: "13px",
                                  padding: "6px 14px",
                                }}
                              >
                                <i className="fas fa-gift mr-1" />
                                {winner.prize || "N/A"}
                              </Badge>
                            </td>
                          </tr>
                        ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center text-muted py-3">
                          <i className="fas fa-inbox mr-2" />
                          No winners data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Show Result Declared Badge */}
              <div className="mt-3 text-center">
                <Badge
                  color="success"
                  pill
                  style={{ fontSize: "14px", padding: "8px 20px" }}
                >
                  <i className="fas fa-check-circle mr-2" />
                  Results Declared ✓
                </Badge>
              </div>
            </div>
          )}

          {/* Judges Card */}
          {/* {judges.length > 0 && (
                        <div style={styles.modalDataBlock}>
                            <h6 className="text-uppercase text-muted ls-1 mb-3">
                                <i className="fas fa-gavel mr-2" /> Assigned Judges ({judges.length})
                            </h6>
                            <div className="d-flex flex-wrap">
                                {judges.map((judge, idx) => (
                                    <div key={idx} style={styles.judgeChip}>
                                        <i className="fas fa-user-check mr-1" style={{ fontSize: "10px" }} />
                                        {typeof judge === 'object' ? (judge.name || judge.au_name || judge.email || `Judge ${idx + 1}`) : judge}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )} */}

          {/* Evaluation Criteria Card */}
          {criteria.length > 0 && (
            <div style={styles.modalDataBlock}>
              <h6 className="text-uppercase text-muted ls-1 mb-3">
                <i className="fas fa-clipboard-list mr-2" /> Evaluation Criteria
              </h6>
              {criteria.map((criterion, idx) => (
                <div key={idx} style={styles.criteriaCard}>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span className="font-weight-bold">
                      {criterion.title ||
                        criterion.name ||
                        `Criteria ${idx + 1}`}
                    </span>
                    <Badge color="primary" pill>
                      Weight: {criterion.weight || 1}
                    </Badge>
                  </div>
                  <Progress
                    value={criterion.max_score || 100}
                    max={criterion.max_score || 100}
                    className="mb-2"
                    style={{ height: "6px" }}
                  />
                  <div className="d-flex justify-content-between">
                    <small className="text-muted">
                      Max Score: {criterion.max_score || 100}
                    </small>
                    {criterion.description && (
                      <small className="text-muted">
                        {criterion.description}
                      </small>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Attachments Card */}
          {attachments.length > 0 && (
            <div style={styles.modalDataBlock}>
              <h6 className="text-uppercase text-muted ls-1 mb-3">
                <i className="fas fa-paperclip mr-2" />
                Attachments ({attachments.length})
              </h6>

              <div className="row">
                {attachments.map((att, idx) => {
                  const fileUrl = att.file_url?.startsWith("http")
                    ? att.file_url
                    : `${IMAGE_BASE_URL}/user-media/${att.file_url}`;
                  const fileName = att.file_url
                    ? att.file_url.split("/").pop()
                    : `Attachment ${idx + 1}`;

                  const isImage =
                    att.file_url &&
                    /\.(jpg|jpeg|png|gif|webp)$/i.test(att.file_url);

                  return (
                    <div key={idx} className="col-md-4 mb-3">
                      <div
                        style={{
                          border: "1px solid #ddd",
                          borderRadius: "10px",
                          padding: "10px",
                          textAlign: "center",
                          background: "#fff",
                        }}
                      >
                        {/* Image Preview */}
                        {isImage ? (
                          <img
                            src={fileUrl}
                            alt={fileName}
                            style={{
                              width: "100%",
                              height: "180px",
                              objectFit: "cover",
                              borderRadius: "8px",
                              marginBottom: "10px",
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              height: "180px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              background: "#f5f5f5",
                              borderRadius: "8px",
                              marginBottom: "10px",
                            }}
                          >
                            <i
                              className="fas fa-file-pdf"
                              style={{
                                fontSize: "50px",
                                color: "#dc3545",
                              }}
                            />
                          </div>
                        )}

                        {/* File Name */}
                        <p
                          style={{
                            fontSize: "13px",
                            wordBreak: "break-word",
                            marginBottom: "10px",
                          }}
                        >
                          {fileName}
                        </p>

                        {/* View Button */}
                        <a
                          href={fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-primary btn-sm"
                        >
                          <i className="fas fa-eye mr-1"></i>
                          View
                        </a>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          {/* Rules Card */}
          {selectedItem.c_rules && (
            <div style={styles.modalDataBlock}>
              <h6 className="text-uppercase text-muted ls-1 mb-3">
                <i className="fas fa-book mr-2" /> Challenge Rules
              </h6>
              <div
                className="bg-light p-3 rounded"
                style={{ whiteSpace: "pre-wrap" }}
              >
                {selectedItem.c_rules}
              </div>
            </div>
          )}

          <hr />
          {/* <h4 className="mb-3">
                        <i className="fas fa-upload mr-2" /> Submissions ({submissions.length})
                    </h4> */}
          {/* {submissions.length > 0 ? (
                        <div className="table-responsive">
                            <Table className="align-items-center table-flush" size="sm">
                                <thead>
                                    <tr>
                                        <th>User</th>
                                        <th>Status</th>
                                        <th>Reward</th>
                                        <th className="text-right">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {submissions.map(sub => (
                                        <tr key={sub.cs_uuid}>
                                            <td>
                                                <div className="font-weight-bold">{sub.cs_user_id?.name || sub.user_name || "User"}</div>
                                                <small className="text-muted">{sub.cs_user_id?.email}</small>
                                            </td>
                                            <td>
                                                <Badge color={sub.cs_status === "Approved" ? "success" : sub.cs_status === "Rejected" ? "danger" : "warning"}>
                                                    {sub.cs_status || "Pending"}
                                                </Badge>
                                            </td>
                                            <td>
                                                <Badge color={sub.cs_reward_status === "Winner" ? "success" : "secondary"}>
                                                    {sub.cs_reward_status || "None"}
                                                </Badge>
                                            </td>
                                            <td className="text-right">
                                                <UncontrolledDropdown>
                                                    <DropdownToggle size="sm" color="light" outline caret>Judge Actions</DropdownToggle>
                                                    <DropdownMenu right>
                                                        <DropdownItem onClick={() => handleJudge(sub.cs_uuid, "Approved")}>
                                                            <i className="fas fa-check-circle text-success mr-2" /> Approve
                                                        </DropdownItem>
                                                        <DropdownItem onClick={() => handleJudge(sub.cs_uuid, "Rejected")}>
                                                            <i className="fas fa-times-circle text-danger mr-2" /> Reject
                                                        </DropdownItem>
                                                        <DropdownItem divider />
                                                        <DropdownItem onClick={() => handleReward(sub.cs_uuid, "Winner")}>
                                                            <i className="fas fa-trophy text-warning mr-2" /> Mark Winner
                                                        </DropdownItem>
                                                        <DropdownItem onClick={() => handleReward(sub.cs_uuid, "None")}>
                                                            <i className="fas fa-trash text-muted mr-2" /> Remove Reward
                                                        </DropdownItem>
                                                    </DropdownMenu>
                                                </UncontrolledDropdown>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    ) : (
                        <div className="text-center py-4 text-muted">
                            <i className="fas fa-inbox fa-2x mb-2 d-block" />
                            No submissions yet
                        </div>
                </div>
            );
        }
        if (modalType === "referral") {
            return (
                <div className="px-4 pb-4">
                    <h2 className="mb-1 text-dark">Referral Details</h2>
                    <p className="text-muted text-sm mb-4">
                        Referrer: <b>{selectedItem?.referrer_id?.name || selectedItem?.referrer_id || "N/A"}</b> •
                        Status: <Badge color={selectedItem?.reward_status === "credited" ? "success" : "danger"} pill>
                            {selectedItem?.reward_status || "N/A"}
                        </Badge>
                    </p>

                    <Row className="mb-4 text-center">
                        <Col xs="4">
                            <div className="font-weight-bold text-dark" style={{ fontSize: "20px" }}>
                                {selectedItem?.points_amount || 0}
                            </div>
                            <div className="text-xs text-uppercase text-muted">Points Earned</div>
                        </Col>
                        <Col xs="4">
                            <div className="font-weight-bold text-success" style={{ fontSize: "20px" }}>
                                ${selectedItem?.monetary_amount || 0}
                            </div>
                            <div className="text-xs text-uppercase text-muted">Wallet Credits</div>
                        </Col>
                        <Col xs="4">
                            <div className="font-weight-bold text-primary" style={{ fontSize: "16px" }}>
                                {selectedItem?.fraud_flag ? "Flagged" : "Clean"}
                            </div>
                            <div className="text-xs text-uppercase text-muted">Fraud Status</div>
                        </Col>
                    </Row>

                    {/* Additional details */}

          <Row className="mt-3">
            <Col>
              {/* <Button
                                block
                                color="primary"
                                onClick={() => {
                                    // Handle Adjust Points logic
                                    Swal.fire("Adjust Points", `Adjusting points for ${selectedItem?.referrer_id?.name || selectedItem?.referrer_id}`, "info");
                                }}
                                style={{ height: "100%" }}
                            >
                                Adjust Points
                            </Button> */}
            </Col>
            <Col>
              {/* <Button
                                block
                                color="danger"
                                onClick={() => {
                                    // Handle Revoke Bonus logic
                                    Swal.fire({
                                        title: "Revoke Bonus?",
                                        text: `Are you sure you want to revoke the bonus for ${selectedItem?.referrer_id?.name || selectedItem?.referrer_id}?`,
                                        icon: "warning",
                                        showCancelButton: true,
                                        confirmButtonColor: "#f5365c",
                                        confirmButtonText: "Yes, revoke"
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            // Update local state or call API
                                            Swal.fire("Revoked!", "Bonus has been revoked.", "success");
                                        }
                                    });
                                }}
                                disabled={selectedItem?.reward_status === "blocked"}
                                style={{ height: "100%" }}
                            >
                                Revoke Bonus
                            </Button> */}
            </Col>
          </Row>
        </div>
      );
    }
    if (modalType === "referral" && selectedItem) {
      return (
        <div className="px-4 pb-4">
          <h2 className="mb-1 text-dark">Referral Details</h2>

          <div className="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom mt-3">
            <div>
              <p className="text-muted text-xs text-uppercase ls-1 mb-1">
                Referrer
              </p>
              <h5 className="mb-0 font-weight-bold">
                {selectedItem?.referrer_id?.name ||
                  selectedItem?.referrer_id?.email ||
                  "Unknown"}
              </h5>
            </div>
            <div className="text-right">
              <p className="text-muted text-xs text-uppercase ls-1 mb-1">
                Referred User
              </p>
              <h5 className="mb-0 font-weight-bold">
                {selectedItem?.referred_user_id?.name ||
                  selectedItem?.referred_user_id?.email ||
                  "Unknown"}
              </h5>
            </div>
          </div>

          <Row className="mb-4 text-center">
            <Col xs="4">
              <div className="text-muted text-uppercase text-xs mb-1">
                Points
              </div>
              <div
                className="font-weight-bold text-primary"
                style={{ fontSize: 22 }}
              >
                {selectedItem?.points_amount || 0}
              </div>
            </Col>
            <Col xs="4">
              <div className="text-muted text-uppercase text-xs mb-1">
                Wallet
              </div>
              <div
                className="font-weight-bold text-success"
                style={{ fontSize: 22 }}
              >
                ${selectedItem?.monetary_amount || 0}
              </div>
            </Col>
            <Col xs="4">
              <div className="text-muted text-uppercase text-xs mb-1">
                Status
              </div>
              <Badge
                color={
                  selectedItem?.reward_status === "credited"
                    ? "success"
                    : selectedItem?.reward_status === "pending"
                      ? "warning"
                      : selectedItem?.reward_status === "blocked"
                        ? "danger"
                        : "secondary"
                }
                pill
              >
                {selectedItem?.reward_status || "Unknown"}
              </Badge>
            </Col>
          </Row>

          <Row className="text-center">
            <Col xs="6">
              <div className="text-muted text-uppercase text-xs mb-1">
                Country Route
              </div>
              <div className="font-weight-bold text-dark">
                {selectedItem?.country_referrer || "Unknown"} &rarr;{" "}
                {selectedItem?.country_referred || "Unknown"}
              </div>
            </Col>
            <Col xs="6">
              <div className="text-muted text-uppercase text-xs mb-1">
                Fraud Status
              </div>
              {selectedItem?.fraud_flag ? (
                <div>
                  <Badge color="danger" pill>
                    Fraud Detected
                  </Badge>
                  {selectedItem?.fraud_reason && (
                    <div className="text-danger mt-1 text-xs">
                      {selectedItem?.fraud_reason}
                    </div>
                  )}
                </div>
              ) : (
                <Badge color="success" pill>
                  Clean
                </Badge>
              )}
            </Col>
          </Row>
        </div>
      );
    }
    if (modalType === "membership") {
      const sub = selectedItem;
      return (
        <div className="px-4 pb-4">
          {/* Header Details with Avatar and Name */}
          <div className="d-flex align-items-center mb-4 pb-3 border-bottom">
            <Avatar
              src={sub?.user?.image}
              name={sub?.user?.name || "Unknown User"}
              size="lg"
              className="mr-3"
              style={{ width: "64px", height: "64px" }}
            />
            <div>
              <h3 className="mb-0 text-dark font-weight-bold">
                {sub?.user?.name || "Unknown User"}
              </h3>
              <p className="text-muted text-sm mb-0">
                {sub?.user?.email || "N/A"}
              </p>
            </div>
          </div>

          <h4 className="mb-3 text-dark font-weight-bold">
            <i className="fa fa-gem text-teal mr-2" /> Subscription Details
          </h4>

          <div style={styles.modalDataBlock}>
            <Row>
              <Col md="6" className="mb-3">
                <span className="text-sm text-muted d-block font-weight-500">
                  Channel Hub
                </span>
                <span className="font-weight-bold text-dark">
                  {sub?.channel?.channel_name || sub?.title || "—"}
                </span>
              </Col>
              <Col md="6" className="mb-3">
                <span className="text-sm text-muted d-block font-weight-500">
                  Membership Tier
                </span>
                <Badge
                  color="primary"
                  pill
                  style={{ fontSize: "12px", padding: "5px 10px" }}
                >
                  {sub?.membershipTier?.title || sub?.title || "—"}
                </Badge>
              </Col>
              <Col md="6" className="mb-3">
                <span className="text-sm text-muted d-block font-weight-500">
                  Price Paid
                </span>
                <strong className="text-dark" style={{ fontSize: "16px" }}>
                  ${(sub?.price || 0).toLocaleString()}
                </strong>
              </Col>
              <Col md="6" className="mb-3">
                <span className="text-sm text-muted d-block font-weight-500">
                  Status
                </span>
                {(() => {
                  let displayStatus = sub?.status || "inactive";
                  if (sub?.cancellationReason) {
                    displayStatus =
                      sub.cancellationReason === "upgraded"
                        ? "upgraded"
                        : "cancelled";
                  }
                  return (
                    <Badge
                      color={
                        displayStatus === "active"
                          ? "success"
                          : displayStatus === "cancelled"
                            ? "danger"
                            : displayStatus === "upgraded"
                              ? "info"
                              : "warning"
                      }
                      pill
                      style={{ fontSize: "12px", padding: "5px 10px" }}
                    >
                      {displayStatus}
                    </Badge>
                  );
                })()}
              </Col>
              <Col md="6" className="mb-3">
                <span className="text-sm text-muted d-block font-weight-500">
                  Purchase Date
                </span>
                <span className="text-dark font-weight-500">
                  {sub?.buyDate
                    ? new Date(sub.buyDate).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      })
                    : "N/A"}
                </span>
              </Col>
              <Col md="6" className="mb-3">
                <span className="text-sm text-muted d-block font-weight-500">
                  Expiry Date
                </span>
                <span className="text-dark font-weight-500">
                  {sub?.expireDate
                    ? new Date(sub.expireDate).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      })
                    : "N/A"}
                </span>
              </Col>
            </Row>
          </div>

          {/* Cancellation Block if Cancelled */}
          {(sub?.status === "cancelled" || sub?.cancellationReason) && (
            <div className="mt-4">
              <h4 className="mb-3 text-danger font-weight-bold">
                <i className="fa fa-ban mr-2" /> Cancellation Info
              </h4>
              <div
                style={{
                  ...styles.modalDataBlock,
                  borderLeft: "4px solid #f5365c",
                }}
              >
                <Row>
                  <Col md="6" className="mb-3">
                    <span className="text-sm text-muted d-block font-weight-500">
                      Cancellation Reason
                    </span>
                    <span className="font-weight-bold text-dark">
                      {cancellationReasons[sub?.cancellationReason] ||
                        sub?.cancellationReason ||
                        "N/A"}
                    </span>
                  </Col>
                  <Col md="6" className="mb-3">
                    <span className="text-sm text-muted d-block font-weight-500">
                      Cancelled At
                    </span>
                    <span className="text-dark font-weight-500">
                      {sub?.cancelledAt
                        ? new Date(sub.cancelledAt).toLocaleDateString(
                            "en-US",
                            {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            },
                          )
                        : "N/A"}
                    </span>
                  </Col>
                  {sub?.cancellationFeedback && (
                    <Col md="12">
                      <span className="text-sm text-muted d-block font-weight-500">
                        Cancellation Feedback
                      </span>
                      <div
                        className="p-3 bg-light rounded text-dark text-sm mt-1 border"
                        style={{ fontStyle: "italic" }}
                      >
                        "{sub.cancellationFeedback}"
                      </div>
                    </Col>
                  )}
                </Row>
              </div>
            </div>
          )}

          <div className="mt-4">
            <h4 className="mb-3 text-dark font-weight-bold">
              <i className="fa fa-clock mr-2 text-primary" /> System Metadata
            </h4>
            <div style={styles.modalDataBlock}>
              <Row>
                <Col md="6">
                  <span className="text-sm text-muted d-block font-weight-500">
                    Record Created At
                  </span>
                  <span className="text-dark text-sm">
                    {sub?.createdAt
                      ? new Date(sub.createdAt).toLocaleString("en-US")
                      : "N/A"}
                  </span>
                </Col>
                <Col md="6">
                  <span className="text-sm text-muted d-block font-weight-500">
                    Record Last Updated
                  </span>
                  <span className="text-dark text-sm">
                    {sub?.updatedAt
                      ? new Date(sub.updatedAt).toLocaleString("en-US")
                      : "N/A"}
                  </span>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      );
    }

    return null;
  };

  const renderOverviewCards = () => {
    if (statsLoading) {
      return (
        <Row className="mb-4">
          <Col className="text-center py-4">
            <Spinner color="primary" />
          </Col>
        </Row>
      );
    }

    if (activeTab === "Innovation Boards") {
      return (
        <Row className="mb-4">
          <Col lg="4">
            <div style={styles.statCard}>
              <h5 className="text-uppercase text-muted ls-1 mb-1">
                Ideas Funded
              </h5>
              <h3 className="mb-0 text-dark" style={{ fontSize: "28px" }}>
                {dashboardStats.fundedIdeasCount}
              </h3>
              <div className="text-success text-sm font-weight-bold mt-2">
                <i className="fas fa-check-circle mr-1" /> Funded Pitches
              </div>
            </div>
          </Col>
          <Col lg="4">
            <div style={styles.statCard}>
              <h5 className="text-uppercase text-muted ls-1 mb-1">
                Active Funding
              </h5>
              <h3 className="mb-0 text-dark" style={{ fontSize: "28px" }}>
                ${dashboardStats.totalFundingAmount.toLocaleString()}
              </h3>
              <div className="text-primary text-sm font-weight-bold mt-2">
                <i className="fas fa-dollar-sign mr-1" /> Total Received Funding
              </div>
            </div>
          </Col>
          <Col lg="4">
            <div style={styles.statCard}>
              <h5 className="text-uppercase text-muted ls-1 mb-1">
                Total Ideas
              </h5>
              <h3 className="mb-0 text-dark" style={{ fontSize: "28px" }}>
                {dashboardStats.totalIdeas}
              </h3>
              <div className="text-warning text-sm font-weight-bold mt-2">
                <i className="fas fa-lightbulb mr-1" /> Total Pitches Submitted
              </div>
            </div>
          </Col>
        </Row>
      );
    }

    if (activeTab === "Challenges") {
      return (
        <Row className="mb-4">
          <Col lg="4">
            <div style={styles.statCard}>
              <h5 className="text-uppercase text-muted ls-1 mb-1">
                Total Challenges
              </h5>
              <h3 className="mb-0 text-dark" style={{ fontSize: "28px" }}>
                {dashboardStats.totalChallenges}
              </h3>
              <div className="text-primary text-sm font-weight-bold mt-2">
                <i className="fas fa-trophy mr-1" /> All Contests & Hackathons
              </div>
            </div>
          </Col>
          <Col lg="4">
            <div style={styles.statCard}>
              <h5 className="text-uppercase text-muted ls-1 mb-1">
                Total Submissions
              </h5>
              <h3 className="mb-0 text-dark" style={{ fontSize: "28px" }}>
                {dashboardStats.totalSubmissions}
              </h3>
              <div className="text-success text-sm font-weight-bold mt-2">
                <i className="fas fa-file-upload mr-1" /> Uploaded Entries
              </div>
            </div>
          </Col>
          <Col lg="4">
            <div style={styles.statCard}>
              <h5 className="text-uppercase text-muted ls-1 mb-1">
                Completed Challenges
              </h5>
              <h3 className="mb-0 text-dark" style={{ fontSize: "28px" }}>
                {dashboardStats.completedChallenges}
              </h3>
              <div className="text-warning text-sm font-weight-bold mt-2">
                <i className="fas fa-flag-checkered mr-1" /> Concluded Contests
              </div>
            </div>
          </Col>
        </Row>
      );
    }

    if (activeTab === "Creator Channels") {
      return (
        <Row className="mb-4">
          <Col lg="4">
            <div style={styles.statCard}>
              <h5 className="text-uppercase text-muted ls-1 mb-1">
                Total Creators
              </h5>
              <h3 className="mb-0 text-dark" style={{ fontSize: "28px" }}>
                {dashboardStats.totalCreators}
              </h3>
              <div className="text-primary text-sm font-weight-bold mt-2">
                <i className="fas fa-video mr-1" /> Channel Applications
              </div>
            </div>
          </Col>
          <Col lg="4">
            <div style={styles.statCard}>
              <h5 className="text-uppercase text-muted ls-1 mb-1">
                Active Creators
              </h5>
              <h3 className="mb-0 text-dark" style={{ fontSize: "28px" }}>
                {dashboardStats.activeCreators}
              </h3>
              <div className="text-success text-sm font-weight-bold mt-2">
                <i className="fas fa-user-check mr-1" /> Approved Creator
                Channels
              </div>
            </div>
          </Col>
          <Col lg="4">
            <div style={styles.statCard}>
              <h5 className="text-uppercase text-muted ls-1 mb-1">
                Pending Creators
              </h5>
              <h3 className="mb-0 text-dark" style={{ fontSize: "28px" }}>
                {Math.max(
                  0,
                  dashboardStats.totalCreators - dashboardStats.activeCreators,
                )}
              </h3>
              <div className="text-warning text-sm font-weight-bold mt-2">
                <i className="fas fa-clock mr-1" /> Awaiting Review
              </div>
            </div>
          </Col>
        </Row>
      );
    }

    if (activeTab === "Referral Tracker") {
      return (
        <Row className="mb-4">
          <Col lg="4">
            <div style={styles.statCard}>
              <h5 className="text-uppercase text-muted ls-1 mb-1">
                Total Referrals
              </h5>
              <h3 className="mb-0 text-dark" style={{ fontSize: "28px" }}>
                {dashboardStats.totalReferrals}
              </h3>
              <div className="text-primary text-sm font-weight-bold mt-2">
                <i className="fas fa-users mr-1" /> Invitations Sent
              </div>
            </div>
          </Col>
          <Col lg="4">
            <div style={styles.statCard}>
              <h5 className="text-uppercase text-muted ls-1 mb-1">
                Total Bonuses Paid
              </h5>
              <h3 className="mb-0 text-dark" style={{ fontSize: "28px" }}>
                {dashboardStats.totalBonusesPaid}
              </h3>
              <div className="text-success text-sm font-weight-bold mt-2">
                <i className="fas fa-gift mr-1" /> Credited Referral Rewards
              </div>
            </div>
          </Col>
          <Col lg="4">
            <div style={styles.statCard}>
              <h5 className="text-uppercase text-muted ls-1 mb-1">
                Cross-Country Bonuses
              </h5>
              <h3 className="mb-0 text-dark" style={{ fontSize: "28px" }}>
                {dashboardStats.crossCountryBonuses}
              </h3>
              <div className="text-warning text-sm font-weight-bold mt-2">
                <i className="fas fa-globe mr-1" /> Global Invites Credited
              </div>
            </div>
          </Col>
        </Row>
      );
    }

    return null;
  };

  return (
    <>
      <CommonHeader />
      <Container
        className="mt--7"
        fluid
        style={{ position: "relative", zIndex: 1, overflowX: "hidden" }}
      >
        {/* ── Referral & Global Stats Overview ─────────────────────── */}
        {renderOverviewCards()}
        {/* ── Tabs Navigation ─────────────────────── */}
        <div className="flex-wrap admn-bttn" style={styles.filterBar}>
          {[
            "Innovation Boards",
            "Challenges",
            "Creator Channels",
            "Referral Tracker",
            "User Memberships",
            "Gift Config",
            "Packages",
          ].map((tab) => (
            <div
              key={tab}
              style={{
                ...styles.filterPill,
                ...(activeTab === tab ? styles.filterPillActive : {}),
              }}
              onClick={() => {
                setActiveTab(tab);
                if (tab === "Gift Config") {
                  fetchGiftConfig();
                }
              }}
            >
              <i
                className={`fas ${
                  tab === "Innovation Boards"
                    ? "fa-lightbulb"
                    : tab === "Challenges"
                      ? "fa-trophy"
                      : tab === "Creator Channels"
                        ? "fa-video"
                        : tab === "Referral Tracker"
                          ? "fa-users"
                          : tab === "User Memberships"
                            ? "fa-user-check"
                            : tab === "Gift Config"
                              ? "fa-gift"
                              : tab === "Packages"
                                ? "fa-box-open"
                                : ""
                }`}
              />
              {tab}
            </div>
          ))}
        </div>

        {/* ── Main Workspaces ─────────────────────── */}
        <TabContent activeTab={activeTab}>
          {/* ──── TAB: Innovation Boards ──── */}
          {/* ──── TAB: Innovation Boards ──── */}
          <TabPane tabId="Innovation Boards">
            <Card
              className="shadow"
              style={{
                borderRadius: "16px",
                border: "none",
                overflow: "visible",
              }}
            >
              <CardHeader
                className="border-0 bg-white"
                style={{ borderRadius: "16px 16px 0 0", padding: "24px" }}
              >
                <Row className="align-items-center">
                  <Col xs="12" md="6" className="mb-3 mb-md-0">
                    <h3 className="mb-0 text-dark font-weight-700">
                      <i className="ni ni-world text-teal mr-2" />
                      Innovation Pitch Pipeline
                    </h3>
                  </Col>

                  <Col
                    xs="12"
                    md="6"
                    className="d-flex justify-content-md-end justify-content-center"
                  >
                    <Button
                      color="primary"
                      size="sm"
                      className="changes-btn"
                      onClick={() => setChangesModalOpen(true)}
                    >
                      <i className="fas fa-edit mr-2" />
                      Changes Request
                    </Button>
                  </Col>
                </Row>
                {/* Add Search and Filter Row */}
                <Row className="mt-3">
                  <Col md="6">
                    <InputGroup className="input-group-alternative">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fas fa-search" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Search by title, category, or author name..."
                        type="text"
                        value={innovationBoardsSearch}
                        onChange={(e) => {
                          setInnovationBoardsSearch(e.target.value);
                          setInnovationBoardsPage(1);
                        }}
                      />
                    </InputGroup>
                  </Col>
                  <Col md="3">
                    <Input
                      type="select"
                      value={innovationBoardsStatus}
                      onChange={(e) => {
                        setInnovationBoardsStatus(e.target.value);
                        setInnovationBoardsPage(1);
                      }}
                      style={{
                        borderRadius: "8px",
                        border: "1px solid #e0e0e0",
                        height: "44px",
                        fontSize: "14px",
                      }}
                    >
                      <option value="">All Statuses</option>
                      <option value="open">Open</option>
                      <option value="funded">Funded</option>
                      <option value="closed">Closed</option>
                    </Input>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody className="p-0">
                {innovationBoardsLoading ? (
                  <div className="text-center py-5">
                    <Spinner
                      color="primary"
                      style={{ width: "3rem", height: "3rem" }}
                    />
                    <p className="text-muted mt-3">
                      Loading innovation boards...
                    </p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <Table className="align-items-center table-flush" hover>
                      <thead className="thead-light">
                        <tr>
                          <th scope="col" style={{ padding: "16px 24px" }}>
                            Idea Title
                          </th>
                          <th scope="col">Author</th>
                          <th scope="col">Category</th>
                          <th scope="col">Funding Needed</th>
                          <th scope="col">Funding Received</th>
                          <th scope="col">Skills</th>
                          <th scope="col">Status</th>
                          <th scope="col">Views</th>
                          <th
                            scope="col"
                            className="text-right"
                            style={{ paddingRight: "24px" }}
                          >
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {innovationBoards.length > 0 ? (
                          innovationBoards.map((item) => (
                            <tr key={item._id} style={styles.tableRow}>
                              <td style={{ padding: "16px 24px" }}>
                                <span className="font-weight-bold text-dark d-block">
                                  {item.title}
                                </span>
                                {/* <small className="text-muted">ID: {item.uuid?.substring(0, 8)}...</small> */}
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <img
                                    src={
                                      getUserImage(item?.created_by) ||
                                      `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                        item?.created_by?.name || "User",
                                      )}&background=random&color=fff`
                                    }
                                    alt={item?.created_by?.name || "User"}
                                    className="rounded-circle mr-2"
                                    style={{
                                      width: "32px",
                                      height: "32px",
                                      minWidth: "32px",
                                      objectFit: "cover",
                                      border: "1px solid #e9ecef",
                                    }}
                                    onError={(e) => {
                                      e.currentTarget.onerror = null;
                                      e.currentTarget.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                        item?.created_by?.name || "User",
                                      )}&background=random&color=fff`;
                                    }}
                                  />

                                  <div>
                                    <div style={{ fontWeight: 600 }}>
                                      {item.created_by?.name || "Unknown User"}
                                    </div>

                                    <small className="text-muted">
                                      {item.created_by?.email || ""}
                                    </small>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <Badge color="info" pill>
                                  {item.category || "N/A"}
                                </Badge>
                              </td>
                              <td className="font-weight-bold">
                                ${item.funding_needed || 0}
                              </td>
                              <td className="text-success font-weight-bold">
                                ${item.funding_received || 0}
                              </td>
                              <td>
                                <div className="d-flex flex-wrap gap-1">
                                  {item.skills_needed
                                    ?.slice(0, 2)
                                    .map((skill, idx) => (
                                      <span key={idx} style={styles.tag}>
                                        {skill}
                                      </span>
                                    ))}
                                  {item.skills_needed?.length > 2 && (
                                    <span
                                      className="text-muted"
                                      style={{ fontSize: "10px" }}
                                    >
                                      +{item.skills_needed.length - 2}
                                    </span>
                                  )}
                                </div>
                              </td>
                              <td>
                                <Badge
                                  color={
                                    item.status === "funded"
                                      ? "success"
                                      : item.status === "open"
                                        ? "primary"
                                        : "secondary"
                                  }
                                  pill
                                >
                                  {item.status || "open"}
                                </Badge>
                              </td>
                              <td>
                                <i className="fas fa-eye text-muted mr-1" />{" "}
                                {item.views || 0}
                              </td>
                              <td
                                className="text-right"
                                style={{ paddingRight: "24px" }}
                              >
                                <Button
                                  color="info"
                                  outline
                                  size="sm"
                                  onClick={(e) =>
                                    openModal(
                                      "idea",
                                      {
                                        id: item._id,
                                        title: item.title,
                                        author:
                                          item.created_by?.name ||
                                          "Unknown User",
                                        category: item.category,
                                        upvotes: item.upvotes || 0,
                                        views: item.views || 0,
                                        investments: item.funding_received,
                                        status: item.status,
                                        comments: item.comments || 0,
                                        description: item.description,
                                        skills_needed: item.skills_needed,
                                        funding_needed: item.funding_needed,
                                      },
                                      e,
                                    )
                                  }
                                >
                                  View Details
                                </Button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan="9"
                              className="text-center py-4 text-muted"
                            >
                              No innovation boards found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                )}
              </CardBody>
              {/* Pagination for Innovation Boards */}
              {innovationBoardsTotal > innovationBoardsLimit && (
                <CardFooter className="py-4 border-top bg-transparent d-flex justify-content-between align-items-center flex-wrap">
                  <span className="text-muted small">
                    Showing{" "}
                    {(innovationBoardsPage - 1) * innovationBoardsLimit + 1} to{" "}
                    {Math.min(
                      innovationBoardsPage * innovationBoardsLimit,
                      innovationBoardsTotal,
                    )}{" "}
                    of {innovationBoardsTotal} ideas
                  </span>
                  <nav aria-label="...">
                    <Pagination
                      className="pagination justify-content-end mb-0"
                      listClassName="justify-content-end mb-0"
                    >
                      <PaginationItem disabled={innovationBoardsPage <= 1}>
                        <PaginationLink
                          href="#pablo"
                          onClick={(e) => {
                            e.preventDefault();
                            setInnovationBoardsPage(innovationBoardsPage - 1);
                          }}
                          tabIndex="-1"
                        >
                          <i className="fas fa-angle-left" />
                        </PaginationLink>
                      </PaginationItem>
                      {renderPaginationItems(
                        innovationBoardsPage,
                        innovationBoardsTotal,
                        innovationBoardsLimit,
                        setInnovationBoardsPage,
                      )}
                      <PaginationItem
                        disabled={
                          innovationBoardsPage >=
                          Math.ceil(
                            innovationBoardsTotal / innovationBoardsLimit,
                          )
                        }
                      >
                        <PaginationLink
                          href="#pablo"
                          onClick={(e) => {
                            e.preventDefault();
                            setInnovationBoardsPage(innovationBoardsPage + 1);
                          }}
                        >
                          <i className="fas fa-angle-right" />
                        </PaginationLink>
                      </PaginationItem>
                    </Pagination>
                  </nav>
                </CardFooter>
              )}
            </Card>
          </TabPane>

          {/* ──── TAB: Challenges ──── */}
          <TabPane tabId="Challenges">
            <Card
              className="shadow"
              style={{
                borderRadius: "16px",
                border: "none",
                overflow: "visible",
              }}
            >
              <CardHeader
                className="border-0 bg-white"
                style={{ borderRadius: "16px 16px 0 0", padding: "24px" }}
              >
                <Row className="align-items-center">
                  <Col>
                    <h3 className="mb-0 text-dark font-weight-700">
                      <i className="ni ni-world text-teal mr-2" /> Hackathon &
                      Bounties Manager
                    </h3>
                  </Col>
                  <Col className="text-right">
                    <Button
                      color="warning"
                      size="sm"
                      className="mr-2"
                      onClick={openJoinRequestsModal}
                    >
                      <i className="fas fa-user-clock mr-2" /> User Requests
                    </Button>
                    {/* <Button color="primary" size="sm" onClick={() => openModal("createChallenge", null)}>
                                            <i className="fas fa-plus mr-2" /> Add Challenge
                                        </Button> */}
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md="6">
                    <InputGroup className="input-group-alternative">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fas fa-search" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Search by name or sponsor..."
                        type="text"
                        value={challengesSearch}
                        onChange={(e) => {
                          setChallengesSearch(e.target.value);
                          setChallengesPage(1);
                        }}
                      />
                    </InputGroup>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody className="p-0">
                <div className="table-responsive">
                  <Table className="align-items-center table-flush" hover>
                    <thead className="thead-light">
                      <tr>
                        <th style={{ padding: "16px 24px" }}>Challenge Name</th>
                        <th>Category</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Deadline</th>
                        <th>status</th>
                        <th
                          className="text-right"
                          style={{ paddingRight: "24px" }}
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="8" className="text-center py-4">
                            <i className="fas fa-spinner fa-spin fa-2x text-primary" />
                          </td>
                        </tr>
                      ) : challenges.length > 0 ? (
                        challenges.map((item) => (
                          <tr key={item.c_uuid}>
                            <td style={{ padding: "16px 24px" }}>
                              <span className="font-weight-bold text-dark d-block">
                                {item.c_name}
                              </span>

                              <span className="text-xs text-muted">
                                {categoryMap[item.c_category] || ""}
                              </span>

                              {item.c_status === "Draft" && (
                                <Badge
                                  color="warning"
                                  pill
                                  className="ml-2"
                                ></Badge>
                              )}
                            </td>

                            <td>
                              <Badge color="info" pill>
                                {item.c_category || "General"}
                              </Badge>
                            </td>
                            <td className="text-muted">
                              {item.c_start_date
                                ? new Date(
                                    item.c_start_date,
                                  ).toLocaleDateString()
                                : "N/A"}
                            </td>
                            <td className="text-muted">
                              {item.c_end_date
                                ? new Date(item.c_end_date).toLocaleDateString()
                                : "N/A"}
                            </td>
                            <td className="text-muted">
                              {item.c_deadline
                                ? new Date(item.c_deadline).toLocaleDateString()
                                : "N/A"}
                            </td>
                            <td>
                              <Badge
                                color={
                                  item.c_status === "Active"
                                    ? "success"
                                    : item.c_status === "Draft"
                                      ? "warning"
                                      : item.c_status === "Completed"
                                        ? "dark"
                                        : item.c_status === "Judging Phase"
                                          ? "info"
                                          : "secondary"
                                }
                                pill
                              >
                                {item.c_status}
                              </Badge>
                            </td>
                            <td
                              className="text-right"
                              style={{ paddingRight: "24px" }}
                            >
                              <UncontrolledDropdown>
                                <DropdownToggle
                                  size="sm"
                                  color="light"
                                  className="btn-icon-only shadow-sm"
                                  style={{
                                    background: "#fff",
                                    border: "none",
                                    borderRadius: "8px",
                                    color: "#6c757d",
                                    width: "32px",
                                    height: "32px",
                                    padding: 0,
                                    boxShadow:
                                      "0 1px 3px rgba(0,0,0,0.08), 0 4px 6px rgba(50,50,93,0.11)",
                                  }}
                                >
                                  <i className="fas fa-ellipsis-v" />
                                </DropdownToggle>

                                <DropdownMenu right container="body">
                                  {/* View Challenge */}
                                  <DropdownItem
                                    onClick={(e) =>
                                      openModal("challenge", item, e)
                                    }
                                  >
                                    <i className="fas fa-eye text-info mr-2" />
                                    View Details
                                  </DropdownItem>

                                  {/* Add Judges */}
                                  <DropdownItem
                                    onClick={() => handleOpenJudgesModal(item)}
                                  >
                                    <i className="fas fa-gavel text-primary mr-2" />
                                    Judges
                                  </DropdownItem>

                                  <DropdownItem divider />

                                  {/* Activate (only if Draft) */}
                                  {item.c_status === "Draft" && (
                                    <DropdownItem
                                      onClick={() => handleStatusUpdate(item)}
                                    >
                                      <i className="fas fa-check text-success mr-2" />
                                      Make Active
                                    </DropdownItem>
                                  )}
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </td>

                            <td
                              className="text-right"
                              style={{ paddingRight: "24px" }}
                            >
                              {/* Status Button */}
                              {/*   {item.c_status === "Draft" && (
                                                                <Button
                                                                    color="success"
                                                                    outline
                                                                    size="sm"
                                                                    onClick={() => handleStatusUpdate(item)}
                                                                >
                                                                    <i className="fas fa-check mr-1" />
                                                                    Active
                                                                </Button>
                                                            )}*/}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="8"
                            className="text-center py-4 text-muted"
                          >
                            No challenges found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </CardBody>
              <CardFooter className="py-4 border-top bg-transparent d-flex justify-content-between align-items-center flex-wrap">
                <span className="text-muted small">
                  Showing {(challengesPage - 1) * challengesLimit + 1} to{" "}
                  {Math.min(challengesPage * challengesLimit, challengesTotal)}{" "}
                  of {challengesTotal} challenges
                </span>
                {challengesTotal > challengesLimit && (
                  <nav aria-label="...">
                    <Pagination
                      className="pagination justify-content-end mb-0"
                      listClassName="justify-content-end mb-0"
                    >
                      <PaginationItem disabled={challengesPage <= 1}>
                        <PaginationLink
                          href="#pablo"
                          onClick={(e) => {
                            e.preventDefault();
                            setChallengesPage(challengesPage - 1);
                          }}
                          tabIndex="-1"
                        >
                          <i className="fas fa-angle-left" />
                        </PaginationLink>
                      </PaginationItem>
                      {renderPaginationItems(
                        challengesPage,
                        challengesTotal,
                        challengesLimit,
                        setChallengesPage,
                      )}
                      <PaginationItem
                        disabled={
                          challengesPage >=
                          Math.ceil(challengesTotal / challengesLimit)
                        }
                      >
                        <PaginationLink
                          href="#pablo"
                          onClick={(e) => {
                            e.preventDefault();
                            setChallengesPage(challengesPage + 1);
                          }}
                        >
                          <i className="fas fa-angle-right" />
                        </PaginationLink>
                      </PaginationItem>
                    </Pagination>
                  </nav>
                )}
              </CardFooter>
            </Card>
          </TabPane>

          {/* ──── TAB: Creator Channels ──── */}
          <TabPane tabId="Creator Channels">
            <Card
              className="shadow"
              style={{
                borderRadius: "16px",
                border: "none",
                overflow: "visible",
              }}
            >
              <CardHeader
                className="border-0 bg-white"
                style={{ borderRadius: "16px 16px 0 0", padding: "24px" }}
              >
                <Row className="align-items-center">
                  <Col>
                    <h3 className="mb-0 text-dark font-weight-700">
                      <i className="ni ni-world text-teal mr-2" /> Creator
                      Channel Moderation
                    </h3>
                  </Col>
                  {/* <Col className="text-right">
                                        <Button color="primary" size="sm" outline>+ Invite Partner</Button>
                                    </Col> */}
                </Row>

                {/* Search and Filter Bar */}
                <Row className="mt-3">
                  <Col md="6">
                    <InputGroup className="input-group-alternative">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fas fa-search" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Search by channel name ..."
                        type="text"
                        value={channelsSearch}
                        onChange={(e) => {
                          setChannelsSearch(e.target.value);
                          setChannelsPage(1);
                        }}
                      />
                    </InputGroup>
                  </Col>
                  {/* <Col md="3">
                                        <Input
                                            type="select"
                                            value={channelsStatus}
                                            onChange={(e) => {
                                                setChannelsStatus(e.target.value);
                                                setChannelsPage(1);
                                            }}
                                            style={{ borderRadius: "8px", border: "1px solid #e0e0e0", height: "44px", fontSize: "14px" }}
                                        >
                                            <option value="">All Status</option>
                                            <option value="live">Live</option>
                                            <option value="active">Active</option>
                                            <option value="pending">Pending</option>
                                        </Input>
                                    </Col> */}
                  {/* <Col md="3">
                                        <Button
                                            color="light"
                                            size="sm"
                                            onClick={() => {
                                                setChannelsSearch("");
                                                setChannelsStatus("");
                                                setChannelsPage(1);
                                            }}
                                            style={{ height: "44px", width: "100%" }}
                                        >
                                            <i className="fas fa-redo-alt mr-1" /> Reset Filters
                                        </Button>
                                    </Col> */}
                </Row>
              </CardHeader>

              <CardBody className="p-0">
                {channelsLoading ? (
                  <div className="text-center py-5">
                    <Spinner
                      color="primary"
                      style={{ width: "3rem", height: "3rem" }}
                    />
                    <p className="text-muted mt-3">Loading channels...</p>
                  </div>
                ) : channels.length > 0 ? (
                  <>
                    <div className="table-responsive">
                      <Table className="align-items-center table-flush" hover>
                        <thead className="thead-light">
                          <tr>
                            <th style={{ padding: "16px 24px" }}>Channel</th>
                            <th>Creator</th>
                            <th>Category</th>
                            <th>Created At</th>
                            <th
                              className="text-right"
                              style={{ paddingRight: "24px" }}
                            >
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {channels.map((item) => (
                            <tr key={item._id} style={styles.tableRow}>
                              {/* CHANNEL */}
                              <td style={{ padding: "16px 24px" }}>
                                <div className="d-flex align-items-center">
                                  <img
                                    src={
                                      item.image
                                        ? item.image.startsWith("http")
                                          ? item.image
                                          : `https://cradleaibucket.s3.us-east-1.amazonaws.com/user-media/${item.image}`
                                        : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                            item.name || "Channel",
                                          )}&background=random&color=fff`
                                    }
                                    alt="channel"
                                    width="40"
                                    height="40"
                                    style={{
                                      borderRadius: "8px",
                                      objectFit: "cover",
                                      marginRight: "10px",
                                    }}
                                    onError={(e) => {
                                      e.currentTarget.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                        item.name || "Channel",
                                      )}&background=random&color=fff`;
                                    }}
                                  />
                                  <div>
                                    <span className="font-weight-bold text-dark">
                                      {item.name}
                                    </span>
                                    {item.slug && (
                                      <div
                                        className="text-muted"
                                        style={{ fontSize: "11px" }}
                                      >
                                        {item.slug}
                                      </div>
                                    )}
                                    {item.status === "live" && (
                                      <Badge
                                        color="danger"
                                        className="ml-2"
                                        style={{ fontSize: "10px" }}
                                      >
                                        LIVE
                                      </Badge>
                                    )}
                                  </div>
                                </div>
                              </td>

                              {/* CREATOR */}
                              <td>
                                <div className="d-flex align-items-center">
                                  <img
                                    src={
                                      item.createdBy?.image
                                        ? item.createdBy.image.startsWith(
                                            "http",
                                          )
                                          ? item.createdBy.image
                                          : `https://cradleaibucket.s3.us-east-1.amazonaws.com/users-profile-images/${item.createdBy.image}`
                                        : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                            item.createdBy?.name || "User",
                                          )}&background=random&color=fff`
                                    }
                                    alt="creator"
                                    width="32"
                                    height="32"
                                    style={{
                                      borderRadius: "50%",
                                      objectFit: "cover",
                                      marginRight: "10px",
                                    }}
                                    onError={(e) => {
                                      e.currentTarget.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                        item.createdBy?.name || "User",
                                      )}&background=random&color=fff`;
                                    }}
                                  />
                                  <div>
                                    <div className="font-weight-bold text-dark">
                                      {item.createdBy?.name || "Unknown"}
                                    </div>
                                    <small className="text-muted">
                                      {item.createdBy?.email || "No email"}
                                    </small>
                                  </div>
                                </div>
                              </td>

                              {/* CATEGORY */}
                              <td>
                                <Badge color="info" pill>
                                  {item.category || "N/A"}
                                </Badge>
                              </td>

                              {/* CREATED AT */}
                              <td
                                className="text-muted"
                                style={{ fontSize: "12px" }}
                              >
                                {item.createdAt
                                  ? new Date(
                                      item.createdAt,
                                    ).toLocaleDateString()
                                  : "N/A"}
                                {item.createdAt && (
                                  <div
                                    className="text-muted"
                                    style={{ fontSize: "10px" }}
                                  >
                                    {new Date(
                                      item.createdAt,
                                    ).toLocaleTimeString()}
                                  </div>
                                )}
                              </td>

                              {/* ACTIONS */}
                              <td
                                className="text-right"
                                style={{ paddingRight: "24px" }}
                              >
                                <UncontrolledDropdown>
                                  <DropdownToggle
                                    size="sm"
                                    color="light"
                                    className="btn-icon-only shadow-sm"
                                    style={{
                                      background: "#fff",
                                      border: "none",
                                      borderRadius: "8px",
                                      color: "#6c757d",
                                      width: "32px",
                                      height: "32px",
                                      padding: 0,
                                      boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                                    }}
                                  >
                                    <i className="fas fa-ellipsis-v" />
                                  </DropdownToggle>
                                  <DropdownMenu right>
                                    <DropdownItem
                                      onClick={() =>
                                        openChannelDetailModal(item)
                                      }
                                    >
                                      <i className="fas fa-eye text-info mr-2" />
                                      View Details
                                    </DropdownItem>
                                    {/* <DropdownItem divider />
                                                                        <DropdownItem>
                                                                            <i className="fas fa-edit text-warning mr-2" />
                                                                            Edit Channel
                                                                        </DropdownItem>
                                                                        <DropdownItem>
                                                                            <i className="fas fa-chart-line text-success mr-2" />
                                                                            View Analytics
                                                                        </DropdownItem>
                                                                        <DropdownItem divider />
                                                                        <DropdownItem className="text-danger">
                                                                            <i className="fas fa-ban text-danger mr-2" />
                                                                            Suspend Channel
                                                                        </DropdownItem> */}
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>

                    {/* Pagination */}
                    {channelsTotal > channelsLimit && (
                      <div className="d-flex justify-content-between align-items-center p-4 border-top bg-white">
                        <span className="text-muted small">
                          Showing {(channelsPage - 1) * channelsLimit + 1} to{" "}
                          {Math.min(
                            channelsPage * channelsLimit,
                            channelsTotal,
                          )}{" "}
                          of {channelsTotal} channels
                        </span>
                        <Pagination className="mb-0">
                          <PaginationItem disabled={channelsPage <= 1}>
                            <PaginationLink
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                setChannelsPage(channelsPage - 1);
                              }}
                            >
                              <i className="fas fa-angle-left" />
                            </PaginationLink>
                          </PaginationItem>

                          {Array.from(
                            {
                              length: Math.min(
                                5,
                                Math.ceil(channelsTotal / channelsLimit),
                              ),
                            },
                            (_, i) => {
                              let pageNum;
                              if (
                                Math.ceil(channelsTotal / channelsLimit) <= 5
                              ) {
                                pageNum = i + 1;
                              } else if (channelsPage <= 3) {
                                pageNum = i + 1;
                              } else if (
                                channelsPage >=
                                Math.ceil(channelsTotal / channelsLimit) - 2
                              ) {
                                pageNum =
                                  Math.ceil(channelsTotal / channelsLimit) -
                                  4 +
                                  i;
                              } else {
                                pageNum = channelsPage - 2 + i;
                              }

                              return (
                                <PaginationItem
                                  key={pageNum}
                                  active={pageNum === channelsPage}
                                >
                                  <PaginationLink
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setChannelsPage(pageNum);
                                    }}
                                  >
                                    {pageNum}
                                  </PaginationLink>
                                </PaginationItem>
                              );
                            },
                          )}

                          <PaginationItem
                            disabled={
                              channelsPage >=
                              Math.ceil(channelsTotal / channelsLimit)
                            }
                          >
                            <PaginationLink
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                setChannelsPage(channelsPage + 1);
                              }}
                            >
                              <i className="fas fa-angle-right" />
                            </PaginationLink>
                          </PaginationItem>
                        </Pagination>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="text-center py-5">
                    <i
                      className="fas fa-video fa-3x text-muted mb-3 d-block"
                      style={{ opacity: 0.4 }}
                    />
                    <h5 className="text-muted font-weight-normal">
                      No channels found
                    </h5>
                    <p className="text-muted" style={{ fontSize: "13px" }}>
                      {channelsSearch || channelsStatus
                        ? "Try adjusting your search or filter criteria"
                        : "No creator channels available"}
                    </p>
                    {(channelsSearch || channelsStatus) && (
                      <Button
                        color="primary"
                        size="sm"
                        onClick={() => {
                          setChannelsSearch("");
                          setChannelsStatus("");
                          setChannelsPage(1);
                        }}
                        className="mt-2"
                      >
                        <i className="fas fa-redo-alt mr-1" /> Clear Filters
                      </Button>
                    )}
                  </div>
                )}
              </CardBody>
            </Card>

            {/* Channel Detail Modal */}
            <Modal
              isOpen={channelDetailModalOpen}
              toggle={() => setChannelDetailModalOpen(false)}
              size="xl"
              centered
              scrollable
            >
              <ModalHeader
                toggle={() => setChannelDetailModalOpen(false)}
                className="border-0 pb-0"
                style={{
                  background:
                    "linear-gradient(135deg, #5e72e4 0%, #825ee4 100%)",
                  borderRadius: "12px 12px 0 0",
                  padding: "20px 24px",
                }}
              >
                <div className="d-flex align-items-center">
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "10px",
                      background: "rgba(255,255,255,0.2)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "12px",
                    }}
                  >
                    <i
                      className="fas fa-video text-white"
                      style={{ fontSize: "18px" }}
                    />
                  </div>
                  <div>
                    <h5 className="mb-0 text-white font-weight-bold">
                      Channel Details
                    </h5>
                    <small className="text-white" style={{ opacity: 0.8 }}>
                      Complete channel and creator information
                    </small>
                  </div>
                </div>
              </ModalHeader>
              <ModalBody style={{ padding: "24px", background: "#f8f9fe" }}>
                {selectedChannel && (
                  <>
                    {/* Banner Image */}
                    {selectedChannel.banner && (
                      <div
                        className="mb-4"
                        style={{
                          borderRadius: "12px",
                          overflow: "hidden",
                          maxHeight: "200px",
                        }}
                      >
                        <img
                          src={
                            selectedChannel.banner.startsWith("http")
                              ? selectedChannel.banner
                              : `https://cradleaibucket.s3.us-east-1.amazonaws.com/channel-banners/${selectedChannel.banner}`
                          }
                          alt="Channel Banner"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            maxHeight: "200px",
                          }}
                          onError={(e) => {
                            e.currentTarget.style.display = "none";
                          }}
                        />
                      </div>
                    )}

                    <Row>
                      {/* Channel Information Column */}
                      <Col md="6">
                        <div style={styles.modalDataBlock}>
                          <h6 className="text-uppercase text-muted ls-1 mb-3">
                            <i className="fas fa-info-circle mr-2" /> Channel
                            Information
                          </h6>

                          <div className="d-flex align-items-center mb-3">
                            <img
                              src={
                                selectedChannel.image
                                  ? selectedChannel.image.startsWith("http")
                                    ? selectedChannel.image
                                    : `https://cradleaibucket.s3.us-east-1.amazonaws.com/user-media/${selectedChannel.image}`
                                  : `https://ui-avatars.com/api/?name=${encodeURIComponent(selectedChannel.name || "Channel")}&background=random&color=fff&size=80`
                              }
                              alt={selectedChannel.name}
                              style={{
                                width: "80px",
                                height: "80px",
                                borderRadius: "12px",
                                objectFit: "cover",
                                marginRight: "20px",
                                border: "2px solid #e9ecef",
                              }}
                              onError={(e) => {
                                e.currentTarget.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(selectedChannel.name || "Channel")}&background=random&color=fff&size=80`;
                              }}
                            />

                            <div>
                              <h4 className="mb-1 text-dark">
                                {selectedChannel.name}
                              </h4>
                              {selectedChannel.slug && (
                                <p className="text-muted mb-0">
                                  <i className="fas fa-link mr-1" />{" "}
                                  {selectedChannel.slug}
                                </p>
                              )}
                              {selectedChannel.status === "live" && (
                                <Badge color="danger" className="mt-1">
                                  LIVE NOW
                                </Badge>
                              )}
                            </div>
                          </div>

                          <table className="table table-sm table-borderless">
                            <tbody>
                              <tr>
                                <td className="text-muted">Category:</td>
                                <td>
                                  <Badge color="info" pill>
                                    {selectedChannel.category || "N/A"}
                                  </Badge>
                                </td>
                              </tr>
                              <tr>
                                <td className="text-muted">Description:</td>
                                <td className="text-wrap">
                                  {selectedChannel.description ||
                                    "No description provided"}
                                </td>
                              </tr>
                              <tr>
                                <td className="text-muted">Created At:</td>
                                <td>
                                  {selectedChannel.createdAt
                                    ? new Date(
                                        selectedChannel.createdAt,
                                      ).toLocaleString()
                                    : "N/A"}
                                </td>
                              </tr>
                              <tr>
                                <td className="text-muted">Last Updated:</td>
                                <td>
                                  {selectedChannel.updatedAt
                                    ? new Date(
                                        selectedChannel.updatedAt,
                                      ).toLocaleString()
                                    : "N/A"}
                                </td>
                              </tr>
                              <tr>
                                <td className="text-muted">Banners:</td>
                                <td>
                                  {selectedChannel.banners &&
                                  selectedChannel.banners.length > 0 ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "8px",
                                        flexWrap: "wrap",
                                      }}
                                    >
                                      {selectedChannel.banners
                                        .slice(0, 3)
                                        .map((banner, idx) => (
                                          <div
                                            key={idx}
                                            style={{
                                              width: "60px",
                                              height: "60px",
                                              borderRadius: "6px",
                                              overflow: "hidden",
                                              border: "1px solid #e9ecef",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              window.open(
                                                banner.startsWith("http")
                                                  ? banner
                                                  : `https://cradleaibucket.s3.us-east-1.amazonaws.com/user-media/${banner}`,
                                                "_blank",
                                              );
                                            }}
                                          >
                                            <img
                                              src={
                                                banner.startsWith("http")
                                                  ? banner
                                                  : `https://cradleaibucket.s3.us-east-1.amazonaws.com/user-media/${banner}`
                                              }
                                              alt={`Banner ${idx + 1}`}
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                              }}
                                              onError={(e) => {
                                                e.currentTarget.src =
                                                  "https://via.placeholder.com/60x60?text=Error";
                                              }}
                                            />
                                          </div>
                                        ))}
                                      {selectedChannel.banners.length > 3 && (
                                        <div
                                          style={{
                                            width: "60px",
                                            height: "60px",
                                            borderRadius: "6px",
                                            background: "#f0f0f0",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: "12px",
                                            fontWeight: "bold",
                                            color: "#666",
                                          }}
                                        >
                                          +{selectedChannel.banners.length - 3}
                                        </div>
                                      )}
                                    </div>
                                  ) : selectedChannel.banner ? (
                                    <div
                                      style={{
                                        width: "60px",
                                        height: "60px",
                                        borderRadius: "6px",
                                        overflow: "hidden",
                                        border: "1px solid #e9ecef",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        window.open(
                                          selectedChannel.banner.startsWith(
                                            "http",
                                          )
                                            ? selectedChannel.banner
                                            : `https://cradleaibucket.s3.us-east-1.amazonaws.com/user-media/${selectedChannel.banner}`,
                                          "_blank",
                                        );
                                      }}
                                    >
                                      <img
                                        src={
                                          selectedChannel.banner.startsWith(
                                            "http",
                                          )
                                            ? selectedChannel.banner
                                            : `https://cradleaibucket.s3.us-east-1.amazonaws.com/user-media/${selectedChannel.banner}`
                                        }
                                        alt="Banner"
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "cover",
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    <span className="text-muted">
                                      No banners
                                    </span>
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </Col>

                      {/* Creator Information Column */}
                      <Col md="6">
                        <div style={styles.modalDataBlock}>
                          <h6 className="text-uppercase text-muted ls-1 mb-3">
                            <i className="fas fa-user-circle mr-2" /> Creator
                            Information
                          </h6>

                          {selectedChannel.createdBy ? (
                            <>
                              <div className="d-flex align-items-center mb-3">
                                <img
                                  src={
                                    selectedChannel.createdBy.image
                                      ? selectedChannel.createdBy.image.startsWith(
                                          "http",
                                        )
                                        ? selectedChannel.createdBy.image
                                        : `https://cradleaibucket.s3.us-east-1.amazonaws.com/users-profile-images/${selectedChannel.createdBy.image}`
                                      : `https://ui-avatars.com/api/?name=${encodeURIComponent(selectedChannel.createdBy.name || "User")}&background=random&color=fff&size=80`
                                  }
                                  alt={selectedChannel.createdBy.name}
                                  style={{
                                    width: "80px",
                                    height: "80px",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                    marginRight: "20px",
                                    border: "2px solid #5e72e4",
                                  }}
                                  onError={(e) => {
                                    e.currentTarget.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(selectedChannel.createdBy.name || "User")}&background=random&color=fff&size=80`;
                                  }}
                                />
                                <div>
                                  <h4 className="mb-1 text-dark">
                                    {selectedChannel.createdBy.name ||
                                      "Unknown"}
                                  </h4>
                                  <p className="text-muted mb-0">
                                    <i className="fas fa-envelope mr-1" />{" "}
                                    {selectedChannel.createdBy.email ||
                                      "No email"}
                                  </p>
                                  {selectedChannel.createdBy.handlername && (
                                    <p className="text-muted mb-0">
                                      <i className="fas fa-at mr-1" /> @
                                      {selectedChannel.createdBy.handlername}
                                    </p>
                                  )}
                                </div>
                              </div>

                              <table className="table table-sm table-borderless">
                                <tbody>
                                  {selectedChannel.createdBy.bio && (
                                    <tr>
                                      <td className="text-muted">Bio:</td>
                                      <td className="text-wrap">
                                        {selectedChannel.createdBy.bio}
                                      </td>
                                    </tr>
                                  )}
                                  {selectedChannel.createdBy.country && (
                                    <tr>
                                      <td className="text-muted">Country:</td>
                                      <td>
                                        {selectedChannel.createdBy.country}
                                      </td>
                                    </tr>
                                  )}
                                  {selectedChannel.createdBy.role && (
                                    <tr>
                                      <td className="text-muted">Role:</td>
                                      <td>
                                        <Badge color="primary" pill>
                                          {selectedChannel.createdBy.role}
                                        </Badge>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </>
                          ) : (
                            <div className="text-center py-4 text-muted">
                              <i className="fas fa-user-slash fa-2x mb-2 d-block" />
                              <p>Creator information not available</p>
                            </div>
                          )}
                        </div>
                      </Col>
                    </Row>

                    {/* Additional Statistics Row */}
                    <Row>
                      <Col md="12">
                        <div style={styles.modalDataBlock}>
                          <h6 className="text-uppercase text-muted ls-1 mb-3">
                            <i className="fas fa-chart-line mr-2" /> Channel
                            Statistics
                          </h6>
                          <Row className="text-center">
                            <Col md="4">
                              <div
                                className="font-weight-bold text-dark"
                                style={{ fontSize: "24px" }}
                              >
                                {selectedChannel.subscribersCount || 0}
                              </div>
                              <div className="text-xs text-uppercase text-muted">
                                Subscribers
                              </div>
                            </Col>
                            <Col md="4">
                              <div
                                className="font-weight-bold text-primary"
                                style={{ fontSize: "24px" }}
                              >
                                {selectedChannel.videosCount || 0}
                              </div>
                              <div className="text-xs text-uppercase text-muted">
                                Videos
                              </div>
                            </Col>
                            <Col md="4">
                              <div
                                className="font-weight-bold text-success"
                                style={{ fontSize: "24px" }}
                              >
                                {selectedChannel.totalViews || 0}
                              </div>
                              <div className="text-xs text-uppercase text-muted">
                                Total Views
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </>
                )}
              </ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={() => setChannelDetailModalOpen(false)}
                >
                  Close
                </Button>
              </ModalFooter>
            </Modal>
          </TabPane>

          {/* ──── TAB: Referral Tracker ──── */}
          <TabPane tabId="Referral Tracker">
            <Card
              className="shadow"
              style={{
                borderRadius: "16px",
                border: "none",
                overflow: "hidden",
              }}
            >
              {/* HEADER */}
              <CardHeader
                className="border-0 bg-white"
                style={{ borderRadius: "16px 16px 0 0", padding: "24px" }}
              >
                <h3 className="mb-0 text-dark font-weight-700">
                  <i className="ni ni-world text-teal mr-2" /> Referral Program
                  Tracker
                </h3>
              </CardHeader>

              <CardBody className="p-0">
                {/* 🔍 FILTER BAR */}
                <div className="p-3 border-bottom bg-white">
                  <div className="d-flex flex-wrap align-items-center">
                    {/* Search */}
                    <div
                      style={{
                        flex: 1,
                        minWidth: "220px",
                        marginRight: "10px",
                      }}
                    >
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search referrer, user, email..."
                        value={search}
                        onChange={(e) => {
                          setPage(1);
                          setSearch(e.target.value);
                        }}
                      />
                    </div>

                    {/* Status Filter */}
                    <div style={{ minWidth: "180px", marginRight: "10px" }}>
                      <select
                        className="form-control"
                        value={status}
                        onChange={(e) => {
                          setPage(1);
                          setStatus(e.target.value);
                        }}
                      >
                        <option value="">All Status</option>
                        <option value="credited">Credited</option>
                        <option value="pending">Pending</option>
                        <option value="blocked">Blocked</option>
                        <option value="failed">Failed</option>
                        <option value="reversed">Reversed</option>
                      </select>
                    </div>

                    {/* Fraud Filter */}
                    <div style={{ minWidth: "180px", marginRight: "10px" }}>
                      <select
                        className="form-control"
                        value={fraud}
                        onChange={(e) => {
                          setPage(1);
                          setFraud(e.target.value);
                        }}
                      >
                        <option value="">All</option>
                        <option value="true">Fraud Only</option>
                        <option value="false">Clean Only</option>
                      </select>
                    </div>

                    {/* Reset */}
                    <button
                      className="btn btn-outline-secondary btn-sm"
                      onClick={() => {
                        setSearch("");
                        setStatus("");
                        setFraud("");
                        setPage(1);
                      }}
                    >
                      Reset
                    </button>
                  </div>
                </div>

                {/* TABLE */}
                <div style={{ width: "100%", overflowX: "auto" }}>
                  <Table className="align-items-center table-flush" hover>
                    <thead className="thead-light">
                      <tr>
                        <th>Referrer</th>
                        <th>Referred User</th>
                        <th>Country</th>
                        <th>Points</th>
                        <th>Wallet</th>
                        <th>Status</th>
                        <th>Fraud</th>
                        <th className="text-right">Actions</th>
                      </tr>
                    </thead>

                    <tbody>
                      {/* LOADING STATE */}
                      {loading ? (
                        <tr>
                          <td colSpan="8" className="text-center py-4">
                            Loading...
                          </td>
                        </tr>
                      ) : Array.isArray(data) && data.length > 0 ? (
                        data.map((item) => (
                          <tr key={item._id}>
                            {/* Referrer */}
                            <td>
                              <div className="d-flex align-items-center">
                                <img
                                  src={
                                    item.referrer_id?.image
                                      ? item.referrer_id.image.startsWith(
                                          "http",
                                        )
                                        ? item.referrer_id.image
                                        : `https://cradleaibucket.s3.us-east-1.amazonaws.com/users-profile-images/${item.referrer_id.image}`
                                      : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                          item.referrer_id?.name || "User",
                                        )}&background=random&color=fff`
                                  }
                                  alt={item.referrer_id?.name || "User"}
                                  style={{
                                    width: "32px",
                                    height: "32px",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                    marginRight: "10px",
                                    border: "1px solid #ddd",
                                  }}
                                  onError={(e) => {
                                    e.currentTarget.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                      item.referrer_id?.name || "User",
                                    )}&background=random&color=fff`;
                                  }}
                                />

                                <div>
                                  <div>
                                    {item.referrer_id?.name || "Unknown"}
                                  </div>
                                  <small className="text-muted">
                                    {item.referrer_id?.email || ""}
                                  </small>
                                </div>
                              </div>
                            </td>

                            {/* Referred */}
                            <td>
                              <div className="d-flex align-items-center">
                                <img
                                  src={
                                    item?.referred_user_id?.image
                                      ? item.referred_user_id.image.startsWith(
                                          "http",
                                        )
                                        ? item.referred_user_id.image
                                        : `https://cradleaibucket.s3.us-east-1.amazonaws.com/users-profile-images/${item.referred_user_id.image}`
                                      : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                          item?.referred_user_id?.name ||
                                            "User",
                                        )}&background=random&color=fff`
                                  }
                                  alt={item?.referred_user_id?.name || "User"}
                                  style={{
                                    width: "32px",
                                    height: "32px",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                    marginRight: "10px",
                                    border: "1px solid #ddd",
                                  }}
                                  onError={(e) => {
                                    e.currentTarget.onerror = null;
                                    e.currentTarget.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                      item?.referred_user_id?.name || "User",
                                    )}&background=random&color=fff`;
                                  }}
                                />

                                <div>
                                  <div>
                                    {item?.referred_user_id?.name || "Unknown"}
                                  </div>
                                  <small className="text-muted">
                                    {item?.referred_user_id?.email || ""}
                                  </small>
                                </div>
                              </div>
                            </td>

                            {/* Country */}
                            <td>
                              {item.country_referrer} → {item.country_referred}
                            </td>

                            {/* Points */}
                            <td className="font-weight-bold text-primary">
                              {item.points_amount || 0}
                            </td>

                            {/* Wallet */}
                            <td className="text-success font-weight-bold">
                              {item.monetary_amount || 0}
                            </td>

                            {/* Status */}
                            <td>
                              <Badge
                                color={
                                  item.reward_status === "credited"
                                    ? "success"
                                    : item.reward_status === "pending"
                                      ? "warning"
                                      : item.reward_status === "blocked"
                                        ? "danger"
                                        : "secondary"
                                }
                                pill
                              >
                                {item.reward_status}
                              </Badge>
                            </td>

                            {/* Fraud */}
                            <td>
                              {item.fraud_flag ? (
                                <Badge color="danger" pill>
                                  Fraud
                                </Badge>
                              ) : (
                                <Badge color="success" pill>
                                  Clean
                                </Badge>
                              )}

                              {item.fraud_reason && (
                                <div>
                                  <small className="text-danger">
                                    {item.fraud_reason}
                                  </small>
                                </div>
                              )}
                            </td>

                            {/* Actions */}
                            <td className="text-right">
                              <Button
                                size="sm"
                                color="info"
                                outline
                                className="mr-2"
                                onClick={() => openReferralModal(item, "view")}
                              >
                                View
                              </Button>
                              {/* <Button
                                                                size="sm"
                                                                color="primary"
                                                                outline
                                                                className="mr-2"
                                                                onClick={() => openReferralModal(item, "adjust")}
                                                            >
                                                                Adjust
                                                            </Button>
                                                            <Button
                                                                size="sm"
                                                                color="danger"
                                                                outline
                                                                onClick={() => openReferralModal(item, "revoke")}
                                                            >
                                                                Revoke
                                                            </Button> */}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" className="text-center py-4">
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </CardBody>
              <CardFooter
                className="py-4 bg-white border-0"
                style={{ borderRadius: "0 0 16px 16px" }}
              >
                <nav aria-label="...">
                  <Pagination
                    className="pagination justify-content-end mb-0"
                    listClassName="justify-content-end mb-0"
                  >
                    <PaginationItem disabled={page <= 1}>
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => {
                          e.preventDefault();
                          if (page > 1) setPage(page - 1);
                        }}
                        tabIndex="-1"
                      >
                        <i className="fas fa-angle-left" />
                        <span className="sr-only">Previous</span>
                      </PaginationLink>
                    </PaginationItem>

                    {renderPaginationItems(
                      page,
                      pagination.total,
                      limit,
                      setPage,
                    )}

                    <PaginationItem disabled={page >= pagination.pages}>
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => {
                          e.preventDefault();
                          if (page < pagination.pages) {
                            setPage(page + 1);
                          }
                        }}
                      >
                        <i className="fas fa-angle-right" />
                        <span className="sr-only">Next</span>
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
                </nav>
              </CardFooter>
            </Card>
          </TabPane>

          {/* ──── TAB: user memberships ──── */}
          <TabPane tabId="User Memberships">
            {/* KPI Stat Cards */}
            {/* <Row className="mb-4">
                            <Col lg="4" md="6" className="mb-4 mb-lg-0">
                                <Card className="shadow border-0" style={{ ...styles.statCard, background: "linear-gradient(135deg, #2dce89 0%, #2dcecc 100%)", color: "#fff" }}>
                                    <CardBody className="p-3">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <span className="text-uppercase font-weight-bold text-xs" style={{ fontSize: "11px", letterSpacing: "1px", opacity: 0.85 }}>Total Revenue</span>
                                            <div style={{ ...styles.statIconBox, background: "rgba(255,255,255,0.2)", marginBottom: 0 }}>
                                                <i className="fa fa-dollar-sign" />
                                            </div>
                                        </div>
                                        <h3 className="mb-0 text-white font-weight-bold" style={{ fontSize: "28px" }}>
                                            ${Object.values(membershipsByType).reduce((acc, curr) => acc + (curr.totalRevenue || 0), 0).toLocaleString()}
                                        </h3>
                                        <div className="text-xs mt-2" style={{ opacity: 0.9 }}>
                                            <i className="fa fa-arrow-up mr-1" /> Active members payment value
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col lg="4" md="6" className="mb-4 mb-lg-0">
                                <Card className="shadow border-0" style={{ ...styles.statCard, background: "linear-gradient(135deg, #11cdef 0%, #1171ef 100%)", color: "#fff" }}>
                                    <CardBody className="p-3">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <span className="text-uppercase font-weight-bold text-xs" style={{ fontSize: "11px", letterSpacing: "1px", opacity: 0.85 }}>Total Subscriptions</span>
                                            <div style={{ ...styles.statIconBox, background: "rgba(255,255,255,0.2)", marginBottom: 0 }}>
                                                <i className="fa fa-gem" />
                                            </div>
                                        </div>
                                        <h3 className="mb-0 text-white font-weight-bold" style={{ fontSize: "28px" }}>
                                            {membershipsTotal}
                                        </h3>
                                        <div className="text-xs mt-2" style={{ opacity: 0.9 }}>
                                            <i className="fa fa-users mr-1" /> Active & expired users
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col lg="4" md="12">
                                <Card className="shadow border-0" style={{ ...styles.statCard, background: "linear-gradient(135deg, #ff9f43 0%, #ff6b6b 100%)", color: "#fff" }}>
                                    <CardBody className="p-3">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <span className="text-uppercase font-weight-bold text-xs" style={{ fontSize: "11px", letterSpacing: "1px", opacity: 0.85 }}>Membership Tiers</span>
                                            <div style={{ ...styles.statIconBox, background: "rgba(255,255,255,0.2)", marginBottom: 0 }}>
                                                <i className="fa fa-star" />
                                            </div>
                                        </div>
                                        <div className="d-flex flex-wrap" style={{ gap: "10px" }}>
                                            {Object.keys(membershipsByType).length > 0 ? (
                                                Object.keys(membershipsByType).map(key => (
                                                    <span key={key} className="badge badge-pill badge-light text-dark font-weight-bold px-2 py-1" style={{ fontSize: "11px", background: "rgba(255,255,255,0.85)" }}>
                                                        {key.toUpperCase()}: {membershipsByType[key].count}
                                                    </span>
                                                ))
                                            ) : (
                                                <span className="text-xs text-white" style={{ opacity: 0.8 }}>No tiers loaded</span>
                                            )}
                                        </div>
                                        <div className="text-xs mt-2" style={{ opacity: 0.9 }}>
                                            <i className="fa fa-chart-pie mr-1" /> Tier distribution
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row> */}

            {/* Subscriber Directory Table */}
            <Card
              className="shadow"
              style={{
                borderRadius: "16px",
                border: "none",
                overflow: "visible",
              }}
            >
              <CardHeader
                className="border-0 bg-white"
                style={{ borderRadius: "16px 16px 0 0", padding: "24px" }}
              >
                <Row className="align-items-center">
                  <Col>
                    <h3 className="mb-0 text-dark font-weight-700">
                      <i className="fa fa-star text-warning mr-2" /> Subscriber
                      Directory & Memberships
                    </h3>
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md="7">
                    <InputGroup
                      className="input-group-alternative"
                      style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}
                    >
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText style={{ background: "#fff" }}>
                          <i className="fas fa-search text-muted" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Search by subscriber name, email, or channel hub..."
                        type="text"
                        value={membershipsSearch}
                        onChange={(e) => {
                          setMembershipsSearch(e.target.value);
                          setMembershipsPage(1);
                        }}
                        style={{ fontSize: "14px" }}
                      />
                    </InputGroup>
                  </Col>
                  <Col md="4">
                    <Input
                      type="select"
                      value={membershipsStatus}
                      onChange={(e) => {
                        setMembershipsStatus(e.target.value);
                        setMembershipsPage(1);
                      }}
                      style={{
                        borderRadius: "8px",
                        border: "1px solid #e0e0e0",
                        height: "44px",
                        fontSize: "14px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                      }}
                    >
                      <option value="">All Statuses</option>
                      <option value="active">Active</option>
                      <option value="cancelled">Cancelled</option>
                      <option value="expired">Expired</option>
                    </Input>
                  </Col>
                  <Col
                    md="1"
                    className="text-right d-flex align-items-center"
                  ></Col>
                </Row>
              </CardHeader>
              <CardBody className="p-0">
                {membershipsLoading ? (
                  <div className="text-center py-5">
                    <Spinner
                      color="primary"
                      style={{ width: "3rem", height: "3rem" }}
                    />
                    <p className="text-muted mt-3">
                      Loading membership subscriptions...
                    </p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <Table className="align-items-center table-flush" hover>
                      <thead className="thead-light">
                        <tr>
                          <th scope="col" style={{ padding: "16px 24px" }}>
                            Subscriber
                          </th>
                          <th scope="col">Channel Hub</th>
                          <th scope="col">Membership Tier</th>
                          <th scope="col">Price</th>
                          <th scope="col">Status</th>
                          <th scope="col">Cancellation Reason</th>
                          <th scope="col">Purchase Date</th>
                          <th scope="col">Expiry Date</th>
                          <th scope="col" className="text-right">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {memberships.length > 0 ? (
                          memberships.map((sub, idx) => (
                            <tr key={idx} style={styles.tableRow}>
                              <td style={{ padding: "16px 24px" }}>
                                <div className="d-flex align-items-center">
                                  <Avatar
                                    src={sub.user?.image}
                                    name={sub.user?.name || "Unknown User"}
                                    size="sm"
                                    className="mr-2"
                                  />
                                  <div>
                                    <span className="font-weight-bold d-block text-dark text-sm">
                                      {sub.user?.name || "Unknown User"}
                                    </span>
                                    <small className="text-xs text-muted d-block">
                                      {sub.user?.email || "N/A"}
                                    </small>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <span className="text-sm font-weight-bold text-dark">
                                  {sub.channel?.channel_name ||
                                    sub.title ||
                                    "—"}
                                </span>
                              </td>
                              <td>
                                <Badge color="primary" pill>
                                  {sub.membershipTier?.title ||
                                    sub.title ||
                                    "—"}
                                </Badge>
                              </td>
                              <td>
                                <strong className="text-dark">
                                  ${(sub.price || 0).toLocaleString()}
                                </strong>
                              </td>
                              <td>
                                {(() => {
                                  let displayStatus = sub.status || "inactive";
                                  if (sub.cancellationReason) {
                                    displayStatus =
                                      sub.cancellationReason === "upgraded"
                                        ? "upgraded"
                                        : "cancelled";
                                  }
                                  return (
                                    <Badge
                                      color={
                                        displayStatus === "active"
                                          ? "success"
                                          : displayStatus === "cancelled"
                                            ? "danger"
                                            : displayStatus === "upgraded"
                                              ? "info"
                                              : "warning"
                                      }
                                      pill
                                    >
                                      {displayStatus}
                                    </Badge>
                                  );
                                })()}
                              </td>
                              <td className="text-sm text-muted">
                                {cancellationReasons[sub.cancellationReason] ||
                                  sub.cancellationReason ||
                                  "N/A"}
                              </td>
                              <td className="text-sm text-muted">
                                {sub.buyDate
                                  ? new Date(sub.buyDate).toLocaleDateString(
                                      "en-US",
                                      {
                                        year: "numeric",
                                        month: "short",
                                        day: "numeric",
                                      },
                                    )
                                  : "N/A"}
                              </td>
                              <td className="text-sm text-muted">
                                {sub.expireDate
                                  ? new Date(sub.expireDate).toLocaleDateString(
                                      "en-US",
                                      {
                                        year: "numeric",
                                        month: "short",
                                        day: "numeric",
                                      },
                                    )
                                  : "N/A"}
                              </td>
                              <td className="text-right">
                                <Button
                                  size="sm"
                                  color="info"
                                  outline
                                  onClick={() => {
                                    setSelectedItem(sub);
                                    setModalType("membership");
                                    setModalOpen(true);
                                  }}
                                >
                                  View
                                </Button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan="9"
                              className="text-center py-4 text-muted"
                            >
                              No subscribers or memberships found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                )}
              </CardBody>
              {/* Card Footer with Pagination */}
              <CardFooter
                className="py-4 bg-white border-0"
                style={{ borderRadius: "0 0 16px 16px" }}
              >
                <nav aria-label="...">
                  <Pagination
                    className="pagination justify-content-end mb-0"
                    listClassName="justify-content-end mb-0"
                  >
                    <PaginationItem disabled={membershipsPage <= 1}>
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => {
                          e.preventDefault();
                          if (membershipsPage > 1)
                            setMembershipsPage(membershipsPage - 1);
                        }}
                        tabIndex="-1"
                      >
                        <i className="fas fa-angle-left" />
                        <span className="sr-only">Previous</span>
                      </PaginationLink>
                    </PaginationItem>

                    {renderPaginationItems(
                      membershipsPage,
                      membershipsTotal,
                      membershipsLimit,
                      setMembershipsPage,
                    )}

                    <PaginationItem
                      disabled={
                        membershipsPage >=
                        Math.ceil(membershipsTotal / membershipsLimit)
                      }
                    >
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => {
                          e.preventDefault();
                          if (
                            membershipsPage <
                            Math.ceil(membershipsTotal / membershipsLimit)
                          ) {
                            setMembershipsPage(membershipsPage + 1);
                          }
                        }}
                      >
                        <i className="fas fa-angle-right" />
                        <span className="sr-only">Next</span>
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
                </nav>
              </CardFooter>
            </Card>
          </TabPane>

          {/* ──── TAB: Gift Config ──── */}
          <TabPane tabId="Gift Config">
            <Card
              className="shadow"
              style={{
                borderRadius: "16px",
                border: "none",
                overflow: "visible",
              }}
            >
              <CardHeader
                className="border-0 bg-white"
                style={{ borderRadius: "16px 16px 0 0", padding: "24px" }}
              >
                <Row className="align-items-center">
                  <Col>
                    <h3 className="mb-0 text-dark font-weight-700">
                      <i className="fas fa-gift text-warning mr-2" /> Gift
                      Configuration
                    </h3>
                    <p className="text-muted text-sm mt-1">
                      Configure the one-time gift voucher settings for users
                    </p>
                  </Col>
                </Row>
              </CardHeader>

              <CardBody style={{ padding: "24px", background: "#f8f9fe" }}>
                {giftConfigLoading ? (
                  <div className="text-center py-5">
                    <Spinner
                      color="primary"
                      style={{ width: "3rem", height: "3rem" }}
                    />
                    <p className="text-muted mt-3">Loading gift config...</p>
                  </div>
                ) : !giftConfig ? ( // ✅ Agar config null hai toh
                  <div className="text-center py-5">
                    <i
                      className="fas fa-gift fa-3x text-muted mb-3 d-block"
                      style={{ opacity: 0.4 }}
                    />
                    <h5 className="text-muted font-weight-normal">
                      No gift config found
                    </h5>
                    <p className="text-muted" style={{ fontSize: "13px" }}>
                      Please create a gift configuration first.
                    </p>
                    <Button color="primary" onClick={fetchGiftConfig}>
                      <i className="fas fa-redo mr-1" /> Load Config
                    </Button>
                  </div>
                ) : (
                  <div className="row">
                    <div className="col-md-8 mx-auto">
                      <div
                        className="card shadow-sm border-0"
                        style={{ borderRadius: "16px" }}
                      >
                        <div className="card-body p-4">
                          {/* Status Toggle */}
                          <div className="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
                            <div>
                              <h6 className="mb-0 font-weight-bold">
                                Feature Status
                              </h6>
                              <small className="text-muted">
                                Enable or disable the gift feature
                              </small>
                            </div>
                            <div className="d-flex align-items-center gap-3">
                              <Badge
                                color={
                                  giftConfig.is_active ? "success" : "secondary"
                                }
                                pill
                                style={{
                                  fontSize: "12px",
                                  padding: "6px 14px",
                                }}
                              >
                                {giftConfig.is_active ? "ACTIVE" : "INACTIVE"}
                              </Badge>
                              <Button
                                color={
                                  giftConfig.is_active ? "danger" : "success"
                                }
                                size="sm"
                                onClick={handleToggleGiftStatus}
                                style={{ borderRadius: "8px" }}
                              >
                                <i
                                  className={`fas ${giftConfig.is_active ? "fa-pause" : "fa-play"} mr-1`}
                                />
                                {giftConfig.is_active ? "Disable" : "Enable"}
                              </Button>
                            </div>
                          </div>

                          {/* Form */}
                          <form>
                            <div className="row">
                              <div className="col-md-6 mb-3">
                                <label className="form-label fw-semibold">
                                  Gift Amount
                                </label>
                                <div
                                  className="input-group"
                                  style={{
                                    borderRadius: "10px",
                                    overflow: "hidden",
                                  }}
                                >
                                  <span
                                    className="input-group-text"
                                    style={{
                                      background:
                                        "linear-gradient(135deg, #FF6B35, #FF8C42)",
                                      color: "#fff",
                                      fontWeight: "700",
                                      border: "none",
                                      padding: "0 16px",
                                      fontSize: "16px",
                                    }}
                                  >
                                    $
                                  </span>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={giftConfig.gift_amount || 0}
                                    onChange={(e) => {
                                      const value = e.target.value.replace(
                                        /[^0-9.]/g,
                                        "",
                                      );
                                      setGiftConfig({
                                        ...giftConfig,
                                        gift_amount: parseFloat(value) || 0,
                                      });
                                    }}
                                    placeholder="0.00"
                                    style={{
                                      borderRadius: "0 10px 10px 0",
                                      fontSize: "16px",
                                      fontWeight: "600",
                                      padding: "10px 16px",
                                    }}
                                  />
                                </div>
                                <small className="text-muted">
                                  Amount user will receive as gift
                                </small>
                              </div>

                              <div className="col-md-6 mb-3">
                                <label className="form-label fw-semibold">
                                  Currency
                                </label>
                                <select
                                  className="form-control"
                                  value={giftConfig.currency || "USD"}
                                  onChange={(e) =>
                                    setGiftConfig({
                                      ...giftConfig,
                                      currency: e.target.value,
                                    })
                                  }
                                  style={{ borderRadius: "10px" }}
                                >
                                  <option value="USD">USD ($)</option>
                                </select>
                              </div>

                              <div className="col-md-6 mb-3">
                                <label className="form-label fw-semibold">
                                  Expiry Days
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={giftConfig.expiry_days || 30}
                                  onChange={(e) =>
                                    setGiftConfig({
                                      ...giftConfig,
                                      expiry_days:
                                        parseInt(e.target.value) || 30,
                                    })
                                  }
                                  min="1"
                                  max="365"
                                  style={{ borderRadius: "10px" }}
                                />
                                <small className="text-muted">
                                  Days after redemption the gift expires
                                </small>
                              </div>

                              <div className="col-md-6 mb-3">
                                <label className="form-label fw-semibold">
                                  Current Config
                                </label>
                                <div
                                  className="p-3 bg-light rounded-3"
                                  style={{ borderRadius: "10px" }}
                                >
                                  <div className="d-flex justify-content-between">
                                    <span className="text-muted">Amount:</span>
                                    <span className="fw-bold">
                                      ${giftConfig.gift_amount || 0}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <span className="text-muted">Expiry:</span>
                                    <span className="fw-bold">
                                      {giftConfig.expiry_days || 30} days
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <span className="text-muted">Status:</span>
                                    <Badge
                                      color={
                                        giftConfig.is_active
                                          ? "success"
                                          : "secondary"
                                      }
                                      pill
                                    >
                                      {giftConfig.is_active
                                        ? "Active"
                                        : "Inactive"}
                                    </Badge>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <span className="text-muted">
                                      Last Updated:
                                    </span>
                                    <span className="text-muted small">
                                      {giftConfig.updated_at
                                        ? new Date(
                                            giftConfig.updated_at,
                                          ).toLocaleString()
                                        : "N/A"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="mt-3 pt-3 border-top d-flex gap-2">
                              <Button
                                color="primary"
                                onClick={handleGiftConfigUpdate}
                                disabled={giftConfigSaving}
                                style={{
                                  borderRadius: "10px",
                                  padding: "10px 30px",
                                }}
                              >
                                {giftConfigSaving ? (
                                  <>
                                    <span className="spinner-border spinner-border-sm mr-2" />{" "}
                                    Saving...
                                  </>
                                ) : (
                                  <>
                                    <i className="fas fa-save mr-2" /> Save
                                    Changes
                                  </>
                                )}
                              </Button>
                              <Button
                                color="secondary"
                                outline
                                onClick={fetchGiftConfig}
                                style={{ borderRadius: "10px" }}
                              >
                                <i className="fas fa-redo mr-1" /> Refresh
                              </Button>
                            </div>
                          </form>

                          {/* Info Box */}
                          <div
                            className="mt-4 p-3 bg-info-light rounded-3"
                            style={{
                              background: "rgba(17, 205, 239, 0.08)",
                              borderRadius: "12px",
                              border: "1px solid rgba(17, 205, 239, 0.15)",
                            }}
                          >
                            <div className="d-flex">
                              <i className="fas fa-info-circle text-info me-2 mt-1" />
                              <div>
                                <h6 className="mb-1 font-weight-bold">
                                  About Gift Config
                                </h6>
                                <p className="text-muted small mb-0">
                                  This config controls the one-time gift voucher
                                  that every user receives. Once a user redeems
                                  the gift, it expires after the configured
                                  number of days. Users can only redeem the gift
                                  once.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </CardBody>
            </Card>
          </TabPane>
          {/* ──── TAB: Packages ──── */}
          <TabPane tabId="Packages">
            <Card
              className="shadow"
              style={{
                borderRadius: "16px",
                border: "none",
                overflow: "visible",
              }}
            >
              <CardHeader
                className="border-0 bg-white"
                style={{ borderRadius: "16px 16px 0 0", padding: "24px" }}
              >
                <Row className="align-items-center">
                  <Col xs="12" md="6" className="mb-3 mb-md-0">
                    <h3 className="mb-0 text-dark font-weight-700">
                      <i className="fa fa-box-open text-primary mr-2" /> Packages
                    </h3>
                  </Col>
                  <Col
                    xs="12"
                    md="6"
                    className="d-flex justify-content-md-end justify-content-center"
                  >
                    <Button
                      color="primary"
                      size="sm"
                      onClick={() => {
                        setModalType("createPackage");
                        setModalOpen(true);
                      }}
                    >
                      <i className="fas fa-plus mr-2" /> Create Package
                    </Button>
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md="6">
                    <InputGroup className="input-group-alternative">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fas fa-search" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Search packages..."
                        type="text"
                        value={packagesSearch}
                        onChange={(e) => setPackagesSearch(e.target.value)}
                      />
                    </InputGroup>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody className="p-4 bg-transparent">
                <Row>
                  {packagesLoading ? (
                    <Col md="12" className="text-center py-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    </Col>
                  ) : packages.filter(p => p.name.toLowerCase().includes(packagesSearch.toLowerCase())).map((pkg) => (
                    <Col md="4" key={pkg._id || pkg.id} className="mb-4">
                      <Card className="shadow-sm border-0 h-100" style={{ borderRadius: "12px", position: "relative", overflow: "hidden" }}>

                        <CardBody className="p-4 d-flex flex-column">
                          <div className="d-flex justify-content-between align-items-start mb-2">
                            <h4 className="text-dark mb-0 font-weight-bold">{pkg.name}</h4>
                            <UncontrolledDropdown>
                              <DropdownToggle className="btn-icon-only text-muted" color="" role="button" size="sm" style={{ boxShadow: 'none' }}>
                                <i className="fas fa-ellipsis-v" />
                              </DropdownToggle>
                              <DropdownMenu className="dropdown-menu-arrow" right>
                                <DropdownItem onClick={() => { setSelectedItem(pkg); setModalType("package"); setModalOpen(true); }}>
                                  <i className="fas fa-edit text-info"></i> Edit
                                </DropdownItem>
                                <DropdownItem onClick={() => handleDeletePackage(pkg._id || pkg.id)}>
                                  <i className="fas fa-trash text-danger"></i> Delete
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </div>
                          
                          <div className="d-flex align-items-baseline mb-1 mt-2">
                            <h1 className="text-dark font-weight-bold mb-0" style={{ fontSize: "36px" }}>${pkg.price}</h1>
                            {pkg.period && (
                              <span className="text-muted ml-1" style={{ fontSize: "14px" }}>
                                /{pkg.period.startsWith('/') ? pkg.period.substring(1) : pkg.period}
                              </span>
                            )}
                          </div>
                          <p className="text-muted mb-4" style={{ fontSize: "14px" }}>{pkg.subtitle}</p>
                          
                          <div className="mb-4 flex-grow-1">
                            {pkg.features.map((feature, idx) => (
                              <div key={idx} className="d-flex align-items-center mb-3">
                                <i className="fas fa-check text-success mr-3" style={{ fontSize: "12px" }}></i>
                                <span className="text-dark" style={{ fontSize: "14px" }}>{feature}</span>
                              </div>
                            ))}
                          </div>
                          

                        </CardBody>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </CardBody>
            </Card>
          </TabPane>
        </TabContent>
      </Container>

      {/* ── Dynamic Detail Modal ─────────────────── */}
      <Modal
        isOpen={modalOpen}
        toggle={() => setModalOpen(false)}
        size="lg"
        centered
        scrollable
      >
        <ModalHeader
          toggle={() => setModalOpen(false)}
          className="border-0 pb-0"
        >
          <div>
            <span className="text-uppercase text-muted ls-1">
              {modalType === "createChallenge"
                ? "Create New Challenge"
                : modalType === "submissions"
                  ? "Challenge Submissions"
                  : modalType === "challenge"
                    ? "Challenge Details"
                    : modalType === "membership"
                      ? "Membership Details"
                      : `${modalType} Details`}
            </span>
          </div>
        </ModalHeader>
        <ModalBody className="p-0 pt-3">{renderModalBody()}</ModalBody>
      </Modal>
      {/* ── Join Requests Full-Width Modal ─────────────────── */}
      <Modal
        isOpen={joinRequestsModalOpen}
        toggle={() => setJoinRequestsModalOpen(false)}
        size="lg"
        centered
        scrollable
        dialogClassName="join-requests-modal"
        container="body"
      >
        <ModalHeader
          toggle={() => setJoinRequestsModalOpen(false)}
          className="border-0 pb-0"
          style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            borderRadius: "12px 12px 0 0",
            padding: "20px 24px",
          }}
        >
          <div className="d-flex align-items-center">
            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "10px",
                background: "rgba(255,255,255,0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "12px",
              }}
            >
              <i
                className="fas fa-user-clock text-white"
                style={{ fontSize: "18px" }}
              />
            </div>
            <div>
              <h5 className="mb-0 text-white font-weight-bold">
                Challenge Join Requests
              </h5>
              <small className="text-white" style={{ opacity: 0.8 }}>
                Manage user requests to join challenges
              </small>
            </div>
          </div>
        </ModalHeader>

        <ModalBody
          style={{ padding: "24px", background: "#f8f9fe", minHeight: "400px" }}
        >
          {/* Filters */}
          <Row className="mb-4">
            <Col md="5">
              <InputGroup
                className="input-group-alternative"
                style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}
              >
                <InputGroupAddon addonType="prepend">
                  <InputGroupText style={{ background: "#fff" }}>
                    <i className="fas fa-search text-muted" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  placeholder="Search by user name, email or challenge..."
                  type="text"
                  value={joinRequestsSearch}
                  onChange={(e) => {
                    setJoinRequestsSearch(e.target.value);
                    setJoinRequestsPage(1);
                  }}
                  style={{ fontSize: "14px" }}
                />
              </InputGroup>
            </Col>
            <Col md="3">
              <Input
                type="select"
                value={joinRequestsStatus}
                onChange={(e) => {
                  setJoinRequestsStatus(e.target.value);
                  setJoinRequestsPage(1);
                }}
                style={{
                  borderRadius: "8px",
                  border: "1px solid #e0e0e0",
                  height: "44px",
                  fontSize: "14px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                }}
              >
                <option value="">All Statuses</option>
                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </Input>
            </Col>
            <Col
              md="4"
              className="text-right d-flex align-items-center justify-content-end"
            >
              <Badge
                color="dark"
                pill
                className="px-3 py-2"
                style={{ fontSize: "13px" }}
              >
                <i className="fas fa-list mr-1" /> {joinRequestsTotal} Total
                Requests
              </Badge>
            </Col>
          </Row>

          {/* Table */}
          {joinRequestsLoading ? (
            <div className="text-center py-5">
              <Spinner
                color="primary"
                style={{ width: "3rem", height: "3rem" }}
              />
              <p className="text-muted mt-3">Loading requests...</p>
            </div>
          ) : joinRequests.length > 0 ? (
            <div
              className="table-responsive"
              style={{
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 4px 15px rgba(0,0,0,0.06)",
              }}
            >
              <Table
                className="align-items-center mb-0"
                style={{ background: "#fff" }}
              >
                <thead>
                  <tr
                    style={{
                      background:
                        "linear-gradient(135deg, #f6f9fc 0%, #eef1f6 100%)",
                    }}
                  >
                    <th
                      style={{
                        padding: "14px 20px",
                        fontSize: "11px",
                        fontWeight: "700",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        color: "#8898aa",
                        borderBottom: "2px solid #e9ecef",
                      }}
                    >
                      #
                    </th>
                    <th
                      style={{
                        padding: "14px 16px",
                        fontSize: "11px",
                        fontWeight: "700",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        color: "#8898aa",
                        borderBottom: "2px solid #e9ecef",
                      }}
                    >
                      User
                    </th>
                    <th
                      style={{
                        padding: "14px 16px",
                        fontSize: "11px",
                        fontWeight: "700",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        color: "#8898aa",
                        borderBottom: "2px solid #e9ecef",
                      }}
                    >
                      Challenge
                    </th>
                    <th
                      style={{
                        padding: "14px 16px",
                        fontSize: "11px",
                        fontWeight: "700",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        color: "#8898aa",
                        borderBottom: "2px solid #e9ecef",
                      }}
                    >
                      Status
                    </th>
                    <th
                      style={{
                        padding: "14px 16px",
                        fontSize: "11px",
                        fontWeight: "700",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        color: "#8898aa",
                        borderBottom: "2px solid #e9ecef",
                      }}
                    >
                      Requested On
                    </th>
                    <th
                      style={{
                        padding: "14px 20px",
                        fontSize: "11px",
                        fontWeight: "700",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        color: "#8898aa",
                        borderBottom: "2px solid #e9ecef",
                        textAlign: "center",
                      }}
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {joinRequests.map((req, idx) => (
                    <tr
                      key={req._id}
                      style={{
                        transition: "background 0.2s",
                        borderBottom: "1px solid #f0f0f0",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.background = "#f8f9fe")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.background = "#fff")
                      }
                    >
                      <td
                        style={{
                          padding: "14px 20px",
                          fontWeight: "600",
                          color: "#adb5bd",
                          fontSize: "13px",
                        }}
                      >
                        {(joinRequestsPage - 1) * joinRequestsLimit + idx + 1}
                      </td>
                      <td style={{ padding: "14px 16px" }}>
                        <div className="d-flex align-items-center">
                          <div
                            style={{
                              width: "38px",
                              height: "38px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "#fff",
                              fontWeight: "700",
                              fontSize: "14px",
                              marginRight: "12px",
                              flexShrink: 0,
                            }}
                          >
                            {req.user?.name
                              ? req.user.name.charAt(0).toUpperCase()
                              : "?"}
                          </div>
                          <div>
                            <div
                              className="font-weight-bold text-dark"
                              style={{ fontSize: "13px" }}
                            >
                              {req.user?.name || "Unknown User"}
                            </div>
                            <div
                              className="text-muted"
                              style={{ fontSize: "11px" }}
                            >
                              {req.user?.email || "N/A"}
                            </div>
                            {req.user?.handlername && (
                              <div
                                style={{ fontSize: "11px", color: "#5e72e4" }}
                              >
                                @{req.user.handlername}
                              </div>
                            )}
                          </div>
                        </div>
                      </td>
                      <td style={{ padding: "14px 16px" }}>
                        <div
                          className="font-weight-bold text-dark"
                          style={{ fontSize: "13px" }}
                        >
                          {req.challenge?.c_name || "Unknown Challenge"}
                        </div>
                        <div
                          className="d-flex align-items-center mt-1"
                          style={{ gap: "6px" }}
                        >
                          <Badge color="info" pill style={{ fontSize: "10px" }}>
                            {req.challenge?.c_type || "N/A"}
                          </Badge>
                          <Badge
                            color="light"
                            style={{ fontSize: "10px", color: "#525f7f" }}
                          >
                            {req.challenge?.c_category || "N/A"}
                          </Badge>
                        </div>
                        {req.challenge?.c_sponsor && (
                          <div
                            className="text-muted"
                            style={{ fontSize: "11px", marginTop: "2px" }}
                          >
                            <i
                              className="fas fa-building mr-1"
                              style={{ fontSize: "9px" }}
                            />
                            {req.challenge.c_sponsor}
                          </div>
                        )}
                      </td>
                      <td style={{ padding: "14px 16px" }}>
                        <Badge
                          color={
                            req.status === "approved"
                              ? "success"
                              : req.status === "rejected"
                                ? "danger"
                                : "warning"
                          }
                          pill
                          style={{
                            fontSize: "11px",
                            padding: "6px 14px",
                            fontWeight: "600",
                          }}
                        >
                          <i
                            className={`fas ${req.status === "approved" ? "fa-check-circle" : req.status === "rejected" ? "fa-times-circle" : "fa-clock"} mr-1`}
                          />
                          {req.status
                            ? req.status.charAt(0).toUpperCase() +
                              req.status.slice(1)
                            : "Pending"}
                        </Badge>
                      </td>
                      <td
                        style={{
                          padding: "14px 16px",
                          fontSize: "13px",
                          color: "#525f7f",
                        }}
                      >
                        {req.created_at
                          ? new Date(req.created_at).toLocaleDateString(
                              "en-US",
                              {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                              },
                            )
                          : "N/A"}
                        <div
                          className="text-muted"
                          style={{ fontSize: "11px" }}
                        >
                          {req.created_at
                            ? new Date(req.created_at).toLocaleTimeString(
                                "en-US",
                                {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                },
                              )
                            : ""}
                        </div>
                      </td>
                      <td style={{ padding: "14px 20px", textAlign: "center" }}>
                        {req.status === "pending" ? (
                          <div
                            className="d-flex justify-content-center"
                            style={{ gap: "8px" }}
                          >
                            <Button
                              color="success"
                              size="sm"
                              disabled={
                                actionLoading === `${req._id}-approved` ||
                                actionLoading === `${req._id}-rejected`
                              }
                              onClick={() =>
                                handleJoinRequestAction(req._id, "approved")
                              }
                              style={{
                                borderRadius: "8px",
                                fontSize: "12px",
                                padding: "6px 14px",
                                fontWeight: "600",
                                boxShadow: "0 2px 6px rgba(45,206,137,0.3)",
                              }}
                            >
                              {actionLoading === `${req._id}-approved` ? (
                                <Spinner size="sm" />
                              ) : (
                                <>
                                  <i className="fas fa-check mr-1" /> Approve
                                </>
                              )}
                            </Button>
                            <Button
                              color="danger"
                              size="sm"
                              disabled={
                                actionLoading === `${req._id}-approved` ||
                                actionLoading === `${req._id}-rejected`
                              }
                              onClick={() =>
                                handleJoinRequestAction(req._id, "rejected")
                              }
                              style={{
                                borderRadius: "8px",
                                fontSize: "12px",
                                padding: "6px 14px",
                                fontWeight: "600",
                                boxShadow: "0 2px 6px rgba(245,54,92,0.3)",
                              }}
                            >
                              {actionLoading === `${req._id}-rejected` ? (
                                <Spinner size="sm" />
                              ) : (
                                <>
                                  <i className="fas fa-times mr-1" /> Reject
                                </>
                              )}
                            </Button>
                          </div>
                        ) : (
                          <span
                            className="text-muted"
                            style={{ fontSize: "12px", fontStyle: "italic" }}
                          >
                            <i className="fas fa-lock mr-1" />{" "}
                            {req.status === "approved"
                              ? "Approved"
                              : "Rejected"}
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <div className="text-center py-5">
              <i
                className="fas fa-inbox fa-3x text-muted mb-3 d-block"
                style={{ opacity: 0.4 }}
              />
              <h5 className="text-muted font-weight-normal">
                No join requests found
              </h5>
              <p className="text-muted" style={{ fontSize: "13px" }}>
                There are no challenge join requests matching your filters.
              </p>
            </div>
          )}
        </ModalBody>
        {joinRequestsTotal > joinRequestsLimit && (
          <ModalFooter
            className="border-top bg-white d-flex justify-content-between align-items-center"
            style={{ borderRadius: "0 0 12px 12px" }}
          >
            <span className="text-muted small">
              Showing {(joinRequestsPage - 1) * joinRequestsLimit + 1} to{" "}
              {Math.min(
                joinRequestsPage * joinRequestsLimit,
                joinRequestsTotal,
              )}{" "}
              of {joinRequestsTotal}
            </span>
            <Pagination className="pagination mb-0" listClassName="mb-0">
              <PaginationItem disabled={joinRequestsPage <= 1}>
                <PaginationLink
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setJoinRequestsPage(joinRequestsPage - 1);
                  }}
                >
                  <i className="fas fa-angle-left" />
                </PaginationLink>
              </PaginationItem>
              {Array.from(
                { length: Math.ceil(joinRequestsTotal / joinRequestsLimit) },
                (_, i) => i + 1,
              )
                .filter(
                  (p) =>
                    p === 1 ||
                    p === Math.ceil(joinRequestsTotal / joinRequestsLimit) ||
                    Math.abs(p - joinRequestsPage) <= 2,
                )
                .map((p, idx, arr) => (
                  <React.Fragment key={p}>
                    {idx > 0 && arr[idx - 1] !== p - 1 && (
                      <PaginationItem disabled>
                        <PaginationLink>...</PaginationLink>
                      </PaginationItem>
                    )}
                    <PaginationItem active={p === joinRequestsPage}>
                      <PaginationLink
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setJoinRequestsPage(p);
                        }}
                      >
                        {p}
                      </PaginationLink>
                    </PaginationItem>
                  </React.Fragment>
                ))}
              <PaginationItem
                disabled={
                  joinRequestsPage >=
                  Math.ceil(joinRequestsTotal / joinRequestsLimit)
                }
              >
                <PaginationLink
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setJoinRequestsPage(joinRequestsPage + 1);
                  }}
                >
                  <i className="fas fa-angle-right" />
                </PaginationLink>
              </PaginationItem>
            </Pagination>
          </ModalFooter>
        )}
      </Modal>
      <Modal
        isOpen={submissionsModalOpen}
        toggle={handleCloseModal}
        size="xl"
        centered
        scrollable
      >
        <ModalHeader
          toggle={handleCloseModal}
          className="border-0 pb-0"
          style={{
            background: "linear-gradient(135deg, #11cdef 0%, #1171ef 100%)",
            borderRadius: "12px 12px 0 0",
            padding: "20px 24px",
          }}
        >
          <div className="d-flex align-items-center">
            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "10px",
                background: "rgba(255,255,255,0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "12px",
              }}
            >
              <i
                className="fas fa-gavel text-white"
                style={{ fontSize: "18px" }}
              />
            </div>
            <div
              className="d-flex flex-column justify-content-center"
              style={{
                minHeight: "50px",
              }}
            >
              <h5
                className="mb-1 font-weight-bold"
                style={{
                  color: "#fff",
                  lineHeight: "1.3",
                  fontSize: "18px",
                }}
              >
                Manage Judges & Submissions
              </h5>

              <small
                style={{
                  color: "rgba(255,255,255,0.85)",
                  fontSize: "13px",
                  fontWeight: "500",
                  lineHeight: "1.4",
                }}
              >
                Challenge: {selectedSubmission?.c_name || "Loading..."}
              </small>
            </div>
          </div>
        </ModalHeader>
        <ModalBody style={{ padding: "24px", background: "#f8f9fe" }}>
          {/* Submissions List */}
          <div className="mb-4">
            <h6 className="text-uppercase text-muted ls-1 mb-3">
              <i className="fas fa-upload mr-2" /> All Submissions (
              {allSubmissions.length})
            </h6>
            {submissionsLoading ? (
              <div className="text-center py-4">
                <Spinner color="primary" />
                <p className="text-muted mt-2">Loading submissions...</p>
              </div>
            ) : allSubmissions.length > 0 ? (
              <div className="table-responsive">
                <Table className="align-items-center table-flush" size="sm">
                  <thead className="thead-light">
                    <tr>
                      <th>Title</th>
                      <th>User</th>
                      <th>Status</th>
                      <th>Submitted On</th>
                      <th className="text-right">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allSubmissions.map((sub) => (
                      <tr key={sub._id}>
                        <td>
                          <div className="font-weight-bold">{sub.title}</div>
                          <div className="text-muted small mt-1">
                            <ReadMoreDescription
                              text={sub.description}
                              maxLength={50}
                            />
                          </div>
                        </td>
                        <td>
                          <div className="font-weight-bold">
                            {sub.user_id?.name || "User"}
                          </div>
                          <small className="text-muted">
                            {sub.user_id?.email}
                          </small>
                        </td>
                        <td>
                          <Badge
                            color={
                              sub.status === "approved"
                                ? "success"
                                : sub.status === "rejected"
                                  ? "danger"
                                  : "warning"
                            }
                          >
                            {sub.status || "Pending"}
                          </Badge>
                        </td>
                        <td>
                          <small>
                            {new Date(sub.created_at).toLocaleDateString()}
                          </small>
                        </td>
                        <td className="text-right">
                          <UncontrolledDropdown>
                            <DropdownToggle
                              size="sm"
                              color="light"
                              outline
                              caret
                            >
                              Actions
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem
                                onClick={() => {
                                  Swal.fire({
                                    title: "Submission Details",
                                    html: `
                <div style="text-align: left;">
                    <strong>Title:</strong> ${sub.title || "N/A"}<br/><br/>

                    <strong>User:</strong> ${
                      typeof sub.user_id === "object"
                        ? sub.user_id?.name
                        : sub.user_id
                    }<br/>

                    <strong>Email:</strong> ${
                      typeof sub.user_id === "object"
                        ? sub.user_id?.email
                        : "Not available"
                    }<br/><br/>

                    <strong>Description:</strong> ${
                      sub.description || "N/A"
                    }<br/><br/>

                    <strong>Submit Link:</strong> 
                    <a href="${sub.submit_link}" target="_blank">
                        ${sub.submit_link}
                    </a><br/><br/>
${
  sub.file_url
    ? `<strong>File:</strong> 
      <a 
    href="${sub.file_url?.startsWith("http") ? sub.file_url : `${IMAGE_BASE_URL}/user-media/${sub.file_url}`}"
    download
>
    Download Image
</a><br/><br/>`
    : ""
}
                    <strong>Status:</strong> ${sub.status || "N/A"}<br/>

                    <strong>Submitted:</strong> ${
                      sub.created_at
                        ? new Date(sub.created_at).toLocaleString()
                        : "N/A"
                    }
                </div>
            `,
                                    width: "600px",
                                    confirmButtonText: "Close",
                                  });
                                }}
                              >
                                <i className="fas fa-eye text-info mr-2" /> View
                                Details
                              </DropdownItem>
                              <DropdownItem divider />
                              <DropdownItem
                                onClick={() => {
                                  setCurrentScoringSubmission(sub);
                                  setShowScoreModal(true);
                                }}
                              >
                                <i className="fas fa-star text-warning mr-2" />{" "}
                                Rate & Score
                              </DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            ) : (
              <div className="text-center py-4 text-muted">
                <i className="fas fa-inbox fa-2x mb-2 d-block" />
                No submissions found for this challenge
              </div>
            )}
          </div>

          {/* Pagination */}
          {submissionsTotal > submissionsLimit && (
            <div className="d-flex justify-content-between align-items-center mt-3 pt-3 border-top">
              <small className="text-muted">
                Showing {(submissionsPage - 1) * submissionsLimit + 1} to{" "}
                {Math.min(submissionsPage * submissionsLimit, submissionsTotal)}{" "}
                of {submissionsTotal}
              </small>
              <Pagination className="mb-0">
                <PaginationItem disabled={submissionsPage <= 1}>
                  <PaginationLink
                    onClick={() => setSubmissionsPage((p) => p - 1)}
                  >
                    <i className="fas fa-angle-left" />
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem
                  disabled={
                    submissionsPage >=
                    Math.ceil(submissionsTotal / submissionsLimit)
                  }
                >
                  <PaginationLink
                    onClick={() => setSubmissionsPage((p) => p + 1)}
                  >
                    <i className="fas fa-angle-right" />
                  </PaginationLink>
                </PaginationItem>
              </Pagination>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      {/* Score Modal - Premium Redesign */}
      <style>{`
                .score-modal .modal-content {
                    border: none;
                    border-radius: 20px;
                    overflow: hidden;
                    box-shadow: 0 25px 60px rgba(94, 114, 228, 0.25);
                }
                .judge-slider {
                    -webkit-appearance: none;
                    appearance: none;
                    width: 100%;
                    height: 6px;
                    border-radius: 3px;
                    outline: none;
                    cursor: pointer;
                    transition: opacity 0.2s;
                }
                .judge-slider::-webkit-slider-thumb {
                    -webkit-appearance: none;
                    appearance: none;
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    background: #fff;
                    box-shadow: 0 2px 8px rgba(94,114,228,0.5);
                    border: 3px solid #5e72e4;
                    cursor: pointer;
                    transition: transform 0.15s;
                }
                .judge-slider::-webkit-slider-thumb:hover {
                    transform: scale(1.2);
                }
                .judge-slider::-moz-range-thumb {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    background: #fff;
                    box-shadow: 0 2px 8px rgba(94,114,228,0.5);
                    border: 3px solid #5e72e4;
                    cursor: pointer;
                }
                .criterion-card {
                    background: #fff;
                    border-radius: 14px;
                    padding: 18px 20px;
                    margin-bottom: 14px;
                    box-shadow: 0 2px 12px rgba(0,0,0,0.06);
                    border: 1px solid #f0f0f5;
                    transition: box-shadow 0.2s;
                }
                .criterion-card:hover {
                    box-shadow: 0 4px 20px rgba(94,114,228,0.13);
                }
                .score-pill {
                    min-width: 52px;
                    height: 32px;
                    border-radius: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 700;
                    font-size: 13px;
                    letter-spacing: 0.3px;
                }
            `}</style>
      <Modal
        isOpen={showScoreModal}
        toggle={() => {
          setShowScoreModal(false);
          setScoreData({ score: 0, feedback: "", status: "approved" });
          setCurrentScoringSubmission(null);
        }}
        centered
        size="sm"
        className="score-modal"
      >
        {/* Gradient Header */}
        <div
          style={{
            background: "linear-gradient(135deg, #5e72e4 0%, #825ee4 100%)",
            padding: "24px 28px 20px",
            position: "relative",
          }}
        >
          <button
            onClick={() => {
              setShowScoreModal(false);
              setScoreData({ score: 0, feedback: "", status: "approved" });
              setCurrentScoringSubmission(null);
            }}
            style={{
              position: "absolute",
              top: "16px",
              right: "20px",
              background: "rgba(255,255,255,0.2)",
              border: "none",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              color: "#fff",
              cursor: "pointer",
              fontSize: "16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            ×
          </button>
          <div className="d-flex align-items-center">
            <div
              style={{
                width: "48px",
                height: "48px",
                borderRadius: "14px",
                background: "rgba(255,255,255,0.2)",
                backdropFilter: "blur(4px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "16px",
                flexShrink: 0,
              }}
            >
              <i
                className="fas fa-gavel"
                style={{ fontSize: "20px", color: "#fff" }}
              />
            </div>
            <div>
              <h4
                className="mb-0 font-weight-bold"
                style={{ color: "#fff", fontSize: "1.25rem" }}
              >
                Judge Submission
              </h4>
              <p
                className="mb-0"
                style={{ color: "rgba(255,255,255,0.75)", fontSize: "13px" }}
              >
                {currentScoringSubmission?.title
                  ? `Scoring: ${currentScoringSubmission.title}`
                  : "Review & score the project"}
              </p>
            </div>
          </div>
        </div>

        <ModalBody style={{ background: "#f8f9fe", padding: "24px" }}>
          {/* Criterion Cards */}
          {[
            {
              key: "innovation",
              label: "Innovation",
              icon: "fa-lightbulb",
              color: "#5e72e4",
              bg: "rgba(94,114,228,0.1)",
            },
            {
              key: "feasibility",
              label: "Feasibility",
              icon: "fa-tools",
              color: "#2dce89",
              bg: "rgba(45,206,137,0.1)",
            },
            {
              key: "impact",
              label: "Impact",
              icon: "fa-chart-line",
              color: "#fb6340",
              bg: "rgba(251,99,64,0.1)",
            },
            {
              key: "presentation",
              label: "Presentation",
              icon: "fa-chalkboard-teacher",
              color: "#11cdef",
              bg: "rgba(17,205,239,0.1)",
            },
          ].map(({ key, label, icon, color, bg }) => {
            const val = scoreValues[key] || 0;
            const pct = val * 10;
            return (
              <div key={key} className="criterion-card">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div
                    className="d-flex align-items-center"
                    style={{ gap: "10px" }}
                  >
                    <div
                      style={{
                        width: "34px",
                        height: "34px",
                        borderRadius: "10px",
                        background: bg,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <i
                        className={`fas ${icon}`}
                        style={{ color, fontSize: "14px" }}
                      />
                    </div>
                    <span
                      className="font-weight-bold text-dark"
                      style={{ fontSize: "14px" }}
                    >
                      {label}
                    </span>
                  </div>
                  <div className="score-pill" style={{ background: bg, color }}>
                    {val}
                    <span
                      style={{
                        opacity: 0.6,
                        fontWeight: 500,
                        fontSize: "11px",
                      }}
                    >
                      /10
                    </span>
                  </div>
                </div>
                <input
                  type="range"
                  className="judge-slider"
                  min="0"
                  max="10"
                  step="1"
                  value={val}
                  onChange={(e) =>
                    setScoreValues({
                      ...scoreValues,
                      [key]: parseInt(e.target.value),
                    })
                  }
                  style={{
                    background: `linear-gradient(to right, ${color} 0%, ${color} ${pct}%, #e0e4f0 ${pct}%, #e0e4f0 100%)`,
                  }}
                />
                <div
                  className="d-flex justify-content-between mt-1"
                  style={{ fontSize: "11px", color: "#adb5bd" }}
                >
                  <span>Low</span>
                  <span>High</span>
                </div>
              </div>
            );
          })}

          {/* Total Score */}
          {(() => {
            const total = (
              ((scoreValues.innovation || 0) +
                (scoreValues.feasibility || 0) +
                (scoreValues.impact || 0) +
                (scoreValues.presentation || 0)) /
              4
            ).toFixed(1);
            const totalPct = (parseFloat(total) / 10) * 100;
            const scoreColor =
              parseFloat(total) >= 7
                ? "#2dce89"
                : parseFloat(total) >= 4
                  ? "#fb6340"
                  : "#f5365c";
            return (
              <div
                style={{
                  background:
                    "linear-gradient(135deg, #5e72e4 0%, #825ee4 100%)",
                  borderRadius: "16px",
                  padding: "20px 24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <div
                    style={{
                      color: "rgba(255,255,255,0.75)",
                      fontSize: "12px",
                      fontWeight: 600,
                      textTransform: "uppercase",
                      letterSpacing: "0.8px",
                    }}
                  >
                    Total Score
                  </div>
                  <div
                    style={{
                      color: "#fff",
                      fontSize: "13px",
                      marginTop: "2px",
                    }}
                  >
                    Average of all criteria
                  </div>
                </div>
                <div
                  style={{
                    background: "rgba(255,255,255,0.15)",
                    backdropFilter: "blur(4px)",
                    borderRadius: "12px",
                    padding: "10px 22px",
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      color: "#fff",
                      fontSize: "28px",
                      fontWeight: 800,
                      lineHeight: 1,
                    }}
                  >
                    {total}
                  </div>
                  <div
                    style={{ color: "rgba(255,255,255,0.7)", fontSize: "12px" }}
                  >
                    out of 10
                  </div>
                </div>
              </div>
            );
          })()}
        </ModalBody>

        <ModalFooter
          style={{
            background: "#fff",
            borderTop: "1px solid #f0f0f5",
            padding: "16px 24px",
            borderRadius: "0 0 20px 20px",
          }}
        >
          <Button
            color="light"
            onClick={() => {
              setShowScoreModal(false);
              setScoreData({ score: 0, feedback: "", status: "approved" });
              setCurrentScoringSubmission(null);
            }}
            style={{
              borderRadius: "10px",
              fontWeight: 600,
              border: "1px solid #e0e4f0",
              color: "#525f7f",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => submitScore()}
            disabled={scoreLoading}
            style={{
              background: "linear-gradient(135deg, #5e72e4 0%, #825ee4 100%)",
              border: "none",
              borderRadius: "10px",
              fontWeight: 700,
              padding: "10px 28px",
              boxShadow: "0 4px 15px rgba(94,114,228,0.35)",
              color: "#fff",
            }}
          >
            {scoreLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm mr-2"
                  role="status"
                  aria-hidden="true"
                />{" "}
                Submitting...
              </>
            ) : (
              <>
                <i className="fas fa-paper-plane mr-2" /> Submit Score
              </>
            )}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Idea Change Requests Modal */}
      {/* Idea Change Requests Modal */}
      <Modal
        isOpen={changesModalOpen}
        toggle={() => setChangesModalOpen(false)}
        size="xl"
        centered
        scrollable
      >
        <ModalHeader
          toggle={() => setChangesModalOpen(false)}
          className="border-0 pb-0"
          style={{
            background: "linear-gradient(135deg, #5e72e4 0%, #825ee4 100%)",
            borderRadius: "12px 12px 0 0",
            padding: "20px 24px",
          }}
        >
          <div className="d-flex align-items-center">
            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "10px",
                background: "rgba(255,255,255,0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "12px",
              }}
            >
              <i
                className="fas fa-edit text-white"
                style={{ fontSize: "18px" }}
              />
            </div>
            <div>
              <h5 className="mb-0 text-white font-weight-bold">
                Idea Change Requests (Live)
              </h5>
              <small className="text-white" style={{ opacity: 0.8 }}>
                Review and approve user requests to modify their ideas
              </small>
            </div>
          </div>
        </ModalHeader>

        <ModalBody style={{ padding: "24px", background: "#f8f9fe" }}>
          {changeRequestsLoading ? (
            <div className="text-center py-5">
              <Spinner
                color="primary"
                style={{ width: "3rem", height: "3rem" }}
              />
              <p className="text-muted mt-3">Loading change requests...</p>
            </div>
          ) : changeRequests.length > 0 ? (
            <>
              <div
                className="table-responsive"
                style={{
                  borderRadius: "12px",
                  overflowX: "auto",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.06)",
                }}
              >
                <Table
                  className="align-items-center mb-0"
                  style={{ background: "#fff" }}
                >
                  <thead
                    className="thead-light"
                    style={{
                      background: "#f8fafc",
                    }}
                  >
                    <tr>
                      <th
                        style={{
                          padding: "16px",
                          color: "#0f172a",
                          fontWeight: "700",
                          fontSize: "13px",
                        }}
                      >
                        Idea
                      </th>

                      <th
                        style={{
                          color: "#0f172a",
                          fontWeight: "700",
                          fontSize: "13px",
                        }}
                      >
                        User
                      </th>

                      <th
                        style={{
                          color: "#0f172a",
                          fontWeight: "700",
                          fontSize: "13px",
                        }}
                      >
                        Requested Changes
                      </th>

                      <th
                        style={{
                          color: "#0f172a",
                          fontWeight: "700",
                          fontSize: "13px",
                        }}
                      >
                        Status
                      </th>

                      <th
                        style={{
                          color: "#0f172a",
                          fontWeight: "700",
                          fontSize: "13px",
                        }}
                      >
                        Requested On
                      </th>

                      <th
                        className="text-center"
                        style={{
                          color: "#0f172a",
                          fontWeight: "700",
                          fontSize: "13px",
                        }}
                      >
                        Actions
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {changeRequests.map((req) => (
                      <tr key={req._id}>
                        {/* IDEA */}
                        <td style={{ padding: "16px" }}>
                          <div
                            style={{
                              color: "#111827",
                              fontWeight: "700",
                              fontSize: "14px",
                            }}
                          >
                            {req.original_data?.title || "Untitled Idea"}
                          </div>

                          <small
                            style={{
                              color: "#475569",
                              fontWeight: "500",
                            }}
                          >
                            Category:{" "}
                            {req.proposed_data?.category ||
                              req.original_data?.category ||
                              "N/A"}
                          </small>
                        </td>

                        {/* USER */}
                        <td>
                          <div
                            style={{
                              color: "#111827",
                              fontWeight: "600",
                            }}
                          >
                            <i className="fas fa-user-circle mr-1 text-primary" />

                            {typeof req.requested_by === "object"
                              ? req.requested_by?.name
                              : "Unknown User"}
                          </div>

                          <small
                            style={{
                              color: "#64748b",
                              fontWeight: "500",
                            }}
                          >
                            {typeof req.requested_by === "object"
                              ? req.requested_by?.email
                              : ""}
                          </small>
                        </td>

                        {/* REQUESTED CHANGES */}
                        <td style={{ minWidth: "250px" }}>
                          <div className="text-xs">
                            {req.proposed_data?.title !==
                              req.original_data?.title && (
                              <div className="mb-2">
                                <Badge
                                  color="info"
                                  pill
                                  className="mr-1"
                                  style={{
                                    fontSize: "9px",
                                    fontWeight: "700",
                                  }}
                                >
                                  Title
                                </Badge>

                                <div
                                  className="mt-1"
                                  style={{
                                    color: "#111827",
                                    fontWeight: "600",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "#64748b",
                                    }}
                                    className="mr-2"
                                  >
                                    <s>{req.original_data?.title}</s>
                                  </span>

                                  <span
                                    style={{
                                      color: "#059669",
                                      fontWeight: "700",
                                    }}
                                  >
                                    → {req.proposed_data?.title}
                                  </span>
                                </div>
                              </div>
                            )}

                            {req.proposed_data?.description !==
                              req.original_data?.description && (
                              <div className="mb-2">
                                <Badge
                                  color="warning"
                                  pill
                                  className="mr-1"
                                  style={{
                                    fontSize: "9px",
                                    color: "#111827",
                                    fontWeight: "700",
                                  }}
                                >
                                  Description
                                </Badge>

                                <div
                                  className="mt-1"
                                  style={{
                                    color: "#334155",
                                    fontWeight: "500",
                                    fontSize: "12px",
                                  }}
                                >
                                  <ReadMoreDescription
                                    text={req.proposed_data?.description}
                                    maxLength={80}
                                  />
                                </div>
                              </div>
                            )}

                            {req.proposed_data?.funding_needed !==
                              req.original_data?.funding_needed && (
                              <div className="mb-1">
                                <Badge
                                  color="success"
                                  pill
                                  className="mr-1"
                                  style={{
                                    fontSize: "9px",
                                    fontWeight: "700",
                                  }}
                                >
                                  Funding
                                </Badge>

                                <span
                                  style={{
                                    color: "#64748b",
                                    fontWeight: "500",
                                  }}
                                  className="mr-2"
                                >
                                  <s>${req.original_data?.funding_needed}</s>
                                </span>

                                <span
                                  style={{
                                    color: "#059669",
                                    fontWeight: "700",
                                  }}
                                >
                                  → ${req.proposed_data?.funding_needed}
                                </span>
                              </div>
                            )}

                            {req.proposed_data?.skills_needed &&
                              req.proposed_data.skills_needed.length > 0 && (
                                <div className="mt-1">
                                  <Badge
                                    color="primary"
                                    pill
                                    className="mr-1"
                                    style={{
                                      fontSize: "9px",
                                      fontWeight: "700",
                                    }}
                                  >
                                    Skills
                                  </Badge>

                                  <div className="d-flex flex-wrap gap-1 mt-1">
                                    {req.proposed_data.skills_needed
                                      .slice(0, 3)
                                      .map((skill, idx) => (
                                        <span
                                          key={idx}
                                          style={{
                                            background: "#e2e8f0",
                                            color: "#1e293b",
                                            fontWeight: "700",
                                            padding: "3px 8px",
                                            borderRadius: "6px",
                                            fontSize: "10px",
                                            whiteSpace: "normal",
                                            wordBreak: "break-all",
                                            overflowWrap: "anywhere",
                                          }}
                                        >
                                          {skill}
                                        </span>
                                      ))}

                                    {req.proposed_data.skills_needed.length >
                                      3 && (
                                      <span
                                        style={{
                                          color: "#475569",
                                          fontSize: "10px",
                                          fontWeight: "600",
                                        }}
                                      >
                                        +
                                        {req.proposed_data.skills_needed
                                          .length - 3}{" "}
                                        more
                                      </span>
                                    )}
                                  </div>
                                </div>
                              )}
                          </div>
                        </td>

                        {/* STATUS */}
                        <td>
                          <Badge
                            pill
                            style={{
                              fontSize: "11px",
                              padding: "4px 12px",
                              fontWeight: "700",

                              color:
                                req.status === "approved"
                                  ? "#15803d"
                                  : req.status === "rejected"
                                    ? "#dc2626"
                                    : "#b45309",

                              backgroundColor:
                                req.status === "approved"
                                  ? "#d1fae5"
                                  : req.status === "rejected"
                                    ? "#fee2e2"
                                    : "#fef3c7",

                              border: "1px solid #e2e8f0",
                            }}
                          >
                            <i
                              className={`fas ${
                                req.status === "approved"
                                  ? "fa-check-circle"
                                  : req.status === "rejected"
                                    ? "fa-times-circle"
                                    : "fa-clock"
                              } mr-1`}
                            />

                            {(req.status || "pending").toUpperCase()}
                          </Badge>

                          {req.reviewed_at && (
                            <div
                              style={{
                                fontSize: "10px",
                                color: "#475569",
                                fontWeight: "600",
                                marginTop: "5px",
                              }}
                            >
                              Reviewed:{" "}
                              {new Date(req.reviewed_at).toLocaleDateString()}
                            </div>
                          )}
                        </td>

                        {/* REQUESTED ON */}
                        <td>
                          <small
                            style={{
                              color: "#334155",
                              fontWeight: "600",
                            }}
                          >
                            {req.createdAt
                              ? new Date(req.createdAt).toLocaleDateString(
                                  "en-US",
                                  {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                  },
                                )
                              : "N/A"}
                          </small>

                          <div
                            style={{
                              fontSize: "10px",
                              color: "#64748b",
                              fontWeight: "500",
                            }}
                          >
                            {req.createdAt
                              ? new Date(req.createdAt).toLocaleTimeString()
                              : ""}
                          </div>
                        </td>

                        {/* ACTIONS */}
                        <td className="text-center">
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ gap: "8px" }}
                          >
                            <Button
                              color="info"
                              size="sm"
                              style={{
                                borderRadius: "8px",
                                fontSize: "11px",
                                padding: "4px 12px",
                                fontWeight: "700",
                              }}
                              onClick={() => handleViewChangeRequest(req)}
                            >
                              <i className="fas fa-eye mr-1" />
                              View
                            </Button>

                            {req.status === "pending" ? (
                              <>
                                <Button
                                  color="success"
                                  size="sm"
                                  style={{
                                    borderRadius: "8px",
                                    fontSize: "11px",
                                    padding: "4px 12px",
                                    fontWeight: "700",
                                  }}
                                  onClick={() =>
                                    handleChangeRequestAction(
                                      req._id,
                                      "approved",
                                    )
                                  }
                                  disabled={changeRequestsLoading}
                                >
                                  <i className="fas fa-check mr-1" />
                                  Approve
                                </Button>

                                <Button
                                  color="danger"
                                  size="sm"
                                  style={{
                                    borderRadius: "8px",
                                    fontSize: "11px",
                                    padding: "4px 12px",
                                    fontWeight: "700",
                                  }}
                                  onClick={() =>
                                    handleChangeRequestAction(
                                      req._id,
                                      "rejected",
                                    )
                                  }
                                  disabled={changeRequestsLoading}
                                >
                                  <i className="fas fa-times mr-1" />
                                  Reject
                                </Button>
                              </>
                            ) : (
                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "700",
                                  color:
                                    req.status === "approved"
                                      ? "#15803d"
                                      : "#dc2626",
                                }}
                              >
                                <i
                                  className={`fas ${
                                    req.status === "approved"
                                      ? "fa-check-circle"
                                      : "fa-times-circle"
                                  } mr-1`}
                                />

                                {req.status === "approved"
                                  ? "Approved"
                                  : "Rejected"}
                              </span>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

              {/* Pagination for Change Requests */}
              {changeRequestsTotal > changeRequestsLimit && (
                <div className="d-flex justify-content-between align-items-center mt-4 pt-3 border-top">
                  <small className="text-muted">
                    Showing {(changeRequestsPage - 1) * changeRequestsLimit + 1}{" "}
                    to{" "}
                    {Math.min(
                      changeRequestsPage * changeRequestsLimit,
                      changeRequestsTotal,
                    )}{" "}
                    of {changeRequestsTotal}
                  </small>
                  <Pagination className="mb-0">
                    <PaginationItem disabled={changeRequestsPage <= 1}>
                      <PaginationLink
                        onClick={() => setChangeRequestsPage((p) => p - 1)}
                      >
                        <i className="fas fa-angle-left" />
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem
                      disabled={
                        changeRequestsPage >=
                        Math.ceil(changeRequestsTotal / changeRequestsLimit)
                      }
                    >
                      <PaginationLink
                        onClick={() => setChangeRequestsPage((p) => p + 1)}
                      >
                        <i className="fas fa-angle-right" />
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
                </div>
              )}
            </>
          ) : (
            <div className="text-center py-5">
              <i
                className="fas fa-inbox fa-3x text-muted mb-3 d-block"
                style={{ opacity: 0.4 }}
              />
              <h5 className="text-muted font-weight-normal">
                No change requests found
              </h5>
              <p className="text-muted" style={{ fontSize: "13px" }}>
                There are no pending idea change requests at the moment.
              </p>
            </div>
          )}
        </ModalBody>

        {/* View Change Request Modal */}
        <Modal
          isOpen={viewChangeRequestModal}
          toggle={() => setViewChangeRequestModal(false)}
          size="lg"
        >
          <ModalHeader
            className="border-0 pb-3"
            toggle={() => setViewChangeRequestModal(false)}
            cssModule={{ "modal-title": "w-100" }}
            style={{
              background: "linear-gradient(135deg, #11cdef 0%, #1171ef 100%)",
              borderRadius: "10px 10px 0 0",
              color: "#fff",
            }}
          >
            <div className="d-flex align-items-center">
              <div
                style={{
                  background: "rgba(255,255,255,0.2)",
                  borderRadius: "8px",
                  padding: "6px 10px",
                  marginRight: "12px",
                }}
              >
                <i className="fas fa-code-branch text-white" />
              </div>
              <h5 className="mb-0 text-white font-weight-bold">
                Change Request Details
              </h5>
            </div>
          </ModalHeader>
          <ModalBody style={{ background: "#f8f9fe" }}>
            {selectedChangeRequest && (
              <>
                <div className="row">
                  <div className="col-md-6">
                    <div className="card shadow-sm mb-3">
                      <div className="card-header bg-white border-0">
                        <h6 className="mb-0">
                          <i className="fas fa-database text-secondary mr-2" />
                          Original Data
                        </h6>
                      </div>
                      <div className="card-body">
                        <table
                          className="table table-sm table-borderless"
                          style={{
                            tableLayout: "fixed",
                            width: "100%",
                            wordWrap: "break-word",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                                className="text-muted"
                                style={{ width: "35%" }}
                              >
                                Title:
                              </td>
                              <td
                                className="font-weight-medium"
                                style={{
                                  wordBreak: "break-word",
                                  overflowWrap: "break-word",
                                }}
                              >
                                {selectedChangeRequest.original_data?.title ||
                                  "—"}
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="text-muted"
                                style={{ width: "35%" }}
                              >
                                Description:
                              </td>
                              <td
                                className="small"
                                style={{
                                  wordBreak: "break-word",
                                  overflowWrap: "break-word",
                                  whiteSpace: "pre-wrap",
                                }}
                              >
                                <ReadMoreDescription
                                  text={
                                    selectedChangeRequest.original_data
                                      ?.description || "—"
                                  }
                                  maxLength={100}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td className="text-muted">Category:</td>
                              <td>
                                {selectedChangeRequest.original_data
                                  ?.category || "—"}
                              </td>
                            </tr>
                            <tr>
                              <td className="text-muted">Funding Needed:</td>
                              <td>
                                $
                                {selectedChangeRequest.original_data
                                  ?.funding_needed || "0"}
                              </td>
                            </tr>
                            <tr>
                              <td className="text-muted">Skills Needed:</td>
                              <td>
                                {selectedChangeRequest.original_data
                                  ?.skills_needed?.length > 0 ? (
                                  <div className="d-flex flex-wrap gap-1">
                                    {selectedChangeRequest.original_data.skills_needed.map(
                                      (skill, idx) => (
                                        <span
                                          key={idx}
                                          className="badge mr-1 mb-1"
                                          style={{
                                            backgroundColor: "#e2e8f0",
                                            color: "#475569",
                                            fontWeight: 600,
                                            whiteSpace: "normal",
                                            wordBreak: "break-word",
                                            overflowWrap: "anywhere",
                                          }}
                                        >
                                          {skill}
                                        </span>
                                      ),
                                    )}
                                  </div>
                                ) : (
                                  "—"
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="card shadow-sm mb-3">
                      <div className="card-header bg-white border-0">
                        <h6 className="mb-0">
                          <i className="fas fa-edit text-info mr-2" />
                          Proposed Data
                        </h6>
                      </div>
                      <div className="card-body">
                        <table
                          className="table table-sm table-borderless"
                          style={{
                            tableLayout: "fixed",
                            width: "100%",
                            wordWrap: "break-word",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                                className="text-muted"
                                style={{
                                  width: "35%",
                                  background:
                                    selectedChangeRequest.proposed_data
                                      ?.title !==
                                    selectedChangeRequest.original_data?.title
                                      ? "#fff3cd"
                                      : "transparent",
                                }}
                              >
                                Title:
                                {selectedChangeRequest.proposed_data?.title !==
                                  selectedChangeRequest.original_data
                                    ?.title && (
                                  <i className="fas fa-arrow-right ml-1 text-warning" />
                                )}
                              </td>
                              <td
                                className={`font-weight-medium ${selectedChangeRequest.proposed_data?.title !== selectedChangeRequest.original_data?.title ? "text-success" : ""}`}
                                style={{
                                  wordBreak: "break-word",
                                  overflowWrap: "break-word",
                                }}
                              >
                                {selectedChangeRequest.proposed_data?.title ||
                                  "—"}
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="text-muted"
                                style={{
                                  width: "35%",
                                  background:
                                    selectedChangeRequest.proposed_data
                                      ?.description !==
                                    selectedChangeRequest.original_data
                                      ?.description
                                      ? "#fff3cd"
                                      : "transparent",
                                }}
                              >
                                Description:
                                {selectedChangeRequest.proposed_data
                                  ?.description !==
                                  selectedChangeRequest.original_data
                                    ?.description && (
                                  <i className="fas fa-arrow-right ml-1 text-warning" />
                                )}
                              </td>
                              <td
                                className={`small ${selectedChangeRequest.proposed_data?.description !== selectedChangeRequest.original_data?.description ? "text-success" : ""}`}
                                style={{
                                  wordBreak: "break-word",
                                  overflowWrap: "break-word",
                                  whiteSpace: "pre-wrap",
                                }}
                              >
                                <ReadMoreDescription
                                  text={
                                    selectedChangeRequest.proposed_data
                                      ?.description || "—"
                                  }
                                  maxLength={100}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="text-muted"
                                style={{
                                  background:
                                    selectedChangeRequest.proposed_data
                                      ?.category !==
                                    selectedChangeRequest.original_data
                                      ?.category
                                      ? "#fff3cd"
                                      : "transparent",
                                }}
                              >
                                Category:
                              </td>
                              <td
                                className={
                                  selectedChangeRequest.proposed_data
                                    ?.category !==
                                  selectedChangeRequest.original_data?.category
                                    ? "text-success font-weight-bold"
                                    : ""
                                }
                              >
                                {selectedChangeRequest.proposed_data
                                  ?.category || "—"}
                                {selectedChangeRequest.proposed_data
                                  ?.category !==
                                  selectedChangeRequest.original_data
                                    ?.category && (
                                  <span className="ml-2 text-muted small">
                                    <s>
                                      (was:{" "}
                                      {
                                        selectedChangeRequest.original_data
                                          ?.category
                                      }
                                      )
                                    </s>
                                  </span>
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="text-muted"
                                style={{
                                  background:
                                    selectedChangeRequest.proposed_data
                                      ?.funding_needed !==
                                    selectedChangeRequest.original_data
                                      ?.funding_needed
                                      ? "#fff3cd"
                                      : "transparent",
                                }}
                              >
                                Funding Needed:
                              </td>
                              <td
                                className={
                                  selectedChangeRequest.proposed_data
                                    ?.funding_needed !==
                                  selectedChangeRequest.original_data
                                    ?.funding_needed
                                    ? "text-success font-weight-bold"
                                    : ""
                                }
                              >
                                $
                                {selectedChangeRequest.proposed_data
                                  ?.funding_needed || "0"}
                                {selectedChangeRequest.proposed_data
                                  ?.funding_needed !==
                                  selectedChangeRequest.original_data
                                    ?.funding_needed && (
                                  <span className="ml-2 text-muted small">
                                    <s>
                                      (was: $
                                      {
                                        selectedChangeRequest.original_data
                                          ?.funding_needed
                                      }
                                      )
                                    </s>
                                  </span>
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="text-muted"
                                style={{
                                  background:
                                    JSON.stringify(
                                      selectedChangeRequest.proposed_data
                                        ?.skills_needed,
                                    ) !==
                                    JSON.stringify(
                                      selectedChangeRequest.original_data
                                        ?.skills_needed,
                                    )
                                      ? "#fff3cd"
                                      : "transparent",
                                }}
                              >
                                Skills Needed:
                              </td>
                              <td>
                                {selectedChangeRequest.proposed_data
                                  ?.skills_needed?.length > 0 ? (
                                  <div className="d-flex flex-wrap gap-1">
                                    {selectedChangeRequest.proposed_data.skills_needed.map(
                                      (skill, idx) => (
                                        <span
                                          key={idx}
                                          className="badge mr-1 mb-1"
                                          style={{
                                            backgroundColor: "#e0e7ff",
                                            color: "#4f46e5",
                                            fontWeight: 600,
                                            whiteSpace: "normal",
                                            wordBreak: "break-word",
                                            overflowWrap: "anywhere",
                                          }}
                                        >
                                          {skill}
                                        </span>
                                      ),
                                    )}
                                  </div>
                                ) : (
                                  "—"
                                )}
                                {JSON.stringify(
                                  selectedChangeRequest.proposed_data
                                    ?.skills_needed,
                                ) !==
                                  JSON.stringify(
                                    selectedChangeRequest.original_data
                                      ?.skills_needed,
                                  ) && (
                                  <div className="mt-2">
                                    <small className="text-muted">
                                      <s>
                                        Original:{" "}
                                        {selectedChangeRequest.original_data?.skills_needed?.join(
                                          ", ",
                                        ) || "—"}
                                      </s>
                                    </small>
                                  </div>
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card shadow-sm">
                  <div className="card-header bg-white border-0">
                    <h6 className="mb-0">
                      <i className="fas fa-info-circle text-primary mr-2" />
                      Request Information
                    </h6>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-2">
                          <small className="text-muted d-block">
                            Requested By:
                          </small>
                          <span>
                            {typeof selectedChangeRequest.requested_by ===
                            "object"
                              ? selectedChangeRequest.requested_by?.name
                              : selectedChangeRequest.requested_by ||
                                "Unknown User"}
                          </span>
                        </div>
                        <div className="mb-2">
                          <small className="text-muted d-block">
                            Requested On:
                          </small>
                          <span>
                            {new Date(
                              selectedChangeRequest.createdAt,
                            ).toLocaleString()}
                          </span>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-2">
                          <small className="text-muted d-block">Status:</small>
                          <Badge
                            color={
                              selectedChangeRequest.status === "approved"
                                ? "success"
                                : selectedChangeRequest.status === "rejected"
                                  ? "danger"
                                  : "warning"
                            }
                            pill
                          >
                            {selectedChangeRequest.status || "pending"}
                          </Badge>
                        </div>
                        {selectedChangeRequest.reviewed_at && (
                          <div className="mb-2">
                            <small className="text-muted d-block">
                              Reviewed On:
                            </small>
                            <span>
                              {new Date(
                                selectedChangeRequest.reviewed_at,
                              ).toLocaleString()}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => setViewChangeRequestModal(false)}
            >
              Close
            </Button>
            {selectedChangeRequest?.status === "pending" && (
              <>
                <Button
                  color="success"
                  onClick={() => {
                    handleChangeRequestAction(
                      selectedChangeRequest._id,
                      "approved",
                    );
                    setViewChangeRequestModal(false);
                  }}
                  disabled={changeRequestsLoading}
                >
                  <i className="fas fa-check mr-1" /> Approve Request
                </Button>
                <Button
                  color="danger"
                  onClick={() => {
                    handleChangeRequestAction(
                      selectedChangeRequest._id,
                      "rejected",
                    );
                    setViewChangeRequestModal(false);
                  }}
                  disabled={changeRequestsLoading}
                >
                  <i className="fas fa-times mr-1" /> Reject Request
                </Button>
              </>
            )}
          </ModalFooter>
        </Modal>
        <ModalFooter className="border-top bg-white">
          <Button
            color="secondary"
            outline
            onClick={() => setChangesModalOpen(false)}
            style={{ borderRadius: "8px" }}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Community;
